import type * as Enums from './enums'

const OPENAPI_SPEC_CHECKSUM = '1079507b80f645b300e92c2742562cab'


export namespace BackendAPITypes {

// MODELS
export type Money = {
  signed_amount: number,
  currency: Enums.CurrencyEnum | null,
}


// REQ        
export type BACKENDPreHandleAsyncApiV1WebhookSendgridInboundParsePostRequestBody = {
  to: string,
  attachments: null | number,
  "attachment-info": null | string,
}



export type BACKENDPreHandleSyncApiV1AccessControlUserSendEmailVerificationEmailPostRequestBody = object



export type BACKENDPreHandleSyncApiV1AdminBusinessUpdateFlagPostRequestBody = {
  business_id: string,
  name: string,
  value: boolean,
}



export type BACKENDPreHandleSyncApiV1AdminGetUserDetailsPostRequestBody = {
  user_id: string,
}



export type BACKENDPreHandleSyncApiV1AdminGrantBusinessAccessPostRequestBody = {
  user_id: string,
  business_id: string,
  role: string,
}



export type BACKENDPreHandleSyncApiV1AdminInsightsCreateInsightPostRequestBody = {
  type: Enums.InsightTypeEnum,
  business_id: string,
  message: string,
}



export type BACKENDPreHandleSyncApiV1AdminPartnerDemoConfigurePostRequestBody = {
  name: string,
  tagline: string,
  address: string,
  email: string,
  phone_number: string,
  primary_color: string,
  full_logo_url: string,
  icon_logo_url: string,
  website_url: string,
}



export type BACKENDPreHandleSyncApiV1AdminRevokeBusinessAccessPostRequestBody = {
  user_id: string,
  business_id: string,
}



export type BACKENDPreHandleSyncApiV1BankAccountAddCreditCardPostRequestBody = {
  name: string,
  credit_card_number_prefix: string,
  credit_card_number_suffix: string,
  institution_name: string,
  credit_card_prefix_is_placeholder: boolean,
}



export type BACKENDPreHandleSyncApiV1BankAccountAddSavingsAccountPostRequestBody = {
  iban: string,
  owner_name: string,
  balance_cents: number,
  institution_name: string,
}



export type BACKENDPreHandleSyncApiV1BusinessInvoiceGenerateFromPromptPostRequestBody = {
  prompt: string,
}



export type BACKENDPreHandleSyncApiV1BusinessMarkConnectionCompletePostRequestBody = {
  ref: string,
  proxy_connection_id: string,
}



export type BACKENDPreHandleSyncApiV1CategorizationEngineExcludeTransactionFromMatchingPostRequestBody = {
  transaction_id: string,
  feedback: string,
  general_ledger_account_id: null | string,
  vat_code: Enums.VatCode | null,
  direction: Enums.DocumentDirection | null,
  subledger_id: null | string,
}



export type BACKENDPreHandleSyncApiV1CategorizationEngineRecategorizeTransactionPostRequestBody = {
  transaction_id: string,
  feedback: string,
  general_ledger_account_id: null | string,
  subledger_id: null | string,
}



export type BACKENDPreHandleSyncApiV1CategorizationEngineUndoBookAwayPostRequestBody = {
  transaction_id: string,
}



export type BACKENDPreHandleSyncApiV1CatestialBulkCategorizeTransactionsPostRequestBody = {
  transaction_ids: string[],
  general_ledger_account_id: null | string,
}



export type BACKENDPreHandleSyncApiV1CatestialCategorizeTransactionsPostRequestBody = object



export type BACKENDPreHandleSyncApiV1CronProcessInsightsPostRequestBody = {
  business_id_filter: null | string,
}



export type BACKENDPreHandleSyncApiV1CronTriggerReconciliationPostRequestBody = {
  business_id_filter: null | string,
}



export type BACKENDPreHandleSyncApiV1DocumentCollectionShareFilesPostRequestBody = {
  files: string[],
  document_category: null | string,
  shared_via: null | string,
  business_id_override: null | string,
  suggested_match_transaction_id: null | string,
  suggested_match_direction: null | string,
  upload_batch_id: null | string,
}



export type BACKENDPreHandleSyncApiV1EntrepreneurApproveVatDeclarationPostRequestBody = {
  request_id: string,
}



export type BACKENDPreHandleSyncApiV1EntrepreneurCancelDraftMatchPostRequestBody = {
  draft_match_id: string,
}



export type BACKENDPreHandleSyncApiV1EntrepreneurCreateBusinessPostRequestBody = {
  name: string,
  legal_entity_type: Enums.LegalEntityType,
  registration_number: string,
  fte_amount: number,
  industry: string,
  description: string,
}



export type BACKENDPreHandleSyncApiV1EntrepreneurDocumentsReportIncorrectPostRequestBody = {
  document_id: string,
}



export type BACKENDPreHandleSyncApiV1EntrepreneurMarkTransactionAsPrivatePostRequestBody = {
  transaction_id: string,
}



export type BACKENDPreHandleSyncApiV1EntrepreneurRejectVatDeclarationPostRequestBody = {
  request_id: string,
  reason: string,
}



export type BACKENDPreHandleSyncApiV1InitiateBankConnectionPostRequestBody = {
  bank_id: string,
  bank_account_id: null | string,
}



export type BACKENDPreHandleSyncApiV1InsightsMarkInsightsReadPostRequestBody = {
  insight_ids: string[],
}



export type BACKENDPreHandleSyncApiV1ManualReprocessTransactionForBusinessPostRequestBody = {
  business_id: string,
}



export type BACKENDPreHandleSyncApiV1ManualReprocessTransactionPostRequestBody = {
  transaction_id: string,
  business_id: string,
}



export type BACKENDPreHandleSyncApiV1MarkBankAsConnectedPostRequestBody = object



export type BACKENDPreHandleSyncApiV1MarkBankConnectionAsFailedPostRequestBody = object



export type BACKENDPreHandleSyncApiV1MeBusinessArchiveCatalogueItemPostRequestBody = {
  item_id: string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessArchiveCustomerPostRequestBody = {
  id: string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessChangeCatalogueItemPostRequestBody = {
  item_id: string,
  name: string,
  unit_price_net: BackendAPITypes.Money,
  unit: Enums.Unit,
  vat_rate_percentage: number,
  vat_category: Enums.VATCategory,
}



export type BACKENDPreHandleSyncApiV1MeBusinessChangeCustomerPostRequestBody = {
  company_name: string,
  address_extra_line: null | string,
  address: {
    street: string,
    house_number: string,
    postal_code: string,
    city: string,
    country: string,
  },
  email: null | string,
  fixed_cc_email: null | string,
  phone_number: null | string,
  vat_number: null | string,
  default_payment_term_days: null | number,
  id: string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessChangeRecurringSalesInvoicePostRequestBody = {
  series_id: string,
  cadence: Enums.RecurringCadence | null,
  description: null | string,
  payment_term: Enums.PaymentTerm | null,
  auto_send: boolean | null,
}



export type BACKENDPreHandleSyncApiV1MeBusinessChangeSalesInvoiceDraftPostRequestBody = {
  customer: {
    name: string,
    address: {
      street_name: string,
      house_number: string,
      city_name: string,
      postal_code: string,
      country: Enums.Country,
    },
    customer_id: null | string,
    email: null | string,
    cc_email: null | string,
    vat_number: null | string,
    address_extra_line: null | string,
  },
  invoice_date: string,
  payment_term: Enums.PaymentTerm,
  bank_account_id: string,
  lines: {
    description: string,
    quantity: number | string,
    unit: Enums.SalesInvoiceLineUnit,
    unit_price_net: object,
    vat_category: Enums.VATCategory,
    vat_percentage: null | number,
    catalogue_item_id: null | string,
    save_to_catalogue: boolean,
    service_start_date: null | string,
    service_end_date: null | string,
  }[],
  fiscal_year: null | number,
  purchase_order_reference: null | string,
  customer_specific_reference: null | string,
  fixed_footer_text: null | string,
  invoice_id: string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessChangeSalesInvoiceReminderSettingsPostRequestBody = {
  invoice_id: string,
  auto_reminder_enabled: boolean,
  reminder_interval_days: null | number,
}



export type BACKENDPreHandleSyncApiV1MeBusinessCreateCatalogueItemPostRequestBody = {
  name: string,
  unit_price_net: BackendAPITypes.Money,
  unit: Enums.Unit,
  vat_rate_percentage: number,
  vat_category: Enums.VATCategory,
}



export type BACKENDPreHandleSyncApiV1MeBusinessCreateCustomerPostRequestBody = {
  company_name: string,
  address_extra_line: null | string,
  address: {
    street: string,
    house_number: string,
    postal_code: string,
    city: string,
    country: string,
  },
  email: null | string,
  fixed_cc_email: null | string,
  phone_number: null | string,
  vat_number: null | string,
  default_payment_term_days: null | number,
}



export type BACKENDPreHandleSyncApiV1MeBusinessCreateRecurringSalesInvoicePostRequestBody = {
  customer_name: string,
  customer_id: string,
  bank_account_id: string,
  description: string,
  cadence: Enums.RecurringCadence,
  payment_term: Enums.PaymentTerm,
  first_invoice_on: string,
  auto_send: boolean,
  first_invoice_already_issued: boolean,
  lines: {
    description: string,
    quantity: number | string,
    unit: Enums.Unit,
    unit_price_net_cents: number,
    currency: Enums.CurrencyEnum,
    vat_rate_percentage: number,
    vat_category: Enums.VATCategory,
    catalogue_item_id: null | string,
  }[],
}



export type BACKENDPreHandleSyncApiV1MeBusinessCreateSalesInvoiceDraftPostRequestBody = {
  customer: {
    name: string,
    address: {
      street_name: string,
      house_number: string,
      city_name: string,
      postal_code: string,
      country: Enums.Country,
    },
    customer_id: null | string,
    email: null | string,
    cc_email: null | string,
    vat_number: null | string,
    address_extra_line: null | string,
  },
  invoice_date: string,
  payment_term: Enums.PaymentTerm,
  bank_account_id: string,
  lines: {
    description: string,
    quantity: number | string,
    unit: Enums.SalesInvoiceLineUnit,
    unit_price_net: object,
    vat_category: Enums.VATCategory,
    vat_percentage: null | number,
    catalogue_item_id: null | string,
    save_to_catalogue: boolean,
    service_start_date: null | string,
    service_end_date: null | string,
  }[],
  fiscal_year: null | number,
  purchase_order_reference: null | string,
  customer_specific_reference: null | string,
  fixed_footer_text: null | string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessCreditSalesInvoicePostRequestBody = {
  invoice_id: string,
  reason: null | string,
  lines: null | {
    original_line_id: string,
    quantity: number | string,
  }[],
}



export type BACKENDPreHandleSyncApiV1MeBusinessDeleteRecurringSalesInvoicePostRequestBody = {
  series_id: string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessDiscardSalesInvoiceDraftPostRequestBody = {
  invoice_id: string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessEditBaseBusinessInformationPostRequestBody = {
  name: null | string,
  website: null | string,
  vat_number: null | string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessGenerateSalesInvoicePostRequestBody = {
  relation_name: string,
  relation_address: {
    street_name: string,
    house_number: string,
    city_name: string,
    postal_code: string,
    country: Enums.Country,
  },
  invoice_date: string,
  amount_excluding_vat: object,
  bank_account_id: string,
  payment_term: Enums.PaymentTerm,
  vat_status: Enums.VATCategory,
  description: string,
  vat_percentage: null | number,
}



export type BACKENDPreHandleSyncApiV1MeBusinessIssueSalesInvoicePostRequestBody = {
  invoice_id: string,
  number_prefix: null | string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessPauseRecurringSalesInvoicePostRequestBody = {
  series_id: string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessPreviewSalesInvoicePostRequestBody = {
  customer: {
    name: string,
    address: {
      street_name: string,
      house_number: string,
      city_name: string,
      postal_code: string,
      country: Enums.Country,
    },
    customer_id: null | string,
    email: null | string,
    cc_email: null | string,
    vat_number: null | string,
    address_extra_line: null | string,
  },
  invoice_date: string,
  payment_term: Enums.PaymentTerm,
  bank_account_id: string,
  lines: {
    description: string,
    quantity: number | string,
    unit: Enums.SalesInvoiceLineUnit,
    unit_price_net: object,
    vat_category: Enums.VATCategory,
    vat_percentage: null | number,
    catalogue_item_id: null | string,
    save_to_catalogue: boolean,
    service_start_date: null | string,
    service_end_date: null | string,
  }[],
  fiscal_year: null | number,
  purchase_order_reference: null | string,
  customer_specific_reference: null | string,
  fixed_footer_text: null | string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessResendSalesInvoicePostRequestBody = {
  invoice_id: string,
  to_email: null | string,
  cc_email: null | string,
  bcc_email: null | string,
  reply_to_email: null | string,
  message: null | string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessResumeRecurringSalesInvoicePostRequestBody = {
  series_id: string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessSendSalesInvoicePostRequestBody = {
  invoice_id: string,
  to_email: null | string,
  cc_email: null | string,
  bcc_email: null | string,
  reply_to_email: null | string,
  message: null | string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessSendSalesInvoiceReminderPostRequestBody = {
  invoice_id: string,
  to_email: null | string,
  cc_email: null | string,
  bcc_email: null | string,
  reply_to_email: null | string,
  message: null | string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessUpdateSettingPostRequestBody = {
  setting_name: string,
  setting_value: any[] | boolean | number | object | string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessUploadLogoPostRequestBody = {
  file: string,
}



export type BACKENDPreHandleSyncApiV1MeSettingsChangeSettingPostRequestBody = {
  setting_name: string,
  setting_value: any[] | boolean | number | object | string,
}



export type BACKENDPreHandleSyncApiV1MeUpdateFlagPostRequestBody = {
  flag_name: string,
  flag_value: boolean,
}



export type BACKENDPreHandleSyncApiV1MeUserDeviceDeregisterDevicePostRequestBody = {
  device_id: string,
}



export type BACKENDPreHandleSyncApiV1MeUserDeviceRegisterDevicePostRequestBody = {
  device_id: string,
  push_token: string,
  platform: Enums.DevicePlatform,
  device_name: null | string,
}



export type BACKENDPreHandleSyncApiV1MeUserDeviceSendTestMessagePostRequestBody = null | {
  title: null | string,
  body: null | string,
  data: null | object,
}



export type BACKENDPreHandleSyncApiV1OnboardingAcceptInvitationPostRequestBody = {
  token: string,
  phone_number: string,
  first_name: string,
  last_name: string,
  password: string,
  repeat_password: string,
}



export type BACKENDPreHandleSyncApiV1OnboardingCreateSsoUserPostRequestBody = {
  email: string,
  phone_number: string,
  businesses: {
    registration_number: string,
    legal_entity_type: Enums.LegalEntityType,
    fte_amount: number,
    industry: string,
    business_description: string,
    business_name: string,
  }[],
  app_hostname: string,
  first_name: string,
  last_name: string,
}



export type BACKENDPreHandleSyncApiV1OnboardingCreateUserPostRequestBody = {
  email: string,
  phone_number: string,
  businesses: {
    registration_number: string,
    legal_entity_type: Enums.LegalEntityType,
    fte_amount: number,
    industry: string,
    business_description: string,
    business_name: string,
  }[],
  app_hostname: string,
  first_name: string,
  last_name: string,
  password: string,
  repeat_password: string,
}



export type BACKENDPreHandleSyncApiV1OpenBankingHandleCallbackPostRequestBody = {
  ref_id: string,
}



export type BACKENDPreHandleSyncApiV1OpenBankingReconnectBankAccountPostRequestBody = {
  ref_id: string,
}



export type BACKENDPreHandleSyncApiV1PartnerBookToGeneralLedgerAccountPostRequestBody = {
  client_business_id: string,
  general_ledger_account_id: string,
  targets: {
    kind: Enums.BookingTargetKind,
    resource_id: string,
    line_item_id: null | string,
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerBusinessEditBookingSuggestionsPostRequestBody = {
  business_id: string,
  booking_suggestions: string,
}



export type BACKENDPreHandleSyncApiV1PartnerBusinessEditDescriptionPostRequestBody = {
  business_id: string,
  description: string,
}



export type BACKENDPreHandleSyncApiV1PartnerBusinessUpdateSettingPostRequestBody = {
  business_id: string,
  setting_name: string,
  setting_value: any[] | boolean | number | object | string,
}



export type BACKENDPreHandleSyncApiV1PartnerClientBillDismissTodoPostRequestBody = {
  bill_id: string,
  todo_type: Enums.BillTodoType,
}



export type BACKENDPreHandleSyncApiV1PartnerClientDocumentDeletePostRequestBody = {
  document_id: string,
}



export type BACKENDPreHandleSyncApiV1PartnerClientDocumentEditDocumentFieldsPostRequestBody = {
  document_id: string,
  business_id: string,
  editable_bill: {
    document_category: Enums.DocumentCategory | null,
    document_direction: Enums.DocumentDirection | null,
    relation_name: null | string,
    relation_iban: null | string,
    relation_country: Enums.Country | null,
    vat_number: null | string,
    reference_identifier: null | string,
    payment_reference: null | string,
    normalized_date: null | string,
    normalized_time: null | string,
    normalized_due_date: null | string,
    total_amount_payable: BackendAPITypes.Money | null,
    vat_amount_overall: BackendAPITypes.Money | null,
    version: number,
    content_type: "bill" | "draft_bill" | null,
    is_credit_note: boolean,
    vat_reverse_charge_applied: boolean | null,
    is_vat_ignored: boolean,
    relation: null | {
      id: string,
      name: null | string,
    },
    line_items: {
      id: null | string,
      name_or_description: null | string,
      net_amount: BackendAPITypes.Money | null,
      vat_amount: BackendAPITypes.Money | null,
      total_amount: BackendAPITypes.Money | null,
      vat_rate_percentage: null | number,
      vat_id: null | string,
      is_vat_exempt: boolean | null,
      category_id: null | string,
      transitory_start_month: null | string,
      transitory_end_month: null | string,
      subledger_id: null | string,
      subledger: null | {
        id: string,
        name: string,
      },
      original_fx_net_amount: BackendAPITypes.Money | null,
      original_fx_vat_amount: BackendAPITypes.Money | null,
    }[],
  },
}



export type BACKENDPreHandleSyncApiV1PartnerClientDocumentValidateDocumentFieldsPostRequestBody = {
  document_id: string,
  business_id: string,
  editable_bill: {
    document_category: Enums.DocumentCategory | null,
    document_direction: Enums.DocumentDirection | null,
    relation_name: null | string,
    relation_iban: null | string,
    relation_country: Enums.Country | null,
    vat_number: null | string,
    reference_identifier: null | string,
    payment_reference: null | string,
    normalized_date: null | string,
    normalized_time: null | string,
    normalized_due_date: null | string,
    total_amount_payable: BackendAPITypes.Money | null,
    vat_amount_overall: BackendAPITypes.Money | null,
    version: number,
    content_type: "bill" | "draft_bill" | null,
    is_credit_note: boolean,
    vat_reverse_charge_applied: boolean | null,
    is_vat_ignored: boolean,
    relation: null | {
      id: string,
      name: null | string,
    },
    line_items: {
      id: null | string,
      name_or_description: null | string,
      net_amount: BackendAPITypes.Money | null,
      vat_amount: BackendAPITypes.Money | null,
      total_amount: BackendAPITypes.Money | null,
      vat_rate_percentage: null | number,
      vat_id: null | string,
      is_vat_exempt: boolean | null,
      category_id: null | string,
      transitory_start_month: null | string,
      transitory_end_month: null | string,
      subledger_id: null | string,
      subledger: null | {
        id: string,
        name: string,
      },
      original_fx_net_amount: BackendAPITypes.Money | null,
      original_fx_vat_amount: BackendAPITypes.Money | null,
    }[],
  },
}



export type BACKENDPreHandleSyncApiV1PartnerClientUnmatchAndDeleteBillPostRequestBody = {
  bill_id: string,
}



export type BACKENDPreHandleSyncApiV1PartnerCreateBusinessPostRequestBody = {
  name: string,
  legal_entity_type: Enums.LegalEntityType,
  registration_number: string,
  fte_amount: number,
  industry: string,
  description: string,
}



export type BACKENDPreHandleSyncApiV1PartnerCreateClientSubledgerPostRequestBody = {
  business_id: string,
  name: string,
}



export type BACKENDPreHandleSyncApiV1PartnerCreateFixedAssetPostRequestBody = {
  client_business_id: string,
  name: string,
  purchase_value_cents: number,
  residual_value_cents: number,
  economic_lifetime_months: number,
  balance_sheet_gl_account_id: string,
  profit_and_loss_gl_account_id: string,
  purchase_date: string,
  subledger_id: null | string,
  document_id: null | string,
  expected_bill_version: null | number,
}



export type BACKENDPreHandleSyncApiV1PartnerDeleteAutomationRulePostRequestBody = {
  id: string,
}



export type BACKENDPreHandleSyncApiV1PartnerDeleteManualBookingPostRequestBody = {
  client_business_id: string,
  booking_id: string,
}



export type BACKENDPreHandleSyncApiV1PartnerDocumentBillConvertToEuroPostRequestBody = {
  document_id: string,
}



export type BACKENDPreHandleSyncApiV1PartnerDocumentBillMarkAsPrivatelyPaidPostRequestBody = {
  document_id: string,
}



export type BACKENDPreHandleSyncApiV1PartnerDocumentBillUndoMarkAsPrivatelyPaidPostRequestBody = {
  document_id: string,
}



export type BACKENDPreHandleSyncApiV1PartnerDocumentToggleDocumentVatIgnoredPostRequestBody = {
  document_id: string,
}



export type BACKENDPreHandleSyncApiV1PartnerEditManualBookingPostRequestBody = {
  client_business_id: string,
  booking_id: string,
  booking_date: string,
  audit_reason: string,
  lines: {
    general_ledger_account_id: string,
    debit_amount_cents: number,
    credit_amount_cents: number,
    currency: string,
    description: null | string,
    id: null | string,
    subledger_id: null | string,
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerGetBankAccountBalanceAtDatePostRequestBody = {
  client_business_id: string,
  bank_account_id: string,
  target_date: string,
}



export type BACKENDPreHandleSyncApiV1PartnerGetBlacklistRulePreviewPostRequestBody = {
  rules: {
    operand: any[] | boolean | number | object | string,
    operator: Enums.RuleOperatorEnum,
    value_field_name: any[] | boolean | number | object | string,
    context: null | object,
  }[],
  client_business_id: null | string,
}



export type BACKENDPreHandleSyncApiV1PartnerGrantEntrepreneurAccessPostRequestBody = {
  business_id: string,
  application_user_id: string,
}



export type BACKENDPreHandleSyncApiV1PartnerInitiateBksDocumentImportPostRequestBody = {
  business_id: string,
  connection_id: string,
  business_id_in_bks: string,
  date_from: string,
  date_to: string,
  journal_ids: string[],
}



export type BACKENDPreHandleSyncApiV1PartnerInviteEntrepreneurPostRequestBody = {
  business_id: string,
  email: string,
}



export type BACKENDPreHandleSyncApiV1PartnerInviteTeammatePostRequestBody = {
  email: string,
}



export type BACKENDPreHandleSyncApiV1PartnerLinkFixedAssetToDocumentPostRequestBody = {
  client_business_id: string,
  document_id: string,
  fixed_asset_id: string,
  expected_bill_version: number,
}



export type BACKENDPreHandleSyncApiV1PartnerMakeManualBookingPostRequestBody = {
  client_business_id: string,
  booking_date: string,
  audit_reason: string,
  lines: {
    general_ledger_account_id: string,
    debit_amount_cents: number,
    credit_amount_cents: number,
    currency: string,
    description: null | string,
    id: null | string,
    subledger_id: null | string,
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollAdministrationsAssignMappingPostRequestBody = {
  administration_id: string,
  mapping_id: string,
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollConnectSessionPostRequestBody = {
  provider: Enums.PayrollProvider,
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollConnectionCompletePostRequestBody = {
  connection_id: string,
  external_connection_id: string,
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollConnectionReconnectCompletePostRequestBody = {
  connection_id: string,
  external_connection_id: string,
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollCreatePayrollGlMappingPostRequestBody = {
  name: string,
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingRulesPostRequestBody = {
  mapping_id: string,
  external_gl_account_code: string,
  external_gl_account_description: string,
  gl_account: string,
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingRulesRemovePostRequestBody = {
  mapping_id: string,
  external_gl_account_code: string,
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingsDeletePostRequestBody = {
  mapping_id: string,
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingsRenamePostRequestBody = {
  mapping_id: string,
  name: string,
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollImportsPostRequestBody = {
  administration_id: string,
  sync_from: string,
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollLinkPayrollAdministrationPostRequestBody = {
  client_business_id: string,
  employer_ref: string,
  administration_ref: string,
}



export type BACKENDPreHandleSyncApiV1PartnerProcessCreditCardSettlementPostRequestBody = {
  client_business_id: string,
  document_id: string,
  credit_card_account_id: string,
  settlement_transaction_id: string,
  statement_lines: {
    relation_name: string,
    description: string,
    amount_cents: number,
    booking_date: string,
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerRecategorizeDocumentPostRequestBody = {
  document_id: string,
  category: Enums.DocumentCategory,
}



export type BACKENDPreHandleSyncApiV1PartnerRefineVatIgnorePromptPostRequestBody = {
  partner_prompt: string,
}



export type BACKENDPreHandleSyncApiV1PartnerRefreshClientTrialBalanceCachePostRequestBody = {
  client_business_id: string,
}



export type BACKENDPreHandleSyncApiV1PartnerRenameClientSubledgerPostRequestBody = {
  business_id: string,
  subledger_id: string,
  name: string,
}



export type BACKENDPreHandleSyncApiV1PartnerRequestVatDeclarationApprovalPostRequestBody = {
  client_business_id: string,
  snapshot_id: string,
}



export type BACKENDPreHandleSyncApiV1PartnerSaveVatDeclarationSnapshotPostRequestBody = {
  client_business_id: string,
  date_from: string,
  date_to: string,
}



export type BACKENDPreHandleSyncApiV1PartnerTransactionsCategorizationChangePostRequestBody = {
  transaction_ids: string[],
}



export type BACKENDPreHandleSyncApiV1PartnerUnlinkFixedAssetFromDocumentPostRequestBody = {
  client_business_id: string,
  document_id: string,
  expected_bill_version: number,
}



export type BACKENDPreHandleSyncApiV1PartnerUnmatchedTransactionsCreateBacklistRulePostRequestBody = {
  rules: {
    operand: any[] | boolean | number | object | string,
    operator: Enums.RuleOperatorEnum,
    value_field_name: any[] | boolean | number | object | string,
    context: null | object,
  }[],
  general_ledger_account_id: null | string,
  vat_code: Enums.VatCode | null,
  vat_direction: Enums.DocumentDirection | null,
}



export type BACKENDPreHandleSyncApiV1PartnerWithdrawVatDeclarationApprovalRequestPostRequestBody = {
  client_business_id: string,
  request_id: string,
}



export type BACKENDPreHandleSyncApiV1PublicSendResetPasswordEmailPostRequestBody = {
  user_email: string,
}



export type BACKENDPreHandleSyncApiV1QuinnRateAnswerPostRequestBody = {
  run_id: string,
  rating: Enums.QuinnRatingEnum | null,
}



export type BACKENDPreHandleSyncApiV1QuinnSendMessagePostRequestBody = {
  content: string,
  chat_id: null | string,
  entrepreneur_business_id: null | string,
}



export type BACKENDPreHandleSyncApiV1QuinnStartRunPostRequestBody = {
  content: string,
  chat_id: null | string,
  entrepreneur_business_id: null | string,
  client_scope: Enums.QuinnChatScopeEnum,
}



export type BACKENDPreHandleSyncApiV1ReconciliationManuallyAddPartsMatchPostRequestBody = {
  transaction_ids: string[],
  match_id: string,
  bill_ids: string[],
}



export type BACKENDPreHandleSyncApiV1ReconciliationManuallyMatchPostRequestBody = {
  transaction_ids: string[],
  bill_ids: string[],
}



export type BACKENDPreHandleSyncApiV1ReconciliationManuallyUnmatchPostRequestBody = {
  match_id: string,
  transaction_ids: string[],
  bill_ids: string[],
}



export type BACKENDPreHandleSyncApiV1ReconciliationMarkMatchManuallyCompletedPostRequestBody = {
  match_id: string,
  difference_booking_date: null | string,
  difference_booking_reason: null | string,
  difference_booking_gla_id: null | string,
}



export type BACKENDPreHandleSyncApiV1RegisterCallbackPostRequestBody = {
  callback_url: string,
  called_back_on: string,
  parameters: {
    name: string,
    value: string,
  }[],
}



export type BACKENDPreHandleSyncApiV1StartImportJobPostRequestBody = {
  bank_connection_reference_id: string,
}



export type BACKENDPreHandleSyncApiV1TransactionsBookAsPrivatePostRequestBody = {
  transaction_id: string,
}



// RES
export type BACKENDPreHandleAsyncApiV1WebhookSendgridEventsPostResponseBody = {
  received: number,
  processed: number,
}



export type BACKENDPreHandleSyncApiV1AccessControlWhoAmIGetResponseBody = {
  id: string,
  first_name: string,
  last_name: string,
  email: string,
  role: string,
  businesses: string[],
  access: {
    business_id: string,
    business_name: string,
  }[],
  flags: object,
  business_settings: object,
  business_name: null | string,
  business: {
    partner_id: null | string,
  },
}



export type BACKENDPreHandleSyncApiV1AdminBusinessBankAccountsGetResponseBody = {
  account_id: string,
  iban: null | string,
  currency: string,
  owner_name: string,
  institution_name: string,
  balance: number,
  connected_on: string,
  refreshed_on: string,
  last_transaction_full_sync_on: null | string,
  institution_logo_url: null | string,
}[]



export type BACKENDPreHandleSyncApiV1AdminBusinessFlagsGetResponseBody = object



export type BACKENDPreHandleSyncApiV1AdminBusinessUploadedDocumentsGetResponseBody = {
  id: string,
  file_name: string,
  mime_type: string,
  document_type: Enums.DocumentType,
  size: number,
  created_at: string,
  updated_at: string,
  uploaded_by: string,
  business_id: string,
  document_direction: Enums.DocumentDirection | null,
  shared_via: Enums.SharingMethod | null,
  file_hash: null | string,
  is_duplicate: boolean,
  document_category: Enums.DocumentCategory | null,
  status: Enums.DocumentStatus,
  is_vat_ignored: boolean,
  needs_review: boolean,
  review_context: null | object,
  scanned_fields: null | {
    seller_name: string,
    total_amount_payable: BackendAPITypes.Money | null,
    other_dates: string[],
    vat_number: null | string,
    normalized_datetime: string,
    has_time: boolean,
    payment_term: null | number,
    normalized_due_date: null | string,
    is_vat_exempt: boolean | null,
    reference_identifier: null | string,
    payment_reference: null | string,
    seller_iban: null | string,
    buyer_name: null | string,
    buyer_iban: null | string,
    characteristics: null | string,
    time: null | string,
    date: null | string,
    vat_amount_overall: BackendAPITypes.Money | null,
    vat_reverse_charge_applied: boolean | null,
    is_credit_note: boolean | null,
    vat_breakdown_details: null | {
      vat_rate_percentage_applied: null | number,
      net_amount_at_this_rate: null | number,
      vat_amount_at_this_rate: null | number,
    }[],
    due_date: null | string,
  },
}[]



export type BACKENDPreHandleSyncApiV1AdminBusinessesGetResponseBody = {
  id: string,
  name: string,
  legal_entity_type: Enums.LegalEntityType,
  registration_number: string,
  fte_amount: number,
  industry: string,
  description: string,
  created_at: string,
  updated_at: string,
  website: null | string,
  vat_number: null | string,
  managed_by: null | string,
  document_collection_email_address_id: null | string,
  transaction_history_cutoff_date: {
    cutoff_date: string,
  },
  financial_service_integration_proxy_id: null | string,
}[]



export type BACKENDPreHandleSyncApiV1AdminGraphBusinessGetDailyBalanceWithForecastGetResponseBody = {
  date: string,
  day: null | string,
  balance: null | number,
  forecasted_balance: null | number,
}[]



export type BACKENDPreHandleSyncApiV1AdminInsightsCreateInsightPostResponseBody = {
  message: string,
  success: boolean,
}



export type BACKENDPreHandleSyncApiV1AdminPartnerDemoConfigurePostResponseBody = {
  success: boolean,
  message: string,
}



export type BACKENDPreHandleSyncApiV1AdminPartnerDemoGetResponseBody = {
  partner: {
    id: string,
    name: string,
    slug: string,
    tagline: string,
    address: string,
    email: string,
    phone_number: string,
    primary_color: string,
    full_logo_url: string,
    icon_logo_url: string,
    website_url: string,
    created_at: string,
    updated_at: string,
    business_id: string,
  },
}



export type BACKENDPreHandleSyncApiV1BankAccountAddCreditCardPostResponseBody = {
  message: string,
  success: boolean,
}



export type BACKENDPreHandleSyncApiV1BankAccountAddSavingsAccountPostResponseBody = {
  id: string,
  iban: null | string,
  owner_name: string,
  balance: number,
  account_type: string,
  institution_name: string,
}



export type BACKENDPreHandleSyncApiV1BankAccountMyBankAccountsGetResponseBody = {
  account_id: string,
  iban: null | string,
  currency: null | string,
  owner_name: string,
  institution_name: string,
  balance: number,
  connected_on: string,
  refreshed_on: string,
  last_transaction_full_sync_on: null | string,
  is_expired: boolean,
  expires_soon: boolean,
  institution_logo_url: string,
  account_type: string,
  credit_card_number_prefix: null | string,
  credit_card_number_suffix: null | string,
}[]



export type BACKENDPreHandleSyncApiV1BankLogoGetResponseBody = {
  logo_url: string,
  bank_id: string,
}



export type BACKENDPreHandleSyncApiV1BusinessBankTransactionsGetResponseBody = {
  result: {
    account_id: string,
    transaction_id: string,
    booking_date: string,
    relation_name: string,
    relation_iban: string,
    amount: number,
    flow: string,
    currency: string,
    desc: string,
    general_ledger_account_id: null | string,
    general_ledger_account: {
      id: string,
      icon: null | string,
      label_nl: string,
      cashflow_subcategory_nl: string,
    },
    reconciliation_id: null | string,
    matching_exclusion_reason: null | string,
    vat_code: null | string,
    vat_direction: null | string,
    subledger: null | {
      id: string,
      name: string,
    },
  }[],
}



export type BACKENDPreHandleSyncApiV1BusinessConnectFinancialServiceGetResponseBody = {
  url: string,
}



export type BACKENDPreHandleSyncApiV1BusinessInvoiceGenerateFromPromptPostResponseBody = {
  relation: null | string,
  address_street_name: null | string,
  address_house_number: null | string,
  address_postal_code: null | string,
  address_city: null | string,
  address_country_code: null | string,
  invoiceDate: null | string,
  paymentTermDays: Enums.PaymentTerm,
  description: null | string,
  total: null | number,
  vat: Enums.VATCategory,
  seller_iban: null | string,
  vat_percentage: null | number,
  lines: {
    description: string,
    quantity: number,
    unit: Enums.SalesInvoiceLineUnit,
    unit_price: number,
    vat_percentage: null | number,
  }[],
}



export type BACKENDPreHandleSyncApiV1BusinessMarkConnectionCompletePostResponseBody = {
  connection_id: string,
  sync_jobs_group_id: null | string,
}



export type BACKENDPreHandleSyncApiV1BusinessMyBusinessGetResponseBody = {
  id: string,
  name: string,
  legal_entity_type: Enums.LegalEntityType,
  registration_number: string,
  fte_amount: number,
  industry: string,
  description: string,
  created_at: string,
  updated_at: string,
  website: null | string,
  vat_number: null | string,
  managed_by: null | string,
  document_collection_email_address_id: null | string,
  transaction_history_cutoff_date: {
    cutoff_date: string,
  },
  financial_service_integration_proxy_id: null | string,
}



export type BACKENDPreHandleSyncApiV1BusinessMyConnectionsGetResponseBody = {
  id: string,
  name: string,
  institution_id: null | string,
  status: Enums.FinancialServiceIntegrationConnectionStatusEnum,
}[]



export type BACKENDPreHandleSyncApiV1BusinessMySubscriptionsGetResponseBody = {
  id: string,
  relation_name: string,
  frequency: string,
  start_date: string,
  last_payment_date: string,
  cumulative_amount: number,
}[]



export type BACKENDPreHandleSyncApiV1BusinessRelationsAllRelationsGetResponseBody = {
  relations: {
    id: string,
    relation_name: string,
    relation_iban: string,
  }[],
}



export type BACKENDPreHandleSyncApiV1BusinessStatsGetMonthlyTransactionCategoryBreakdownGetResponseBody = {
  expenses: object,
  revenues: object,
}



export type BACKENDPreHandleSyncApiV1BusinessStatsMonthOverviewGetResponseBody = {
  previous_month_inflow: number,
  previous_month_outflow: number,
  current_month_inflow: number,
  current_month_outflow: number,
  inflow_allocations: {
    name: string,
    total: number,
    cashflow_subcategory: string,
    icon: null | string,
  }[],
  outflow_allocations: {
    name: string,
    total: number,
    cashflow_subcategory: string,
    icon: null | string,
  }[],
}



export type BACKENDPreHandleSyncApiV1BusinessTaxHistoryGetResponseBody = {
  tax_group: Enums.TaxTypeGroupEnum,
  tax_group_label: string,
  is_additional_assessment: boolean,
  year: number,
  period_type: null | string,
  assessment_code: null | string,
  paid_on: null | string,
  amount: number,
  flow: string,
}[]



export type BACKENDPreHandleSyncApiV1CategorizationEngineExcludeTransactionFromMatchingPostResponseBody = {
  transaction_id: string,
  vat_code: null | string,
  direction: null | string,
}



export type BACKENDPreHandleSyncApiV1CategorizationEngineUndoBookAwayPostResponseBody = {
  transaction_id: string,
  general_ledger_account_id: null | string,
  vat_code: null | string,
  vat_direction: null | string,
}



export type BACKENDPreHandleSyncApiV1CatestialBaseTransactionsTransactionIdGetResponseBody = {
  account_id: string,
  transaction_id: string,
  booking_date: string,
  relation_name: string,
  relation_iban: string,
  amount: number,
  flow: string,
  currency: string,
  desc: string,
  general_ledger_account_id: null | string,
  general_ledger_account: {
    id: string,
    icon: null | string,
    label_nl: string,
    cashflow_subcategory_nl: string,
  },
  reconciliation_id: null | string,
  matching_exclusion_reason: null | string,
  vat_code: null | string,
  vat_direction: null | string,
  subledger: null | {
    id: string,
    name: string,
  },
}



export type BACKENDPreHandleSyncApiV1CronDocumentCollectionProcessDocumentsPostResponseBody = {
  message: string,
  success: boolean,
}



export type BACKENDPreHandleSyncApiV1CronDocumentCollectionReprocessDocumentsInErrorPostResponseBody = {
  message: string,
  success: boolean,
}



export type BACKENDPreHandleSyncApiV1CronDocumentForwardForwardPendingDocumentsPostResponseBody = {
  message: string,
  success: boolean,
}



export type BACKENDPreHandleSyncApiV1CronImportOpenBankingDataPostResponseBody = {
  sync_id: string,
}



export type BACKENDPreHandleSyncApiV1CronProcessInsightsPostResponseBody = {
  message: string,
  success: boolean,
  data: null | object,
}



export type BACKENDPreHandleSyncApiV1CronQuinnReapAbandonedRunsPostResponseBody = {
  message: string,
  success: boolean,
}



export type BACKENDPreHandleSyncApiV1CronTriggerReconciliationPostResponseBody = {
  message: string,
  success: boolean,
}



export type BACKENDPreHandleSyncApiV1DocumentCollectionReprocessDocumentsWithoutScanningPostResponseBody = {
  message: string,
  success: boolean,
}



export type BACKENDPreHandleSyncApiV1DocumentCollectionShareFilesPostResponseBody = {
  message: string,
  success: boolean,
  data: null | object,
}



export type BACKENDPreHandleSyncApiV1EntrepreneurApproveVatDeclarationPostResponseBody = {
  id: string,
  status: Enums.VATDeclarationApprovalStatus,
}



export type BACKENDPreHandleSyncApiV1EntrepreneurCancelDraftMatchPostResponseBody = {
  id: string,
  status: string,
}



export type BACKENDPreHandleSyncApiV1EntrepreneurDocumentCollectionEmailGetResponseBody = {
  email: string,
}



export type BACKENDPreHandleSyncApiV1EntrepreneurDocumentsReportIncorrectPostResponseBody = {
  message: string,
  success: boolean,
  data: null | object,
}



export type BACKENDPreHandleSyncApiV1EntrepreneurGetPendingDraftMatchesGetResponseBody = {
  id: string,
  status: string,
  transaction_id: string,
  relation_name: string,
  description: string,
  amount: number,
  currency: string,
  booking_date: string,
  document_filename: string,
}[]



export type BACKENDPreHandleSyncApiV1EntrepreneurGetUnmatchedTransactionsGetResponseBody = {
  id: string,
  desc: string,
  relation_name: string,
  relation_iban: string,
  total_amount_payable: object,
  booking_date: string,
  bank_account_iban: null | string,
  bank_account_owner_name: string,
  bank_account_type: string,
  credit_card_number_suffix: null | string,
  institution_name: string,
  currency: string,
  business_name: string,
  bank_logo_url: string,
  category: null | string,
  general_ledger_account_id: null | string,
  rejection: null | {
    reason: Enums.DraftMatchResolutionReason,
    document_id: string,
    document_filename: string,
    criteria: null | {
      amount_matches: boolean,
      date_is_close: boolean,
      relation_matches: boolean | null,
      invoice_number_matches: boolean | null,
    },
  },
}[]



export type BACKENDPreHandleSyncApiV1EntrepreneurGetVatDeclarationApprovalRequestGetResponseBody = {
  subsection_1a_amount: BackendAPITypes.Money,
  subsection_1a_vat: BackendAPITypes.Money,
  subsection_1a_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_1a_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_1b_amount: BackendAPITypes.Money,
  subsection_1b_vat: BackendAPITypes.Money,
  subsection_1b_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_1b_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_1c_amount: BackendAPITypes.Money,
  subsection_1c_vat: BackendAPITypes.Money,
  subsection_1c_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_1d_amount: BackendAPITypes.Money,
  subsection_1d_vat: BackendAPITypes.Money,
  subsection_1d_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_1e_amount: BackendAPITypes.Money,
  subsection_1e_vat: BackendAPITypes.Money,
  subsection_1e_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_1e_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_2a_amount: BackendAPITypes.Money,
  subsection_2a_vat: BackendAPITypes.Money,
  subsection_2a_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_2a_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_3a: BackendAPITypes.Money,
  subsection_3a_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_3a_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_3b: BackendAPITypes.Money,
  subsection_3b_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_3b_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_3c: BackendAPITypes.Money,
  subsection_4a_amount: BackendAPITypes.Money,
  subsection_4a_vat: BackendAPITypes.Money,
  subsection_4a_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_4a_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_4b_amount: BackendAPITypes.Money,
  subsection_4b_vat: BackendAPITypes.Money,
  subsection_4b_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_4b_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_5a: BackendAPITypes.Money,
  subsection_5b: BackendAPITypes.Money,
  subsection_5b_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_5b_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_5c: BackendAPITypes.Money,
  subsection_5d: BackendAPITypes.Money,
  subsection_5e: BackendAPITypes.Money,
  subsection_5f: BackendAPITypes.Money,
  subsection_5g: BackendAPITypes.Money,
  id: string,
  snapshot_id: string,
  business_id: string,
  period_start: string,
  period_end: string,
  status: Enums.VATDeclarationApprovalStatus,
  requested_at: string,
  requested_by_name: null | string,
  answered_at: null | string,
  answered_by_name: null | string,
  rejection_reason: null | string,
  latest_request_id: string,
  is_latest_version: boolean,
}



export type BACKENDPreHandleSyncApiV1EntrepreneurMarkTransactionAsPrivatePostResponseBody = {
  transaction_id: string,
}



export type BACKENDPreHandleSyncApiV1EntrepreneurOutstandingBillsGetResponseBody = {
  sales: {
    id: string,
    document_id: string,
    file_name: string,
    amount: BackendAPITypes.Money,
    relation: string,
    normalized_due_date: null | string,
    days_until_due: null | number,
  }[],
  purchases: {
    id: string,
    document_id: string,
    file_name: string,
    amount: BackendAPITypes.Money,
    relation: string,
    normalized_due_date: null | string,
    days_until_due: null | number,
  }[],
  summary: {
    sales: {
      currency: Enums.CurrencyEnum | null,
      amount: BackendAPITypes.Money,
      count: number,
    }[],
    purchases: {
      currency: Enums.CurrencyEnum | null,
      amount: BackendAPITypes.Money,
      count: number,
    }[],
    total_sales_bill_count: number,
    total_purchase_bill_count: number,
  },
}



export type BACKENDPreHandleSyncApiV1EntrepreneurRejectVatDeclarationPostResponseBody = {
  id: string,
  status: Enums.VATDeclarationApprovalStatus,
}



export type BACKENDPreHandleSyncApiV1EntrepreneurUploadedDocumentsGetResponseBody = {
  id: string,
  file_name: string,
  mime_type: string,
  document_type: Enums.DocumentType,
  size: number,
  created_at: string,
  updated_at: string,
  uploaded_by: string,
  business_id: string,
  document_direction: Enums.DocumentDirection | null,
  shared_via: Enums.SharingMethod | null,
  file_hash: null | string,
  is_duplicate: boolean,
  document_category: Enums.DocumentCategory | null,
  status: Enums.DocumentStatus,
  is_vat_ignored: boolean,
  needs_review: boolean,
  review_context: null | object,
  scanned_fields: null | {
    seller_name: string,
    total_amount_payable: BackendAPITypes.Money | null,
    other_dates: string[],
    vat_number: null | string,
    normalized_datetime: string,
    has_time: boolean,
    payment_term: null | number,
    normalized_due_date: null | string,
    is_vat_exempt: boolean | null,
    reference_identifier: null | string,
    payment_reference: null | string,
    seller_iban: null | string,
    buyer_name: null | string,
    buyer_iban: null | string,
    characteristics: null | string,
    time: null | string,
    date: null | string,
    vat_amount_overall: BackendAPITypes.Money | null,
    vat_reverse_charge_applied: boolean | null,
    is_credit_note: boolean | null,
    vat_breakdown_details: null | {
      vat_rate_percentage_applied: null | number,
      net_amount_at_this_rate: null | number,
      vat_amount_at_this_rate: null | number,
    }[],
    due_date: null | string,
  },
}[]



export type BACKENDPreHandleSyncApiV1GeneralLedgerAccountsGetResponseBody = {
  items: {
    id: string,
    rgs_number: string,
    rgs_official_label: string,
    ranking: number,
    label: string,
    label_nl: string,
    legacy_bankcat: string,
    legacy_bankcat_nl: string,
    cashflow_subcategory: string,
    cashflow_subcategory_nl: string,
    cashflow_category: null | string,
    cashflow_category_nl: null | string,
    icon: null | string,
    applicable_bill_direction: null | string,
    applicable_legal_entity_type: string[],
  }[],
}



export type BACKENDPreHandleSyncApiV1GetBanksByCountryCodeGetResponseBody = {
  banks: {
    id: string,
    name: string,
    logo: null | string,
    transaction_total_days: null | string,
  }[],
  payment_service_providers: {
    id: string,
    name: string,
    logo: null | string,
    transaction_total_days: null | string,
    connection_method: string,
    is_connected: boolean,
  }[],
}



export type BACKENDPreHandleSyncApiV1InitiateBankConnectionPostResponseBody = {
  redirect_url: string,
}



export type BACKENDPreHandleSyncApiV1InsightsGetResponseBody = {
  insights: {
    id: string,
    type: Enums.InsightTypeEnum,
    message: string,
    creator_type: Enums.InsightCreatorTypeEnum,
    creator_id: string,
    business_id: string,
    created_at: string,
    updated_at: string,
    is_read: boolean,
  }[],
}



export type BACKENDPreHandleSyncApiV1InsightsMarkInsightsReadPostResponseBody = {
  message: string,
  success: boolean,
  data: null | object,
}



export type BACKENDPreHandleSyncApiV1InsightsUnreadInsightsGetResponseBody = {
  ids: string[],
}



export type BACKENDPreHandleSyncApiV1MeBusinessArchiveCatalogueItemPostResponseBody = {
  id: string,
  archived_at: string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessChangeCatalogueItemPostResponseBody = {
  id: string,
  name: string,
  unit_price_net: BackendAPITypes.Money,
  unit: string,
  vat_rate_percentage: number,
  vat_category: string,
  times_used: number,
  archived_at: null | string,
  created_at: string,
  updated_at: string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessChangeCustomerPostResponseBody = {
  id: string,
  company_name: string,
  address_extra_line: null | string,
  address: {
    street: string,
    house_number: string,
    postal_code: string,
    city: string,
    country: string,
  },
  email: null | string,
  fixed_cc_email: null | string,
  phone_number: null | string,
  vat_number: null | string,
  default_payment_term_days: null | number,
  archived_at: null | string,
  created_at: string,
  updated_at: string,
  stats: null | {
    invoice_count: number,
  },
}



export type BACKENDPreHandleSyncApiV1MeBusinessChangeRecurringSalesInvoicePostResponseBody = {
  id: string,
  customer_id: string,
  bank_account_id: string,
  customer_name: string,
  description: string,
  cadence: string,
  payment_term: number,
  first_invoice_on: string,
  next_run_on: string,
  last_run_on: null | string,
  auto_send: boolean,
  is_paused: boolean,
  total_excluding_vat_cents: number,
  currency: string,
  lines: {
    id: string,
    position: number,
    description: string,
    quantity: string,
    unit: string,
    unit_price_net_cents: number,
    currency: string,
    vat_rate_percentage: number,
    vat_category: string,
    catalogue_item_id: null | string,
  }[],
}



export type BACKENDPreHandleSyncApiV1MeBusinessChangeSalesInvoiceDraftPostResponseBody = {
  id: string,
  status: string,
  display_status: string,
  invoice_number: null | string,
  invoice_date: string,
  due_date: string,
  fiscal_year: null | number,
  payment_term: number,
  issued_at: null | string,
  customer_id: null | string,
  customer_name: string,
  customer_email: null | string,
  customer_cc_email: null | string,
  customer_vat_number: null | string,
  customer_address_street: string,
  customer_address_house_number: string,
  customer_address_postal_code: string,
  customer_address_city: string,
  customer_address_country: string,
  customer_address_extra_line: null | string,
  purchase_order_reference: null | string,
  customer_specific_reference: null | string,
  fixed_footer_text: null | string,
  seller_business_name: string,
  seller_business_website: null | string,
  seller_address_street: string,
  seller_address_house_number: string,
  seller_address_postal_code: string,
  seller_address_city: string,
  seller_address_country: string,
  seller_vat_number: string,
  seller_registration_number: string,
  seller_contact_name: string,
  seller_email: string,
  bank_account_iban: string,
  bank_account_owner_name: string,
  auto_reminder_enabled: boolean,
  reminder_interval_days: number,
  currency: string,
  lines: {
    id: string,
    position: number,
    description: string,
    quantity: string,
    unit: string,
    unit_price_net_cents: string,
    vat_percentage: number,
    vat_category: string,
    subtotal_cents: string,
    vat_amount_cents: string,
    total_including_vat_cents: string,
    catalogue_item_id: null | string,
    save_to_catalogue: boolean,
    service_start_date: null | string,
    service_end_date: null | string,
    remaining_creditable_quantity: string,
  }[],
  vat_breakdown: {
    vat_percentage: number,
    vat_category: string,
    base_cents: string,
    vat_amount_cents: string,
  }[],
  total_excluding_vat_cents: string,
  vat_total_cents: string,
  total_payable_cents: string,
  is_credit_note: boolean,
  is_fully_credited: boolean,
  credited_invoice_number: null | string,
  credit_reason: null | string,
  credit_notes: {
    id: string,
    invoice_number: null | string,
    invoice_date: string,
    total_payable_cents: null | string,
    is_issued: boolean,
    credit_reason: null | string,
  }[],
}



export type BACKENDPreHandleSyncApiV1MeBusinessChangeSalesInvoiceReminderSettingsPostResponseBody = {
  invoice_id: string,
  auto_reminder_enabled: boolean,
  reminder_interval_days: number,
  last_reminder_sent_at: null | string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessCreateCatalogueItemPostResponseBody = {
  id: string,
  name: string,
  unit_price_net: BackendAPITypes.Money,
  unit: string,
  vat_rate_percentage: number,
  vat_category: string,
  times_used: number,
  archived_at: null | string,
  created_at: string,
  updated_at: string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessCreateCustomerPostResponseBody = {
  id: string,
  company_name: string,
  address_extra_line: null | string,
  address: {
    street: string,
    house_number: string,
    postal_code: string,
    city: string,
    country: string,
  },
  email: null | string,
  fixed_cc_email: null | string,
  phone_number: null | string,
  vat_number: null | string,
  default_payment_term_days: null | number,
  archived_at: null | string,
  created_at: string,
  updated_at: string,
  stats: null | {
    invoice_count: number,
  },
}



export type BACKENDPreHandleSyncApiV1MeBusinessCreateRecurringSalesInvoicePostResponseBody = {
  id: string,
  customer_id: string,
  bank_account_id: string,
  customer_name: string,
  description: string,
  cadence: string,
  payment_term: number,
  first_invoice_on: string,
  next_run_on: string,
  last_run_on: null | string,
  auto_send: boolean,
  is_paused: boolean,
  total_excluding_vat_cents: number,
  currency: string,
  lines: {
    id: string,
    position: number,
    description: string,
    quantity: string,
    unit: string,
    unit_price_net_cents: number,
    currency: string,
    vat_rate_percentage: number,
    vat_category: string,
    catalogue_item_id: null | string,
  }[],
}



export type BACKENDPreHandleSyncApiV1MeBusinessCreateSalesInvoiceDraftPostResponseBody = {
  id: string,
  status: string,
  display_status: string,
  invoice_number: null | string,
  invoice_date: string,
  due_date: string,
  fiscal_year: null | number,
  payment_term: number,
  issued_at: null | string,
  customer_id: null | string,
  customer_name: string,
  customer_email: null | string,
  customer_cc_email: null | string,
  customer_vat_number: null | string,
  customer_address_street: string,
  customer_address_house_number: string,
  customer_address_postal_code: string,
  customer_address_city: string,
  customer_address_country: string,
  customer_address_extra_line: null | string,
  purchase_order_reference: null | string,
  customer_specific_reference: null | string,
  fixed_footer_text: null | string,
  seller_business_name: string,
  seller_business_website: null | string,
  seller_address_street: string,
  seller_address_house_number: string,
  seller_address_postal_code: string,
  seller_address_city: string,
  seller_address_country: string,
  seller_vat_number: string,
  seller_registration_number: string,
  seller_contact_name: string,
  seller_email: string,
  bank_account_iban: string,
  bank_account_owner_name: string,
  auto_reminder_enabled: boolean,
  reminder_interval_days: number,
  currency: string,
  lines: {
    id: string,
    position: number,
    description: string,
    quantity: string,
    unit: string,
    unit_price_net_cents: string,
    vat_percentage: number,
    vat_category: string,
    subtotal_cents: string,
    vat_amount_cents: string,
    total_including_vat_cents: string,
    catalogue_item_id: null | string,
    save_to_catalogue: boolean,
    service_start_date: null | string,
    service_end_date: null | string,
    remaining_creditable_quantity: string,
  }[],
  vat_breakdown: {
    vat_percentage: number,
    vat_category: string,
    base_cents: string,
    vat_amount_cents: string,
  }[],
  total_excluding_vat_cents: string,
  vat_total_cents: string,
  total_payable_cents: string,
  is_credit_note: boolean,
  is_fully_credited: boolean,
  credited_invoice_number: null | string,
  credit_reason: null | string,
  credit_notes: {
    id: string,
    invoice_number: null | string,
    invoice_date: string,
    total_payable_cents: null | string,
    is_issued: boolean,
    credit_reason: null | string,
  }[],
}



export type BACKENDPreHandleSyncApiV1MeBusinessCreditSalesInvoicePostResponseBody = {
  id: string,
  status: string,
  display_status: string,
  invoice_number: null | string,
  invoice_date: string,
  due_date: string,
  fiscal_year: null | number,
  payment_term: number,
  issued_at: null | string,
  customer_id: null | string,
  customer_name: string,
  customer_email: null | string,
  customer_cc_email: null | string,
  customer_vat_number: null | string,
  customer_address_street: string,
  customer_address_house_number: string,
  customer_address_postal_code: string,
  customer_address_city: string,
  customer_address_country: string,
  customer_address_extra_line: null | string,
  purchase_order_reference: null | string,
  customer_specific_reference: null | string,
  fixed_footer_text: null | string,
  seller_business_name: string,
  seller_business_website: null | string,
  seller_address_street: string,
  seller_address_house_number: string,
  seller_address_postal_code: string,
  seller_address_city: string,
  seller_address_country: string,
  seller_vat_number: string,
  seller_registration_number: string,
  seller_contact_name: string,
  seller_email: string,
  bank_account_iban: string,
  bank_account_owner_name: string,
  auto_reminder_enabled: boolean,
  reminder_interval_days: number,
  currency: string,
  lines: {
    id: string,
    position: number,
    description: string,
    quantity: string,
    unit: string,
    unit_price_net_cents: string,
    vat_percentage: number,
    vat_category: string,
    subtotal_cents: string,
    vat_amount_cents: string,
    total_including_vat_cents: string,
    catalogue_item_id: null | string,
    save_to_catalogue: boolean,
    service_start_date: null | string,
    service_end_date: null | string,
    remaining_creditable_quantity: string,
  }[],
  vat_breakdown: {
    vat_percentage: number,
    vat_category: string,
    base_cents: string,
    vat_amount_cents: string,
  }[],
  total_excluding_vat_cents: string,
  vat_total_cents: string,
  total_payable_cents: string,
  is_credit_note: boolean,
  is_fully_credited: boolean,
  credited_invoice_number: null | string,
  credit_reason: null | string,
  credit_notes: {
    id: string,
    invoice_number: null | string,
    invoice_date: string,
    total_payable_cents: null | string,
    is_issued: boolean,
    credit_reason: null | string,
  }[],
}



export type BACKENDPreHandleSyncApiV1MeBusinessDiscardSalesInvoiceDraftPostResponseBody = {
  discarded_invoice_id: string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessEditBaseBusinessInformationPostResponseBody = {
  message: string,
  success: boolean,
  data: null | object,
}



export type BACKENDPreHandleSyncApiV1MeBusinessGenerateSalesInvoicePostResponseBody = {
  file_data: string,
  file_name: string,
  mimetype: string,
  invoice_id: string,
  invoice_number: null | string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessGetCatalogueItemsGetResponseBody = {
  items: {
    id: string,
    name: string,
    unit_price_net: BackendAPITypes.Money,
    unit: string,
    vat_rate_percentage: number,
    vat_category: string,
    times_used: number,
    archived_at: null | string,
    created_at: string,
    updated_at: string,
  }[],
}



export type BACKENDPreHandleSyncApiV1MeBusinessGetCustomersGetResponseBody = {
  customers: {
    id: string,
    company_name: string,
    address_extra_line: null | string,
    address: {
      street: string,
      house_number: string,
      postal_code: string,
      city: string,
      country: string,
    },
    email: null | string,
    fixed_cc_email: null | string,
    phone_number: null | string,
    vat_number: null | string,
    default_payment_term_days: null | number,
    archived_at: null | string,
    created_at: string,
    updated_at: string,
    stats: null | {
      invoice_count: number,
    },
  }[],
}



export type BACKENDPreHandleSyncApiV1MeBusinessGetRecurringSalesInvoicesGetResponseBody = {
  series: {
    id: string,
    customer_id: string,
    bank_account_id: string,
    customer_name: string,
    description: string,
    cadence: string,
    payment_term: number,
    first_invoice_on: string,
    next_run_on: string,
    last_run_on: null | string,
    auto_send: boolean,
    is_paused: boolean,
    total_excluding_vat_cents: number,
    currency: string,
    lines: {
      id: string,
      position: number,
      description: string,
      quantity: string,
      unit: string,
      unit_price_net_cents: number,
      currency: string,
      vat_rate_percentage: number,
      vat_category: string,
      catalogue_item_id: null | string,
    }[],
  }[],
}



export type BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoiceDraftsGetResponseBody = {
  drafts: {
    id: string,
    invoice_date: string,
    customer_name: string,
    description: null | string,
    amount: BackendAPITypes.Money,
    line_count: number,
    updated_at: string,
  }[],
}



export type BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoiceGetResponseBody = {
  id: string,
  status: string,
  display_status: string,
  invoice_number: null | string,
  invoice_date: string,
  due_date: string,
  fiscal_year: null | number,
  payment_term: number,
  issued_at: null | string,
  customer_id: null | string,
  customer_name: string,
  customer_email: null | string,
  customer_cc_email: null | string,
  customer_vat_number: null | string,
  customer_address_street: string,
  customer_address_house_number: string,
  customer_address_postal_code: string,
  customer_address_city: string,
  customer_address_country: string,
  customer_address_extra_line: null | string,
  purchase_order_reference: null | string,
  customer_specific_reference: null | string,
  fixed_footer_text: null | string,
  seller_business_name: string,
  seller_business_website: null | string,
  seller_address_street: string,
  seller_address_house_number: string,
  seller_address_postal_code: string,
  seller_address_city: string,
  seller_address_country: string,
  seller_vat_number: string,
  seller_registration_number: string,
  seller_contact_name: string,
  seller_email: string,
  bank_account_iban: string,
  bank_account_owner_name: string,
  auto_reminder_enabled: boolean,
  reminder_interval_days: number,
  currency: string,
  lines: {
    id: string,
    position: number,
    description: string,
    quantity: string,
    unit: string,
    unit_price_net_cents: string,
    vat_percentage: number,
    vat_category: string,
    subtotal_cents: string,
    vat_amount_cents: string,
    total_including_vat_cents: string,
    catalogue_item_id: null | string,
    save_to_catalogue: boolean,
    service_start_date: null | string,
    service_end_date: null | string,
    remaining_creditable_quantity: string,
  }[],
  vat_breakdown: {
    vat_percentage: number,
    vat_category: string,
    base_cents: string,
    vat_amount_cents: string,
  }[],
  total_excluding_vat_cents: string,
  vat_total_cents: string,
  total_payable_cents: string,
  is_credit_note: boolean,
  is_fully_credited: boolean,
  credited_invoice_number: null | string,
  credit_reason: null | string,
  credit_notes: {
    id: string,
    invoice_number: null | string,
    invoice_date: string,
    total_payable_cents: null | string,
    is_issued: boolean,
    credit_reason: null | string,
  }[],
}



export type BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoiceNumberingGetResponseBody = {
  prefix: string,
  year: number,
  next_sequence: number,
  next_invoice_number: string,
  sequence_exhausted: boolean,
}



export type BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoiceTimelineGetResponseBody = {
  invoice_id: string,
  invoice_number: null | string,
  entries: {
    type: string,
    occurred_at: string,
    description: string,
    recipient: null | string,
    cc_email: null | string,
    failure_reason: null | string,
    message_id: null | string,
  }[],
}



export type BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoicesGetResponseBody = {
  invoices: {
    id: string,
    source: Enums.SalesInvoiceSource,
    document_id: null | string,
    file_name: null | string,
    invoice_number: null | string,
    invoice_date: null | string,
    due_date: null | string,
    customer_name: string,
    description: null | string,
    amount: BackendAPITypes.Money,
    status: Enums.SalesInvoiceDisplayStatus,
    paid_on: null | string,
    last_sent_at: null | string,
    email_bounced: boolean,
    buyer_email: null | string,
    buyer_cc_email: null | string,
    auto_reminder_enabled: boolean,
    reminder_interval_days: number,
  }[],
  summary: {
    outstanding: {
      currency: Enums.CurrencyEnum | null,
      total_amount: BackendAPITypes.Money,
      count: number,
    }[],
    overdue: {
      currency: Enums.CurrencyEnum | null,
      total_amount: BackendAPITypes.Money,
      count: number,
    }[],
    paid_this_month: {
      currency: Enums.CurrencyEnum | null,
      total_amount: BackendAPITypes.Money,
      count: number,
    }[],
    outstanding_count: number,
    overdue_count: number,
    paid_this_month_count: number,
  },
}



export type BACKENDPreHandleSyncApiV1MeBusinessIssueSalesInvoicePostResponseBody = {
  id: string,
  status: string,
  display_status: string,
  invoice_number: null | string,
  invoice_date: string,
  due_date: string,
  fiscal_year: null | number,
  payment_term: number,
  issued_at: null | string,
  customer_id: null | string,
  customer_name: string,
  customer_email: null | string,
  customer_cc_email: null | string,
  customer_vat_number: null | string,
  customer_address_street: string,
  customer_address_house_number: string,
  customer_address_postal_code: string,
  customer_address_city: string,
  customer_address_country: string,
  customer_address_extra_line: null | string,
  purchase_order_reference: null | string,
  customer_specific_reference: null | string,
  fixed_footer_text: null | string,
  seller_business_name: string,
  seller_business_website: null | string,
  seller_address_street: string,
  seller_address_house_number: string,
  seller_address_postal_code: string,
  seller_address_city: string,
  seller_address_country: string,
  seller_vat_number: string,
  seller_registration_number: string,
  seller_contact_name: string,
  seller_email: string,
  bank_account_iban: string,
  bank_account_owner_name: string,
  auto_reminder_enabled: boolean,
  reminder_interval_days: number,
  currency: string,
  lines: {
    id: string,
    position: number,
    description: string,
    quantity: string,
    unit: string,
    unit_price_net_cents: string,
    vat_percentage: number,
    vat_category: string,
    subtotal_cents: string,
    vat_amount_cents: string,
    total_including_vat_cents: string,
    catalogue_item_id: null | string,
    save_to_catalogue: boolean,
    service_start_date: null | string,
    service_end_date: null | string,
    remaining_creditable_quantity: string,
  }[],
  vat_breakdown: {
    vat_percentage: number,
    vat_category: string,
    base_cents: string,
    vat_amount_cents: string,
  }[],
  total_excluding_vat_cents: string,
  vat_total_cents: string,
  total_payable_cents: string,
  is_credit_note: boolean,
  is_fully_credited: boolean,
  credited_invoice_number: null | string,
  credit_reason: null | string,
  credit_notes: {
    id: string,
    invoice_number: null | string,
    invoice_date: string,
    total_payable_cents: null | string,
    is_issued: boolean,
    credit_reason: null | string,
  }[],
}



export type BACKENDPreHandleSyncApiV1MeBusinessLogoGetResponseBody = {
  filename: string,
  content_type: string,
  file_data: string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessPauseRecurringSalesInvoicePostResponseBody = {
  id: string,
  customer_id: string,
  bank_account_id: string,
  customer_name: string,
  description: string,
  cadence: string,
  payment_term: number,
  first_invoice_on: string,
  next_run_on: string,
  last_run_on: null | string,
  auto_send: boolean,
  is_paused: boolean,
  total_excluding_vat_cents: number,
  currency: string,
  lines: {
    id: string,
    position: number,
    description: string,
    quantity: string,
    unit: string,
    unit_price_net_cents: number,
    currency: string,
    vat_rate_percentage: number,
    vat_category: string,
    catalogue_item_id: null | string,
  }[],
}



export type BACKENDPreHandleSyncApiV1MeBusinessResendSalesInvoicePostResponseBody = {
  invoice_id: string,
  kind: string,
  sent_to: string,
  cc_email: null | string,
  bcc_email: null | string,
  sent_at: string,
  message_id: string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessResumeRecurringSalesInvoicePostResponseBody = {
  id: string,
  customer_id: string,
  bank_account_id: string,
  customer_name: string,
  description: string,
  cadence: string,
  payment_term: number,
  first_invoice_on: string,
  next_run_on: string,
  last_run_on: null | string,
  auto_send: boolean,
  is_paused: boolean,
  total_excluding_vat_cents: number,
  currency: string,
  lines: {
    id: string,
    position: number,
    description: string,
    quantity: string,
    unit: string,
    unit_price_net_cents: number,
    currency: string,
    vat_rate_percentage: number,
    vat_category: string,
    catalogue_item_id: null | string,
  }[],
}



export type BACKENDPreHandleSyncApiV1MeBusinessSendSalesInvoicePostResponseBody = {
  invoice_id: string,
  kind: string,
  sent_to: string,
  cc_email: null | string,
  bcc_email: null | string,
  sent_at: string,
  message_id: string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessSendSalesInvoiceReminderPostResponseBody = {
  invoice_id: string,
  kind: string,
  sent_to: string,
  cc_email: null | string,
  bcc_email: null | string,
  sent_at: string,
  message_id: string,
}



export type BACKENDPreHandleSyncApiV1MeBusinessSettingsGetResponseBody = {
  settings: object,
}



export type BACKENDPreHandleSyncApiV1MeBusinessUpdateSettingPostResponseBody = {
  message: string,
  success: boolean,
  data: null | object,
}



export type BACKENDPreHandleSyncApiV1MeBusinessUploadLogoPostResponseBody = {
  message: string,
  success: boolean,
  data: null | object,
}



export type BACKENDPreHandleSyncApiV1MeNoticesGetResponseBody = {
  body: string,
  action_url: string,
}[]



export type BACKENDPreHandleSyncApiV1MeSettingsChangeSettingPostResponseBody = {
  setting_name: string,
  setting_value: (any[] | boolean | number | object | string)[] | boolean | null | number | object | string,
}



export type BACKENDPreHandleSyncApiV1MeSettingsGetResponseBody = {
  settings: object,
}



export type BACKENDPreHandleSyncApiV1MeUserDeviceDeregisterDevicePostResponseBody = {
  deregistered: boolean,
}



export type BACKENDPreHandleSyncApiV1MeUserDeviceRegisterDevicePostResponseBody = {
  id: string,
  device_id: string,
  is_active: boolean,
}



export type BACKENDPreHandleSyncApiV1MeUserDeviceSendTestMessagePostResponseBody = {
  sent: number,
  failed: number,
  no_devices: boolean,
}



export type BACKENDPreHandleSyncApiV1MyBusinessDoublePaymentsGetResponseBody = {
  id: string,
  date: string,
  relation_name: string,
  description: string,
  amount: number,
}[]



export type BACKENDPreHandleSyncApiV1OnboardingInvitationGetResponseBody = {
  email: string,
  business_name: string,
  inviter_name: string,
}



export type BACKENDPreHandleSyncApiV1OpenBankingHandleCallbackPostResponseBody = {
  redirect_url: string,
}



export type BACKENDPreHandleSyncApiV1OpenBankingReconnectBankAccountPostResponseBody = {
  message: string,
  success: boolean,
}



export type BACKENDPreHandleSyncApiV1PartnerBusinessBookingSuggestionsGetResponseBody = {
  business_id: string,
  booking_suggestions: string,
}



export type BACKENDPreHandleSyncApiV1PartnerBusinessEditBookingSuggestionsPostResponseBody = {
  business_id: string,
  booking_suggestions: string,
}



export type BACKENDPreHandleSyncApiV1PartnerBusinessEditDescriptionPostResponseBody = {
  id: string,
  description: string,
}



export type BACKENDPreHandleSyncApiV1PartnerBusinessSettingsGetResponseBody = {
  settings: object,
}



export type BACKENDPreHandleSyncApiV1PartnerBusinessStatsBaseStatsGetResponseBody = {
  outflow: {
    current: number,
    change: number,
  },
  inflow: {
    current: number,
    change: number,
  },
  balance: {
    current: number,
    change: number,
  },
  unique_inflow_sources: {
    current: number,
    change: number,
  },
}



export type BACKENDPreHandleSyncApiV1PartnerBusinessUpdateSettingPostResponseBody = {
  message: string,
  success: boolean,
  data: null | object,
}



export type BACKENDPreHandleSyncApiV1PartnerClientBillDismissTodoPostResponseBody = {
  bill_id: string,
  todo_type: Enums.BillTodoType,
}



export type BACKENDPreHandleSyncApiV1PartnerClientBillListBillTodosGetResponseBody = {
  todos: {
    id: string,
    type: Enums.BillTodoType,
    created_at: string,
    dismissible: boolean,
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerClientDocumentDeletePostResponseBody = {
  message: string,
  success: boolean,
  data: null | object,
}



export type BACKENDPreHandleSyncApiV1PartnerClientDocumentEditDocumentFieldsPostResponseBody = {
  validation_result: {
    is_complete: boolean,
    issues: {
      tag: Enums.ValidationTag,
      category: Enums.ValidationCategory,
      location: {
        field_path: string,
        line_item_index: null | number,
      },
      params: object,
    }[],
    validated_at: string,
    ruleset_version: number,
  },
  editable_bill: {
    document_category: Enums.DocumentCategory | null,
    document_direction: Enums.DocumentDirection | null,
    relation_name: null | string,
    relation_iban: null | string,
    relation_country: Enums.Country | null,
    vat_number: null | string,
    reference_identifier: null | string,
    payment_reference: null | string,
    normalized_date: null | string,
    normalized_time: null | string,
    normalized_due_date: null | string,
    total_amount_payable: BackendAPITypes.Money | null,
    vat_amount_overall: BackendAPITypes.Money | null,
    version: number,
    content_type: "bill" | "draft_bill" | null,
    is_credit_note: boolean,
    vat_reverse_charge_applied: boolean | null,
    is_vat_ignored: boolean,
    relation: null | {
      id: string,
      name: null | string,
    },
    line_items: {
      id: null | string,
      name_or_description: null | string,
      net_amount: BackendAPITypes.Money | null,
      vat_amount: BackendAPITypes.Money | null,
      total_amount: BackendAPITypes.Money | null,
      vat_rate_percentage: null | number,
      vat_id: null | string,
      is_vat_exempt: boolean | null,
      category_id: null | string,
      transitory_start_month: null | string,
      transitory_end_month: null | string,
      subledger_id: null | string,
      subledger: null | {
        id: string,
        name: string,
      },
      original_fx_net_amount: BackendAPITypes.Money | null,
      original_fx_vat_amount: BackendAPITypes.Money | null,
    }[],
  },
}



export type BACKENDPreHandleSyncApiV1PartnerClientDocumentValidateDocumentFieldsPostResponseBody = {
  is_complete: boolean,
  issues: {
    tag: Enums.ValidationTag,
    category: Enums.ValidationCategory,
    location: {
      field_path: string,
      line_item_index: null | number,
    },
    params: object,
  }[],
  validated_at: string,
  ruleset_version: number,
}



export type BACKENDPreHandleSyncApiV1PartnerClientGetBillDuplicatesGetResponseBody = {
  relation_name: string,
  invoice_number: string,
  bills: {
    bill_id: string,
    document_id: string,
    business_id: string,
    file_name: string,
    relation_name: string,
    invoice_number: string,
    invoice_date: string,
    total_amount_payable: number,
    currency: Enums.CurrencyEnum,
    created_at: string,
    is_matched: boolean,
    is_booked: boolean,
    monetary_origin: null | {
      original_fx_currency: Enums.CurrencyEnum,
      original_fx_total_amount_payable: BackendAPITypes.Money | null,
      original_fx_vat_amount_overall: BackendAPITypes.Money | null,
      fx_rate: null | string,
      fx_rate_market_date: null | string,
      fx_rate_source: string,
      fx_is_fallback: boolean,
    },
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerClientGetCompletenessScoreGetResponseBody = {
  completeness_score: number,
  matched_documents_count: number,
  total_documents_count: number,
}



export type BACKENDPreHandleSyncApiV1PartnerClientGetDocumentGetResponseBody = {
  file_name: string,
  bill_id: null | string,
  mimetype: string,
  document_category: string,
  document_direction: null | string,
  is_matched: boolean,
  is_vat_ignored: boolean,
  client_business_name: string,
  reason: Enums.ToCheckReason | null,
  relation_country: null | string,
  is_booked: boolean,
  relation: null | {
    id: string,
    name: string,
  },
  is_incomplete: boolean,
  validation_result: null | {
    is_complete: boolean,
    issues: {
      tag: Enums.ValidationTag,
      category: Enums.ValidationCategory,
      location: {
        field_path: string,
        line_item_index: null | number,
      },
      params: object,
    }[],
    validated_at: string,
    ruleset_version: number,
  },
  editable_bill: null | {
    document_category: Enums.DocumentCategory | null,
    document_direction: Enums.DocumentDirection | null,
    relation_name: null | string,
    relation_iban: null | string,
    relation_country: Enums.Country | null,
    vat_number: null | string,
    reference_identifier: null | string,
    payment_reference: null | string,
    normalized_date: null | string,
    normalized_time: null | string,
    normalized_due_date: null | string,
    total_amount_payable: BackendAPITypes.Money | null,
    vat_amount_overall: BackendAPITypes.Money | null,
    version: number,
    content_type: "bill" | "draft_bill" | null,
    is_credit_note: boolean,
    vat_reverse_charge_applied: boolean | null,
    is_vat_ignored: boolean,
    relation: null | {
      id: string,
      name: null | string,
    },
    line_items: {
      id: null | string,
      name_or_description: null | string,
      net_amount: BackendAPITypes.Money | null,
      vat_amount: BackendAPITypes.Money | null,
      total_amount: BackendAPITypes.Money | null,
      vat_rate_percentage: null | number,
      vat_id: null | string,
      is_vat_exempt: boolean | null,
      category_id: null | string,
      transitory_start_month: null | string,
      transitory_end_month: null | string,
      subledger_id: null | string,
      subledger: null | {
        id: string,
        name: string,
      },
      original_fx_net_amount: BackendAPITypes.Money | null,
      original_fx_vat_amount: BackendAPITypes.Money | null,
    }[],
  },
  monetary_origin: null | {
    original_fx_currency: Enums.CurrencyEnum,
    original_fx_total_amount_payable: BackendAPITypes.Money | null,
    original_fx_vat_amount_overall: BackendAPITypes.Money | null,
    fx_rate: null | string,
    fx_rate_market_date: null | string,
    fx_rate_source: string,
    fx_is_fallback: boolean,
  },
  fixed_asset: null | {
    id: string,
    name: string,
  },
  can_convert_to_euro: boolean,
}



export type BACKENDPreHandleSyncApiV1PartnerClientMatchesGetResponseBody = {
  customer_name: string,
  business_id: string,
  matches: {
    match_id: string,
    match_title: string,
    match_description: string,
    created_at: string,
    transaction: {
      amount: number,
      description: string,
      transaction_date: string,
      relation_name: null | string,
      iban: null | string,
    },
    document: {
      document_id: string,
      bill_id: string,
      amount: number,
      invoice_number: null | string,
      document_date: null | string,
    },
    transaction_ids: string[],
    bill_ids: string[],
  }[],
}[]



export type BACKENDPreHandleSyncApiV1PartnerClientUnmatchAndDeleteBillPostResponseBody = {
  bill_id: string,
}



export type BACKENDPreHandleSyncApiV1PartnerClientUploadedDocumentsGetResponseBody = {
  id: string,
  file_name: string,
  mime_type: string,
  document_type: Enums.DocumentType,
  size: number,
  created_at: string,
  updated_at: string,
  uploaded_by: string,
  business_id: string,
  document_direction: Enums.DocumentDirection | null,
  shared_via: Enums.SharingMethod | null,
  file_hash: null | string,
  is_duplicate: boolean,
  document_category: Enums.DocumentCategory | null,
  status: Enums.DocumentStatus,
  is_vat_ignored: boolean,
  needs_review: boolean,
  review_context: null | object,
  scanned_fields: null | {
    seller_name: string,
    total_amount_payable: BackendAPITypes.Money | null,
    other_dates: string[],
    vat_number: null | string,
    normalized_datetime: string,
    has_time: boolean,
    payment_term: null | number,
    normalized_due_date: null | string,
    is_vat_exempt: boolean | null,
    reference_identifier: null | string,
    payment_reference: null | string,
    seller_iban: null | string,
    buyer_name: null | string,
    buyer_iban: null | string,
    characteristics: null | string,
    time: null | string,
    date: null | string,
    vat_amount_overall: BackendAPITypes.Money | null,
    vat_reverse_charge_applied: boolean | null,
    is_credit_note: boolean | null,
    vat_breakdown_details: null | {
      vat_rate_percentage_applied: null | number,
      net_amount_at_this_rate: null | number,
      vat_amount_at_this_rate: null | number,
    }[],
    due_date: null | string,
  },
}[]



export type BACKENDPreHandleSyncApiV1PartnerComputeVatDeclarationGetResponseBody = {
  subsection_1a_amount: BackendAPITypes.Money,
  subsection_1a_vat: BackendAPITypes.Money,
  subsection_1a_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_1a_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_1b_amount: BackendAPITypes.Money,
  subsection_1b_vat: BackendAPITypes.Money,
  subsection_1b_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_1b_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_1c_amount: BackendAPITypes.Money,
  subsection_1c_vat: BackendAPITypes.Money,
  subsection_1c_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_1d_amount: BackendAPITypes.Money,
  subsection_1d_vat: BackendAPITypes.Money,
  subsection_1d_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_1e_amount: BackendAPITypes.Money,
  subsection_1e_vat: BackendAPITypes.Money,
  subsection_1e_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_1e_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_2a_amount: BackendAPITypes.Money,
  subsection_2a_vat: BackendAPITypes.Money,
  subsection_2a_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_2a_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_3a: BackendAPITypes.Money,
  subsection_3a_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_3a_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_3b: BackendAPITypes.Money,
  subsection_3b_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_3b_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_3c: BackendAPITypes.Money,
  subsection_4a_amount: BackendAPITypes.Money,
  subsection_4a_vat: BackendAPITypes.Money,
  subsection_4a_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_4a_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_4b_amount: BackendAPITypes.Money,
  subsection_4b_vat: BackendAPITypes.Money,
  subsection_4b_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_4b_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_5a: BackendAPITypes.Money,
  subsection_5b: BackendAPITypes.Money,
  subsection_5b_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_5b_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_5c: BackendAPITypes.Money,
  subsection_5d: BackendAPITypes.Money,
  subsection_5e: BackendAPITypes.Money,
  subsection_5f: BackendAPITypes.Money,
  subsection_5g: BackendAPITypes.Money,
  unused_items: {
    id: string,
    document_id: string,
    bill_id: null | string,
    file_name: string,
    status: Enums.DocumentStatus | null,
    needs_review: boolean | null,
    document_direction: Enums.DocumentDirection | null,
    document_category: Enums.DocumentCategory | null,
    relation_name: null | string,
    normalized_date: null | string,
    total_amount_payable: BackendAPITypes.Money | null,
    leftover_line_item_ids: string[],
    is_matched: boolean,
  }[],
  completeness: {
    document_count: number,
    matched_count: number,
    matched_percentage: null | number,
  },
}



export type BACKENDPreHandleSyncApiV1PartnerConnectFinancialServiceGetResponseBody = {
  url: string,
}



export type BACKENDPreHandleSyncApiV1PartnerCreateBusinessPostResponseBody = {
  id: string,
  name: string,
  legal_entity_type: string,
  registration_number: string,
  fte_amount: number,
  industry: string,
  description: string,
}



export type BACKENDPreHandleSyncApiV1PartnerCreateClientSubledgerPostResponseBody = {
  id: string,
  business_id: string,
  name: string,
}



export type BACKENDPreHandleSyncApiV1PartnerCreateFixedAssetPostResponseBody = {
  id: string,
  name: string,
  bill_id: null | string,
  message: string,
}



export type BACKENDPreHandleSyncApiV1PartnerDeleteAutomationRulePostResponseBody = {
  rule_id: string,
  business_name: null | string,
  rule: {
    rules: {
      operand: any[] | boolean | number | object | string,
      operator: Enums.RuleOperatorEnum,
      value_field_name: any[] | boolean | number | object | string,
      context: null | object,
    }[],
    connective: Enums.RuleGroupConnectiveEnum,
  },
}[]



export type BACKENDPreHandleSyncApiV1PartnerDeleteManualBookingPostResponseBody = {
  booking_id: string,
}



export type BACKENDPreHandleSyncApiV1PartnerDocumentActivityDocumentsGetResponseBody = {
  documents: {
    id: string,
    file_name: string,
    created_at: string,
    status: string,
    shared_via: string,
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerDocumentBillConvertToEuroPostResponseBody = {
  was_converted: boolean,
}



export type BACKENDPreHandleSyncApiV1PartnerDocumentBillMarkAsPrivatelyPaidPostResponseBody = {
  message: string,
  success: boolean,
  data: null | object,
}



export type BACKENDPreHandleSyncApiV1PartnerDocumentBillUndoMarkAsPrivatelyPaidPostResponseBody = {
  message: string,
  success: boolean,
  data: null | object,
}



export type BACKENDPreHandleSyncApiV1PartnerDocumentToggleDocumentVatIgnoredPostResponseBody = {
  id: string,
  file_name: string,
  mime_type: string,
  document_type: Enums.DocumentType,
  size: number,
  created_at: string,
  updated_at: string,
  uploaded_by: string,
  business_id: string,
  document_direction: Enums.DocumentDirection | null,
  shared_via: Enums.SharingMethod | null,
  file_hash: null | string,
  is_duplicate: boolean,
  document_category: Enums.DocumentCategory | null,
  status: Enums.DocumentStatus,
  is_vat_ignored: boolean,
  needs_review: boolean,
  review_context: null | object,
  scanned_fields: null | {
    seller_name: string,
    total_amount_payable: BackendAPITypes.Money | null,
    other_dates: string[],
    vat_number: null | string,
    normalized_datetime: string,
    has_time: boolean,
    payment_term: null | number,
    normalized_due_date: null | string,
    is_vat_exempt: boolean | null,
    reference_identifier: null | string,
    payment_reference: null | string,
    seller_iban: null | string,
    buyer_name: null | string,
    buyer_iban: null | string,
    characteristics: null | string,
    time: null | string,
    date: null | string,
    vat_amount_overall: BackendAPITypes.Money | null,
    vat_reverse_charge_applied: boolean | null,
    is_credit_note: boolean | null,
    vat_breakdown_details: null | {
      vat_rate_percentage_applied: null | number,
      net_amount_at_this_rate: null | number,
      vat_amount_at_this_rate: null | number,
    }[],
    due_date: null | string,
  },
}



export type BACKENDPreHandleSyncApiV1PartnerEditManualBookingPostResponseBody = {
  id: string,
  business_id: string,
  booking_date: string,
  journal: string,
  audit_reason: string,
  currency: Enums.CurrencyEnum,
  lines: {
    id: string,
    line_no: number,
    general_ledger_account_id: string,
    description: null | string,
    debit_amount_cents: number,
    credit_amount_cents: number,
    currency: Enums.CurrencyEnum,
    subledger_id: null | string,
    subledger: null | {
      id: string,
      name: string,
    },
  }[],
  created_at: string,
  created_by: string,
  updated_at: null | string,
  updated_by: null | string,
  deleted_at: null | string,
  deleted_by: null | string,
  source_payroll_import_id: null | string,
}



export type BACKENDPreHandleSyncApiV1PartnerEntrepreneurDocumentCollectionEmailGetResponseBody = {
  email: string,
}



export type BACKENDPreHandleSyncApiV1PartnerEntrepreneurGetBankAccountsGetResponseBody = {
  account_id: string,
  iban: null | string,
  currency: string,
  owner_name: string,
  institution_name: string,
  balance: number,
  connected_on: null | string,
  refreshed_on: null | string,
  last_transaction_full_sync_on: null | string,
  is_expired: boolean,
  expires_soon: boolean,
  days_until_expiration: number,
  account_type: string,
  credit_card_number_prefix: null | string,
  credit_card_number_suffix: null | string,
}[]



export type BACKENDPreHandleSyncApiV1PartnerExportClientBalanceSheetGetResponseBody = {
  file_data: string,
  file_name: string,
  mimetype: string,
}



export type BACKENDPreHandleSyncApiV1PartnerFindByBusinessIdGetResponseBody = {
  result: null | {
    id: string,
    name: string,
    slug: string,
    tagline: string,
    address: string,
    email: string,
    phone_number: string,
    primary_color: string,
    full_logo_url: string,
    icon_logo_url: string,
    website_url: string,
    created_at: string,
    updated_at: string,
    business_id: string,
  },
}



export type BACKENDPreHandleSyncApiV1PartnerFindByHostUrlGetResponseBody = {
  result: null | {
    id: string,
    name: string,
    slug: string,
    tagline: string,
    address: string,
    email: string,
    phone_number: string,
    primary_color: string,
    full_logo_url: string,
    icon_logo_url: string,
    website_url: string,
    created_at: string,
    updated_at: string,
    business_id: string,
  },
}



export type BACKENDPreHandleSyncApiV1PartnerGetAllVatDeclarationSnapshotsGetResponseBody = {
  snapshots: {
    id: string,
    period_start: string,
    period_end: string,
    version: number,
    created_at: string,
    created_by: string,
    created_by_name: null | string,
    approval_request_id: null | string,
    approval_status: Enums.VATDeclarationApprovalStatus | null,
    approval_requested_at: null | string,
    approval_requested_by_name: null | string,
    approval_answered_at: null | string,
    approval_answered_by_name: null | string,
    approval_rejection_reason: null | string,
    approval_withdrawn_at: null | string,
    approval_withdrawn_by_name: null | string,
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerGetAutomationRulesGetResponseBody = {
  rule_id: string,
  business_name: null | string,
  rule: {
    rules: {
      operand: any[] | boolean | number | object | string,
      operator: Enums.RuleOperatorEnum,
      value_field_name: any[] | boolean | number | object | string,
      context: null | object,
    }[],
    connective: Enums.RuleGroupConnectiveEnum,
  },
}[]



export type BACKENDPreHandleSyncApiV1PartnerGetBankAccountBalanceAtDatePostResponseBody = {
  balance: null | number,
  iban: null | string,
  institution_name: string,
}



export type BACKENDPreHandleSyncApiV1PartnerGetBksEntrepreneurBusinessesGetResponseBody = {
  id: string,
  name: string,
  selected: boolean | null,
  vat: null | string,
  company_number: null | string,
}[]



export type BACKENDPreHandleSyncApiV1PartnerGetBksImportJobsGetResponseBody = {
  import_id: string,
  status: Enums.DocumentImportStatus,
  connection_id: string,
  connection_name: null | string,
  date_from: string,
  date_to: string,
  created_at: string,
  error_context: null | object,
}[]



export type BACKENDPreHandleSyncApiV1PartnerGetBksImportStatusGetResponseBody = {
  import_id: string,
  business_id: string,
  status: string,
  total_documents: number,
  processed_documents: number,
  failed_documents: number,
  created_at: string,
  started_at: null | string,
  processed_at: null | string,
  failed_at: null | string,
  error_context: null | object,
  failed_document_details: null | {
    invoice_id: string,
    error: string,
    timestamp: string,
  }[],
  documents_without_attachments: null | object,
}



export type BACKENDPreHandleSyncApiV1PartnerGetBksJournalsGetResponseBody = {
  id: string,
  name: string,
  journal_type: string,
  code: null | string,
  currency: null | string,
}[]



export type BACKENDPreHandleSyncApiV1PartnerGetBlacklistRulePreviewPostResponseBody = {
  id: string,
  relation_name: string,
  relation_iban: string,
  description: string,
  signed_amount: number,
  business_name: string,
  booking_date: string,
  general_ledger_account_id: null | string,
}[]



export type BACKENDPreHandleSyncApiV1PartnerGetBusinessAccessListGetResponseBody = {
  members: {
    id: string,
    first_name: string,
    last_name: string,
    email: string,
    role: string,
    other_businesses: {
      business_id: string,
      business_name: string,
    }[],
  }[],
  pending_invitations: {
    email: string,
    created_at: string,
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerGetBusinessReconciliationOverviewsGetResponseBody = {
  business_id: string,
  business_name: string,
  transaction_side: ({
    transaction_id: string,
    desc: string,
    relation_name: string,
    relation_iban: string,
    total_amount_payable: BackendAPITypes.Money,
    booking_date: string,
    bank_account_iban: null | string,
    bank_account_owner_name: string,
    bank_account_type: string,
    credit_card_number_suffix: null | string,
    institution_name: string,
    bank_account_currency: string,
    business_name: string,
    bank_logo_url: string,
    nrs_amount: number,
    general_ledger_account_id: null | string,
    render_type: string,
  } | {
    transaction_id: string,
    match_id: string,
    desc: string,
    relation_name: string,
    relation_iban: string,
    total_amount_payable: BackendAPITypes.Money,
    booking_date: string,
    business_id: string,
    business_name: string,
    bank_account_iban: null | string,
    bank_account_owner_name: string,
    bank_account_type: string,
    credit_card_number_suffix: null | string,
    institution_name: string,
    bank_account_currency: string,
    bank_logo_url: string,
    matched_document_id: null | string,
    nrs_amount: number,
    general_ledger_account_id: null | string,
    render_type: string,
  })[],
  document_side: ({
    document_id: string,
    file_name: string,
    file_type: string,
    business_id: string,
    business_name: string,
    bill_id: string,
    document_category: Enums.DocumentCategory | null,
    document_direction: Enums.DocumentDirection,
    nrs_amount: number,
    scanned_fields: {
      seller_name: string,
      total_amount_payable: BackendAPITypes.Money | null,
      other_dates: string[],
      vat_number: null | string,
      normalized_datetime: string,
      has_time: boolean,
      payment_term: null | number,
      normalized_due_date: null | string,
      is_vat_exempt: boolean | null,
      reference_identifier: null | string,
      payment_reference: null | string,
      seller_iban: null | string,
      buyer_name: null | string,
      buyer_iban: null | string,
      characteristics: null | string,
      time: null | string,
      date: null | string,
      vat_amount_overall: BackendAPITypes.Money | null,
      vat_reverse_charge_applied: boolean | null,
      is_credit_note: boolean | null,
      vat_breakdown_details: null | {
        vat_rate_percentage_applied: null | number,
        net_amount_at_this_rate: null | number,
        vat_amount_at_this_rate: null | number,
      }[],
      due_date: null | string,
    },
    render_type: string,
  } | {
    document_id: string,
    match_id: string,
    file_name: string,
    file_type: string,
    business_id: string,
    business_name: string,
    bill_id: string,
    document_category: Enums.DocumentCategory | null,
    document_direction: Enums.DocumentDirection,
    nrs_amount: number,
    scanned_fields: {
      seller_name: string,
      total_amount_payable: BackendAPITypes.Money | null,
      other_dates: string[],
      vat_number: null | string,
      normalized_datetime: string,
      has_time: boolean,
      payment_term: null | number,
      normalized_due_date: null | string,
      is_vat_exempt: boolean | null,
      reference_identifier: null | string,
      payment_reference: null | string,
      seller_iban: null | string,
      buyer_name: null | string,
      buyer_iban: null | string,
      characteristics: null | string,
      time: null | string,
      date: null | string,
      vat_amount_overall: BackendAPITypes.Money | null,
      vat_reverse_charge_applied: boolean | null,
      is_credit_note: boolean | null,
      vat_breakdown_details: null | {
        vat_rate_percentage_applied: null | number,
        net_amount_at_this_rate: null | number,
        vat_amount_at_this_rate: null | number,
      }[],
      due_date: null | string,
    },
    render_type: string,
  } | {
    match_id: string,
    business_id: string,
    business_name: string,
    bill_direction: Enums.DocumentDirection | null,
    transactions: {
      transaction_id: string,
      match_id: string,
      is_reconciled: boolean,
      business_id: string,
      business_name: string,
      signed_amount: BackendAPITypes.Money,
      bank_logo_url: string,
      bank_account_name: string,
      desc: string,
      booking_date: string,
      nrs_amount: number,
      bank_account_iban: null | string,
      bank_account_owner_name: null | string,
      institution_name: null | string,
      bank_account_currency: null | string,
      relation_name: null | string,
      relation_iban: null | string,
      general_ledger_account_id: null | string,
    }[],
    bills: {
      bill_id: string,
      match_id: string,
      is_reconciled: boolean,
      business_id: string,
      business_name: string,
      signed_amount: BackendAPITypes.Money,
      relation_name: string,
      reference_identifier: string,
      document_id: string,
      normalized_date: string,
      file_name: string,
      nrs_amount: number,
      document_direction: Enums.DocumentDirection,
      file_type: null | string,
    }[],
    nrs_remainder: number,
    remainder: BackendAPITypes.Money,
    is_reconciled: boolean,
    render_type: string,
  })[],
}[]



export type BACKENDPreHandleSyncApiV1PartnerGetClientActivityGetResponseBody = {
  activities: {
    business_id: string,
    inflow_transactions_count: number,
    outflow_transactions_count: number,
    documents_uploaded_count: number,
    mdr_count: number,
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerGetClientBalanceSheetPerPeriodGetResponseBody = {
  period: {
    start_date: string,
    end_date: string,
  },
  buckets: {
    start_date: string,
    end_date: string,
  }[],
  currency: Enums.CurrencyEnum,
  available_currencies: Enums.CurrencyEnum[] | null,
  rows: {
    id: string,
    kind: Enums.ReportRowKind,
    level: number,
    parent_id: null | string,
    label_key: null | string,
    opening_balance: BackendAPITypes.Money,
    balances: BackendAPITypes.Money[],
    account: null | {
      code: string,
      label_nl: string,
    },
    subledger: null | {
      id: string,
      name: string,
    },
    subledger_split: boolean,
    warning: null | {
      reason: string,
      legal_entity_type: string,
    },
    lines: {
      debit_amount: object,
      credit_amount: object,
      sources: ({
        bill_id: string,
        source_date: string,
        description: string,
        document_id: null | string,
        file_name: null | string,
        relation_name: null | string,
        invoice_number: null | string,
        line_item_id: null | string,
        vat_rate_percentage: null | number,
        source_type_for_presentation: Enums.PresentationSourceType,
      } | {
        booking_id: string,
        source_date: string,
        description: string,
        line_id: string,
        source_type_for_presentation: Enums.PresentationSourceType,
      } | {
        fixed_asset_id: string,
        source_date: string,
        description: string,
        source_type_for_presentation: Enums.PresentationSourceType,
      } | {
        match_id: string,
        source_date: string,
        description: string,
        bill_ids: string[],
        transaction_ids: string[],
        source_type_for_presentation: Enums.PresentationSourceType,
      } | {
        transaction_id: string,
        source_date: string,
        description: string,
        relation_name: null | string,
        vat_code: Enums.VatCode | null,
        source_type_for_presentation: Enums.PresentationSourceType,
      })[],
      booking_id: string,
      booking_date: string,
      description: null | string,
      subledger: null | {
        id: string,
        name: string,
      },
    }[],
  }[],
  bank_balance_checks: {
    bank_account_id: string,
    label: null | string,
    currency: Enums.CurrencyEnum,
    derived_balance: object,
    actual_balance: null | object,
    difference: null | object,
    status: string,
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerGetClientBankAccountsGetResponseBody = {
  clients: {
    business_id: string,
    bank_accounts: {
      iban: null | string,
      institution_name: string,
      logo_url: null | string,
      is_expired: boolean,
      expires_soon: boolean,
      days_until_expiration: number,
    }[],
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerGetClientInsightsGetResponseBody = {
  insights: {
    insight: {
      id: string,
      type: Enums.InsightTypeEnum,
      message: string,
      creator_type: Enums.InsightCreatorTypeEnum,
      creator_id: string,
      business_id: string,
      created_at: string,
      updated_at: string,
    },
    is_read: boolean,
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerGetClientManualBookingsGetResponseBody = {
  id: string,
  business_id: string,
  booking_date: string,
  journal: string,
  audit_reason: string,
  currency: Enums.CurrencyEnum,
  lines: {
    id: string,
    line_no: number,
    general_ledger_account_id: string,
    description: null | string,
    debit_amount_cents: number,
    credit_amount_cents: number,
    currency: Enums.CurrencyEnum,
    subledger_id: null | string,
    subledger: null | {
      id: string,
      name: string,
    },
  }[],
  created_at: string,
  created_by: string,
  updated_at: null | string,
  updated_by: null | string,
  deleted_at: null | string,
  deleted_by: null | string,
  source_payroll_import_id: null | string,
}[]



export type BACKENDPreHandleSyncApiV1PartnerGetClientProfitAndLossPdfGetResponseBody = {
  file_data: string,
  file_name: string,
  mimetype: string,
}



export type BACKENDPreHandleSyncApiV1PartnerGetClientProfitAndLossPerPeriodGetResponseBody = {
  period: {
    start_date: string,
    end_date: string,
  },
  buckets: {
    start_date: string,
    end_date: string,
  }[],
  currency: string,
  available_currencies: null | string[],
  rows: {
    id: string,
    kind: string,
    level: number,
    parent_id: null | string,
    label_key: null | string,
    growth_is_favourable: boolean | null,
    account: null | {
      code: string,
      label_nl: string,
    },
    cells: {
      signed_net: object,
      cumulative_signed_net: object,
    }[],
    total_signed_net: object,
    lines: {
      line: {
        debit_amount: object,
        credit_amount: object,
        sources: ({
          bill_id: string,
          source_date: string,
          description: string,
          document_id: null | string,
          file_name: null | string,
          relation_name: null | string,
          invoice_number: null | string,
          line_item_id: null | string,
          vat_rate_percentage: null | number,
          source_type_for_presentation: Enums.PresentationSourceType,
        } | {
          booking_id: string,
          source_date: string,
          description: string,
          line_id: string,
          source_type_for_presentation: Enums.PresentationSourceType,
        } | {
          fixed_asset_id: string,
          source_date: string,
          description: string,
          source_type_for_presentation: Enums.PresentationSourceType,
        } | {
          match_id: string,
          source_date: string,
          description: string,
          bill_ids: string[],
          transaction_ids: string[],
          source_type_for_presentation: Enums.PresentationSourceType,
        } | {
          transaction_id: string,
          source_date: string,
          description: string,
          relation_name: null | string,
          vat_code: Enums.VatCode | null,
          source_type_for_presentation: Enums.PresentationSourceType,
        })[],
        booking_id: string,
        booking_date: string,
        description: null | string,
        subledger: null | {
          id: string,
          name: string,
        },
      },
      period_index: number,
    }[],
    warning: null | {
      reason: string,
      legal_entity_type: string,
    },
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerGetClientReportsGetResponseBody = {
  client_reports: {
    id: string,
    business_name: string,
    fte_amount: number,
    total_insights: number,
    has_unread_insights: boolean,
    has_bank_connection: boolean,
  }[],
  onboarding_url: string,
}



export type BACKENDPreHandleSyncApiV1PartnerGetClientSubledgersGetResponseBody = {
  subledgers: {
    id: string,
    name: string,
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerGetClientTrialBalanceGetResponseBody = {
  period: {
    start_date: string,
    end_date: string,
  },
  rows: {
    category: {
      id: string,
      rgs_number: string,
      rgs_level: number,
      rgs_official_label: string,
      ranking: number,
      label: string,
      label_nl: string,
      reporting_class: Enums.ReportingClass,
      reporting_financial_statement_element: Enums.ReportingFinancialStatementElement,
      normal_balance_direction: Enums.NormalBalance,
      legacy_bankcat: Enums.BankCategory,
      legacy_bankcat_nl: string,
      cashflow_subcategory: Enums.CashflowSubcategory,
      cashflow_subcategory_nl: string,
      cashflow_category: Enums.CashflowCategory | null,
      cashflow_category_nl: null | string,
      bill_line_item_classification_instruction: null | string,
      transaction_classification_instruction: null | string,
      notes_from_author: null | string,
      applicable_legal_entity_type: Enums.LegalEntityType[],
      applicable_bill_direction: Enums.DocumentDirection | null,
      expected_trigger_event: Enums.TriggerEvent | null,
      expected_document_type: Enums.DocumentCategory[],
      icon: null | string,
      section: Enums.SbsSection,
    },
    trial_balance: {
      debit_amount: object,
      credit_amount: object,
    },
    net_trial_balance: {
      debit_amount: object,
      credit_amount: object,
    },
    profit_and_loss: {
      debit_amount: object,
      credit_amount: object,
    },
    balance_sheet: {
      debit_amount: object,
      credit_amount: object,
    },
    currency: Enums.CurrencyEnum,
    lines: {
      debit_amount: object,
      credit_amount: object,
      sources: ({
        bill_id: string,
        source_date: string,
        description: string,
        document_id: null | string,
        file_name: null | string,
        relation_name: null | string,
        invoice_number: null | string,
        line_item_id: null | string,
        vat_rate_percentage: null | number,
        source_type_for_presentation: Enums.PresentationSourceType,
      } | {
        booking_id: string,
        source_date: string,
        description: string,
        line_id: string,
        source_type_for_presentation: Enums.PresentationSourceType,
      } | {
        fixed_asset_id: string,
        source_date: string,
        description: string,
        source_type_for_presentation: Enums.PresentationSourceType,
      } | {
        match_id: string,
        source_date: string,
        description: string,
        bill_ids: string[],
        transaction_ids: string[],
        source_type_for_presentation: Enums.PresentationSourceType,
      } | {
        transaction_id: string,
        source_date: string,
        description: string,
        relation_name: null | string,
        vat_code: Enums.VatCode | null,
        source_type_for_presentation: Enums.PresentationSourceType,
      })[],
      booking_id: string,
      booking_date: string,
      description: null | string,
      subledger: null | {
        id: string,
        name: string,
      },
    }[],
    description: null | string,
  }[],
  profit_and_loss_totals: {
    debit_amount: object,
    credit_amount: object,
  },
  balance_sheet_totals: {
    debit_amount: object,
    credit_amount: object,
  },
  profit_and_loss_result: {
    debit_amount: object,
    credit_amount: object,
  },
  balance_sheet_result: {
    debit_amount: object,
    credit_amount: object,
  },
  available_currencies: null | string[],
  bank_balance_checks: null | {
    bank_account_id: string,
    label: null | string,
    currency: Enums.CurrencyEnum,
    derived_balance: object,
    actual_balance: null | object,
    difference: null | object,
    status: string,
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerGetClientTrialBalanceReportGetResponseBody = {
  period: {
    start_date: string,
    end_date: string,
  },
  currency: string,
  available_currencies: null | string[],
  balance_diff_cents: number,
  bank_balance_checks: null | {
    bank_account_id: string,
    label: null | string,
    currency: Enums.CurrencyEnum,
    derived_balance: object,
    actual_balance: null | object,
    difference: null | object,
    status: string,
  }[],
  comparison_period: null | {
    start_date: string,
    end_date: string,
  },
  profit_and_loss: {
    rows: {
      id: string,
      kind: string,
      level: number,
      parent_id: null | string,
      label_key: null | string,
      amounts: {
        trial_balance: {
          debit_amount: object,
          credit_amount: object,
        },
        net_trial_balance: {
          debit_amount: object,
          credit_amount: object,
        },
        profit_and_loss: {
          debit_amount: object,
          credit_amount: object,
        },
        balance_sheet: {
          debit_amount: object,
          credit_amount: object,
        },
      },
      signed_net: object,
      growth_is_favourable: boolean | null,
      account: null | {
        code: string,
        label_nl: string,
      },
      lines: {
        debit_amount: object,
        credit_amount: object,
        sources: ({
          bill_id: string,
          source_date: string,
          description: string,
          document_id: null | string,
          file_name: null | string,
          relation_name: null | string,
          invoice_number: null | string,
          line_item_id: null | string,
          vat_rate_percentage: null | number,
          source_type_for_presentation: Enums.PresentationSourceType,
        } | {
          booking_id: string,
          source_date: string,
          description: string,
          line_id: string,
          source_type_for_presentation: Enums.PresentationSourceType,
        } | {
          fixed_asset_id: string,
          source_date: string,
          description: string,
          source_type_for_presentation: Enums.PresentationSourceType,
        } | {
          match_id: string,
          source_date: string,
          description: string,
          bill_ids: string[],
          transaction_ids: string[],
          source_type_for_presentation: Enums.PresentationSourceType,
        } | {
          transaction_id: string,
          source_date: string,
          description: string,
          relation_name: null | string,
          vat_code: Enums.VatCode | null,
          source_type_for_presentation: Enums.PresentationSourceType,
        })[],
        booking_id: string,
        booking_date: string,
        description: null | string,
        subledger: null | {
          id: string,
          name: string,
        },
      }[],
      document_settlements: {
        bill_ids: string[],
        invoice_number: null | string,
        relation_name: null | string,
        total_amount: object,
        open_amount: object,
        is_settled: boolean,
      }[],
      comparison: null | {
        signed_net: object,
        delta_ratio: null | number,
      },
      opening_balance_signed_net: null | object,
      warning: null | {
        reason: string,
        legal_entity_type: string,
      },
      subledger: null | {
        id: string,
        name: string,
      },
      subledger_split: boolean,
    }[],
  },
  balance_sheet: {
    rows: {
      id: string,
      kind: string,
      level: number,
      parent_id: null | string,
      label_key: null | string,
      amounts: {
        trial_balance: {
          debit_amount: object,
          credit_amount: object,
        },
        net_trial_balance: {
          debit_amount: object,
          credit_amount: object,
        },
        profit_and_loss: {
          debit_amount: object,
          credit_amount: object,
        },
        balance_sheet: {
          debit_amount: object,
          credit_amount: object,
        },
      },
      signed_net: object,
      growth_is_favourable: boolean | null,
      account: null | {
        code: string,
        label_nl: string,
      },
      lines: {
        debit_amount: object,
        credit_amount: object,
        sources: ({
          bill_id: string,
          source_date: string,
          description: string,
          document_id: null | string,
          file_name: null | string,
          relation_name: null | string,
          invoice_number: null | string,
          line_item_id: null | string,
          vat_rate_percentage: null | number,
          source_type_for_presentation: Enums.PresentationSourceType,
        } | {
          booking_id: string,
          source_date: string,
          description: string,
          line_id: string,
          source_type_for_presentation: Enums.PresentationSourceType,
        } | {
          fixed_asset_id: string,
          source_date: string,
          description: string,
          source_type_for_presentation: Enums.PresentationSourceType,
        } | {
          match_id: string,
          source_date: string,
          description: string,
          bill_ids: string[],
          transaction_ids: string[],
          source_type_for_presentation: Enums.PresentationSourceType,
        } | {
          transaction_id: string,
          source_date: string,
          description: string,
          relation_name: null | string,
          vat_code: Enums.VatCode | null,
          source_type_for_presentation: Enums.PresentationSourceType,
        })[],
        booking_id: string,
        booking_date: string,
        description: null | string,
        subledger: null | {
          id: string,
          name: string,
        },
      }[],
      document_settlements: {
        bill_ids: string[],
        invoice_number: null | string,
        relation_name: null | string,
        total_amount: object,
        open_amount: object,
        is_settled: boolean,
      }[],
      comparison: null | {
        signed_net: object,
        delta_ratio: null | number,
      },
      opening_balance_signed_net: null | object,
      warning: null | {
        reason: string,
        legal_entity_type: string,
      },
      subledger: null | {
        id: string,
        name: string,
      },
      subledger_split: boolean,
    }[],
  },
}



export type BACKENDPreHandleSyncApiV1PartnerGetClientVatDeclarationStatusesGetResponseBody = {
  clients: {
    business_id: string,
    status: Enums.ClientVATDeclarationStatusType,
    snapshot_id: null | string,
    period_start: null | string,
    period_end: null | string,
    approval_requested_at: null | string,
    approval_answered_at: null | string,
    approval_answered_by_name: null | string,
    approval_rejection_reason: null | string,
    approval_withdrawn_at: null | string,
    approval_withdrawn_by_name: null | string,
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerGetFixedAssetDetailsGetResponseBody = {
  id: string,
  name: string,
  purchase_date: string,
  purchase_value_cents: number,
  residual_value_cents: number,
  economic_lifetime_months: number,
  monthly_depreciation_cents: number,
  months_depreciated: number,
  book_value_cents: number,
  book_value_date: string,
  depreciation_end_date: null | string,
  balance_sheet_gl_account_id: string,
  balance_sheet_gl_account_label: string,
  profit_and_loss_gl_account_id: string,
  profit_and_loss_gl_account_label: string,
  subledger: null | {
    id: string,
    name: string,
  },
  linked_bill: null | {
    bill_id: string,
    document_id: string,
    relation_name: string,
    invoice_number: null | string,
    invoice_date: null | string,
    total_amount_payable: BackendAPITypes.Money | null,
  },
}



export type BACKENDPreHandleSyncApiV1PartnerGetFixedAssetsGetResponseBody = {
  items: {
    id: string,
    name: string,
    purchase_date: string,
    purchase_value_cents: number,
    residual_value_cents: number,
    economic_lifetime_months: number,
    balance_sheet_gl_account_id: string,
    profit_and_loss_gl_account_id: string,
    balance_sheet_gl_account_label: string,
    profit_and_loss_gl_account_label: string,
    subledger: null | {
      id: string,
      name: string,
    },
    linked_bill: null | {
      bill_id: string,
      document_id: string,
      relation_name: string,
      invoice_number: null | string,
      invoice_date: null | string,
      total_amount_payable: BackendAPITypes.Money | null,
    },
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerGetVatDeclarationSnapshotGetResponseBody = {
  subsection_1a_amount: BackendAPITypes.Money,
  subsection_1a_vat: BackendAPITypes.Money,
  subsection_1a_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_1a_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_1b_amount: BackendAPITypes.Money,
  subsection_1b_vat: BackendAPITypes.Money,
  subsection_1b_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_1b_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_1c_amount: BackendAPITypes.Money,
  subsection_1c_vat: BackendAPITypes.Money,
  subsection_1c_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_1d_amount: BackendAPITypes.Money,
  subsection_1d_vat: BackendAPITypes.Money,
  subsection_1d_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_1e_amount: BackendAPITypes.Money,
  subsection_1e_vat: BackendAPITypes.Money,
  subsection_1e_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_1e_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_2a_amount: BackendAPITypes.Money,
  subsection_2a_vat: BackendAPITypes.Money,
  subsection_2a_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_2a_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_3a: BackendAPITypes.Money,
  subsection_3a_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_3a_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_3b: BackendAPITypes.Money,
  subsection_3b_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_3b_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_3c: BackendAPITypes.Money,
  subsection_4a_amount: BackendAPITypes.Money,
  subsection_4a_vat: BackendAPITypes.Money,
  subsection_4a_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_4a_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_4b_amount: BackendAPITypes.Money,
  subsection_4b_vat: BackendAPITypes.Money,
  subsection_4b_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_4b_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_5a: BackendAPITypes.Money,
  subsection_5b: BackendAPITypes.Money,
  subsection_5b_bills: {
    id: string,
    document_id: string,
    file_name: string,
    relation_name: null | string,
    normalized_date: null | string,
    section_total_amount: BackendAPITypes.Money | null,
    section_net_amount: BackendAPITypes.Money | null,
    section_vat_amount: BackendAPITypes.Money | null,
  }[],
  subsection_5b_transactions: {
    id: string,
    booking_date: string,
    relation_name: null | string,
    description: null | string,
    net: BackendAPITypes.Money,
    vat: BackendAPITypes.Money,
    total: BackendAPITypes.Money,
  }[],
  subsection_5c: BackendAPITypes.Money,
  subsection_5d: BackendAPITypes.Money,
  subsection_5e: BackendAPITypes.Money,
  subsection_5f: BackendAPITypes.Money,
  subsection_5g: BackendAPITypes.Money,
  id: string,
  version: number,
  period_start: string,
  period_end: string,
  created_at: string,
  created_by: string,
  approval_request_id: null | string,
  approval_status: Enums.VATDeclarationApprovalStatus | null,
  approval_requested_at: null | string,
  approval_requested_by_name: null | string,
  approval_answered_at: null | string,
  approval_answered_by_name: null | string,
  approval_rejection_reason: null | string,
  approval_withdrawn_at: null | string,
  approval_withdrawn_by_name: null | string,
  unused_items: {
    id: string,
    document_id: string,
    bill_id: null | string,
    file_name: string,
    status: Enums.DocumentStatus | null,
    needs_review: boolean | null,
    document_direction: Enums.DocumentDirection | null,
    document_category: Enums.DocumentCategory | null,
    relation_name: null | string,
    normalized_date: null | string,
    total_amount_payable: BackendAPITypes.Money | null,
    leftover_line_item_ids: string[],
    is_matched: boolean,
  }[],
  completeness: {
    document_count: number,
    matched_count: number,
    matched_percentage: null | number,
  },
}



export type BACKENDPreHandleSyncApiV1PartnerGrantEntrepreneurAccessPostResponseBody = {
  message: string,
  success: boolean,
  data: null | object,
}



export type BACKENDPreHandleSyncApiV1PartnerInviteEntrepreneurPostResponseBody = {
  message: string,
  success: boolean,
  data: null | object,
}



export type BACKENDPreHandleSyncApiV1PartnerInviteTeammatePostResponseBody = {
  message: string,
  success: boolean,
  data: null | object,
}



export type BACKENDPreHandleSyncApiV1PartnerLinkFixedAssetToDocumentPostResponseBody = {
  document_id: string,
}



export type BACKENDPreHandleSyncApiV1PartnerLinkableEntrepreneursGetResponseBody = {
  entrepreneurs: {
    id: string,
    first_name: string,
    last_name: string,
    email: string,
    businesses: {
      business_id: string,
      business_name: string,
    }[],
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerListArchivedDocumentsGetResponseBody = {
  documents: {
    id: string,
    business_id: string,
    business_name: string,
    file_name: string,
    mime_type: string,
    created_at: string,
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerListClientBillsGetResponseBody = {
  bills: {
    id: string,
    bill_id: string,
    file_name: string,
    document_direction: string,
    document_category: string,
    needs_write_off: boolean,
    scanned_fields: object,
    business_id: string,
    business_name: string,
    relation_name: string,
    total_amount_payable: number,
    currency: Enums.CurrencyEnum,
    is_vat_ignored: boolean,
    created_at: string,
    reconciliation_id: null | string,
    is_matched: boolean,
    matching_exclusion_reason: null | string,
    monetary_origin: null | {
      original_fx_currency: Enums.CurrencyEnum,
      original_fx_total_amount_payable: BackendAPITypes.Money | null,
      original_fx_vat_amount_overall: BackendAPITypes.Money | null,
      fx_rate: null | string,
      fx_rate_market_date: null | string,
      fx_rate_source: string,
      fx_is_fallback: boolean,
    },
    fixed_asset_id: null | string,
    fixed_asset_name: null | string,
  }[],
  filter_options: {
    relations: {
      id: string,
      name: string,
      business_id: null | string,
    }[],
  },
}



export type BACKENDPreHandleSyncApiV1PartnerListCreditCardStatementsGetResponseBody = {
  credit_card_statements: {
    id: string,
    file_name: string,
    document_direction: string,
    document_category: string,
    business_id: string,
    business_name: string,
    created_at: string,
    is_credit_card_statement_settled: boolean,
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerListDocumentsToCheckGetResponseBody = {
  documents: {
    id: string,
    bill_id: null | string,
    reason: Enums.ToCheckReason | null,
    todos: Enums.BillTodoType[],
    business_id: string,
    business_name: string,
    file_name: string,
    mime_type: string,
    document_category: Enums.DocumentCategory | null,
    created_at: string,
    invoice_date: null | string,
    total_amount_payable: null | object,
    relation_name: null | string,
  }[],
  counts: {
    awaiting_scan: number,
    needs_category: number,
    needs_review: number,
  },
  outside_period_count: number,
}



export type BACKENDPreHandleSyncApiV1PartnerMakeManualBookingPostResponseBody = {
  message: string,
  success: boolean,
}



export type BACKENDPreHandleSyncApiV1PartnerManagedBusinessesBankAccountsGetResponseBody = {
  business_id: string,
  business_name: string,
  account_id: string,
  iban: null | string,
  currency: string,
  owner_name: string,
  institution_name: string,
  balance: number,
  connected_on: string,
  refreshed_on: string,
  last_transaction_full_sync_on: null | string,
  institution_logo_url: null | string,
  account_type: string,
  credit_card_number_prefix: null | string,
  credit_card_number_suffix: null | string,
}[]



export type BACKENDPreHandleSyncApiV1PartnerMyClientsGetResponseBody = {
  businesses: {
    id: string,
    name: string,
    fte_amount: number,
    managed_by: null | string,
    legal_entity_type: string,
    registration_number: string,
    industry: string,
    description: string,
    transaction_history_cutoff_date: null | string,
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerMyClientsListGetResponseBody = {
  businesses: {
    id: string,
    name: string,
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollAdministrationOptionsGetResponseBody = {
  administrations: {
    ref: string,
    name: string,
    number: string,
    employer_ref: string,
    employer_name: string,
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollAdministrationsAssignMappingPostResponseBody = {
  administration_id: string,
  mapping_id: string,
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollAdministrationsMappingCoverageGetResponseBody = {
  administration_id: string,
  mapping_id: string,
  all_gl_accounts: {
    code: string,
    description: string,
  }[],
  unmapped_gl_accounts: {
    code: string,
    description: string,
  }[],
  runs_covered: number,
  runs_total: number,
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollConnectSessionPostResponseBody = {
  connection_id: string,
  session_token: string,
  public_provider_url: string,
  api_provider_url: string,
  provider_config_key: string,
  expires_at: null | string,
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollConnectionCompletePostResponseBody = {
  connection_id: string,
  status: Enums.PayrollToolConnectionStatus,
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollConnectionReconnectCompletePostResponseBody = {
  connection_id: string,
  status: Enums.PayrollToolConnectionStatus,
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollCreatePayrollGlMappingPostResponseBody = {
  mapping_id: string,
  name: string,
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollGetPayrollAdministrationGetResponseBody = {
  administration_id: null | string,
  external_payroll_ref: null | string,
  external_employer_ref: null | string,
  administration_name: null | string,
  administration_number: null | string,
  mapping_id: null | string,
  mapping_name: null | string,
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollGetPayrollConnectionGetResponseBody = {
  connection_id: null | string,
  provider: Enums.PayrollProvider | null,
  name: null | string,
  status: Enums.PayrollToolConnectionStatus | null,
  is_connected: boolean,
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollGetPayrollGlMappingGetResponseBody = {
  mapping_id: string,
  name: string,
  used_by_count: number,
  rules: {
    external_gl_account_code: string,
    external_gl_account_description: string,
    gl_account: string,
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingRulesPostResponseBody = {
  mapping_id: string,
  external_gl_account_code: string,
  external_gl_account_description: string,
  gl_account: string,
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingRulesRemovePostResponseBody = {
  mapping_id: string,
  external_gl_account_code: string,
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingsListGetResponseBody = {
  mappings: {
    mapping_id: string,
    name: string,
    used_by_count: number,
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingsRenamePostResponseBody = {
  mapping_id: string,
  name: string,
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollImportsHistoryGetResponseBody = {
  imports: {
    import_id: string,
    administration_id: string,
    run_ref: string,
    run_sequence_number: number,
    period_start: string,
    period_end: string,
    status: string,
    created_at: any[] | boolean | number | object | string,
    posted_at: any[] | boolean | number | object | string | null,
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollImportsPostResponseBody = {
  results: {
    run_ref: string,
    period_start: string,
    period_end: string,
    status: string,
    import_id: string,
    unmapped_gl_accounts: {
      code: string,
      description: string,
    }[],
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollImportsUnmappedGlAccountsGetResponseBody = {
  import_id: string,
  administration_id: string,
  run_ref: string,
  period_start: string,
  period_end: string,
  unmapped_gl_accounts: {
    code: string,
    description: string,
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollLinkPayrollAdministrationPostResponseBody = {
  administration_id: string,
  business_id: string,
  connection_id: string,
  external_payroll_ref: string,
  external_employer_ref: string,
  administration_name: string,
  administration_number: string,
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollListAvailableProvidersGetResponseBody = {
  providers: {
    provider: Enums.PayrollProvider,
    name: string,
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollReconnectSessionPostResponseBody = {
  connection_id: string,
  session_token: string,
  public_provider_url: string,
  api_provider_url: string,
  provider_config_key: string,
  expires_at: null | string,
}



export type BACKENDPreHandleSyncApiV1PartnerPayrollTestConnectionPostResponseBody = {
  ok: boolean,
  status_code: number,
}



export type BACKENDPreHandleSyncApiV1PartnerProcessCreditCardSettlementPostResponseBody = {
  message: string,
  success: boolean,
  data: null | object,
}



export type BACKENDPreHandleSyncApiV1PartnerRecategorizeDocumentPostResponseBody = {
  message: string,
  success: boolean,
  data: null | object,
}



export type BACKENDPreHandleSyncApiV1PartnerRefineVatIgnorePromptPostResponseBody = {
  refined_prompt: string,
}



export type BACKENDPreHandleSyncApiV1PartnerRefreshClientTrialBalanceCachePostResponseBody = {
  business_id: string,
  invalidated_count: number,
}



export type BACKENDPreHandleSyncApiV1PartnerRenameClientSubledgerPostResponseBody = {
  id: string,
  business_id: string,
  name: string,
}



export type BACKENDPreHandleSyncApiV1PartnerRequestVatDeclarationApprovalPostResponseBody = {
  id: string,
  snapshot_id: string,
  status: Enums.VATDeclarationApprovalStatus,
  requested_by: string,
  requested_at: string,
}



export type BACKENDPreHandleSyncApiV1PartnerSaveVatDeclarationSnapshotPostResponseBody = {
  id: string,
  version: number,
  period_start: string,
  period_end: string,
  created_at: string,
  created_by: string,
}



export type BACKENDPreHandleSyncApiV1PartnerTeammatesGetResponseBody = {
  members: {
    id: string,
    first_name: string,
    last_name: string,
    email: string,
    role: string,
  }[],
  pending_invitations: {
    email: string,
    created_at: string,
  }[],
}



export type BACKENDPreHandleSyncApiV1PartnerTransactionsCategorizationChangePostResponseBody = {
  transaction_id: string,
  source: string,
  changed_on: string,
  human_user_id: null | string,
  human_display_name: null | string,
  automation_rule_id: null | string,
}[]



export type BACKENDPreHandleSyncApiV1PartnerTransactionsGetResponseBody = {
  items: {
    account_id: string,
    transaction_id: string,
    booking_date: string,
    relation_name: string,
    relation_iban: string,
    amount: number,
    flow: string,
    currency: string,
    desc: string,
    general_ledger_account_id: null | string,
    general_ledger_account: {
      id: string,
      icon: null | string,
      label_nl: string,
      cashflow_subcategory_nl: string,
    },
    reconciliation_id: null | string,
    matching_exclusion_reason: null | string,
    vat_code: null | string,
    vat_direction: null | string,
    subledger: null | {
      id: string,
      name: string,
    },
    mdr_status: {
      is_mdr: boolean,
      exclusion_reason: Enums.MdrExclusionReason | null,
      automation_rule_id: null | string,
    },
  }[],
  next_cursor: null | string,
  has_more: boolean,
  total: null | number,
}



export type BACKENDPreHandleSyncApiV1PartnerUnlinkFixedAssetFromDocumentPostResponseBody = {
  document_id: string,
}



export type BACKENDPreHandleSyncApiV1PartnerUnmatchedTransactionsCreateBacklistRulePostResponseBody = object



export type BACKENDPreHandleSyncApiV1PartnerWithdrawVatDeclarationApprovalRequestPostResponseBody = {
  id: string,
  status: Enums.VATDeclarationApprovalStatus,
}



export type BACKENDPreHandleSyncApiV1PublicSendResetPasswordEmailPostResponseBody = {
  message: string,
  success: boolean,
  data: null | object,
}



export type BACKENDPreHandleSyncApiV1QuinnGetChatGetResponseBody = {
  quinn_chat: {
    id: string,
    user_id: string,
    business_id: string,
    message_history: {
      content: string,
      role: Enums.QuinnChatRoleEnum,
      created_at: string,
      id: string,
      sources: {
        transactions: object[],
        documents: object[],
        forecasts: object[],
      }[],
      action_type: Enums.QuinnChatActionTypeEnum | null,
      context: object[],
      run_id: null | string,
    }[],
    created_at: null | string,
    client_business_id: null | string,
    title: null | string,
    client_scope: Enums.QuinnChatScopeEnum,
  },
  ratings: object,
}



export type BACKENDPreHandleSyncApiV1QuinnGetRunStatusGetResponseBody = {
  id: string,
  chat_id: string,
  status: Enums.QuinnRunStatusEnum,
  steps: {
    id: string,
    step_index: number,
    step_type: Enums.QuinnRunStepTypeEnum,
    label: string,
    created_at: string,
  }[],
  answer: null | string,
  artifacts: object[],
  needs_clarification: boolean,
  prompt: null | {
    kind: string,
    question: string,
    help_text: null | string,
    options: {
      value: string,
      label: string,
      hint: null | string,
    }[],
    multiple: boolean,
    allow_free_text: boolean,
  },
  sources: {
    document_id: string,
    business_id: string,
    file_name: null | string,
    document_category: Enums.DocumentCategory | null,
    document_direction: Enums.DocumentDirection | null,
    counterparty: null | string,
    document_date: null | string,
    page_from: null | number,
    page_to: null | number,
  }[],
}



export type BACKENDPreHandleSyncApiV1QuinnListSessionsGetResponseBody = {
  sessions: {
    id: string,
    title: null | string,
    client_business_id: null | string,
    client_scope: Enums.QuinnChatScopeEnum,
    created_at: string,
    last_message_at: string,
  }[],
}



export type BACKENDPreHandleSyncApiV1QuinnRateAnswerPostResponseBody = {
  run_id: string,
  rating: Enums.QuinnRatingEnum | null,
}



export type BACKENDPreHandleSyncApiV1QuinnSendMessagePostResponseBody = {
  quinn_chat_message: {
    content: string,
    role: Enums.QuinnChatRoleEnum,
    created_at: string,
    id: string,
    sources: {
      transactions: object[],
      documents: object[],
      forecasts: object[],
    }[],
    action_type: Enums.QuinnChatActionTypeEnum | null,
    context: object[],
    run_id: null | string,
  },
  chat_id: string,
}



export type BACKENDPreHandleSyncApiV1QuinnStartRunPostResponseBody = {
  run_id: string,
  chat_id: string,
  status: Enums.QuinnRunStatusEnum,
}



export type BACKENDPreHandleSyncApiV1ReconciliationGetMatchDetailsByDocumentIdGetResponseBody = {
  match_id: string,
  transaction_parts: {
    id: string,
    date: string,
    relation_name: null | string,
    description: string,
    bank_account_name: string,
    bank_logo_url: string,
    amount: number,
    flow: string,
    currency: string,
    relation_iban: null | string,
    nrs_amount: number,
  }[],
  bill_parts: {
    id: string,
    document_id: string,
    relation_name: null | string,
    date: null | string,
    reference_identifier: null | string,
    file_name: string,
    amount: number,
    direction: Enums.DocumentDirection,
    currency: string,
    nrs_amount: number,
  }[],
  is_completed: boolean,
  created_at: null | string,
  completed_at: null | string,
  matching_reason: null | string,
  created_by_name: null | string,
  business_id: null | string,
  difference_booking_date: null | string,
  difference_booking_reason: null | string,
  difference_booking_gla_id: null | string,
  difference_booking_gla_label: null | string,
  nrs_remainder: number,
}



export type BACKENDPreHandleSyncApiV1ReconciliationGetMatchDetailsGetResponseBody = {
  match_id: string,
  transaction_parts: {
    id: string,
    date: string,
    relation_name: null | string,
    description: string,
    bank_account_name: string,
    bank_logo_url: string,
    amount: number,
    flow: string,
    currency: string,
    relation_iban: null | string,
    nrs_amount: number,
  }[],
  bill_parts: {
    id: string,
    document_id: string,
    relation_name: null | string,
    date: null | string,
    reference_identifier: null | string,
    file_name: string,
    amount: number,
    direction: Enums.DocumentDirection,
    currency: string,
    nrs_amount: number,
  }[],
  is_completed: boolean,
  created_at: null | string,
  completed_at: null | string,
  matching_reason: null | string,
  created_by_name: null | string,
  business_id: null | string,
  difference_booking_date: null | string,
  difference_booking_reason: null | string,
  difference_booking_gla_id: null | string,
  difference_booking_gla_label: null | string,
  nrs_remainder: number,
}



export type BACKENDPreHandleSyncApiV1ReconciliationManuallyAddPartsMatchPostResponseBody = {
  message: string,
  success: boolean,
}



export type BACKENDPreHandleSyncApiV1ReconciliationManuallyMatchPostResponseBody = {
  match_id: string,
}



export type BACKENDPreHandleSyncApiV1ReconciliationManuallyUnmatchPostResponseBody = {
  match: {
    id: string,
    bills: {
      _bills: {
        id: string,
        is_reconciled: boolean,
        business_id: string,
        business_name: string,
        signed_amount: object,
        direction: Enums.DocumentDirection,
        normalized_date: null | string,
      }[],
    },
    transactions: {
      _transactions: {
        id: string,
        is_reconciled: boolean,
        business_id: string,
        business_name: string,
        signed_amount: object,
        booking_date: null | string,
      }[],
    },
    created_at: string,
    created_by: string,
    rule: null | string,
    matching_reason: Enums.MatchingReasonEnum | null,
    updated_at: string,
    updated_by: string,
    deleted_at: null | string,
    deleted_by: null | string,
    is_manually_completed: boolean,
    is_completed: boolean,
    completed_at: null | string,
    difference_booking_date: null | string,
    difference_booking_reason: null | string,
    difference_booking_gla_id: null | string,
  },
  message: string,
  success: boolean,
}



export type BACKENDPreHandleSyncApiV1ReconciliationMarkMatchManuallyCompletedPostResponseBody = {
  message: string,
  success: boolean,
  data: null | object,
}



export type BACKENDPreHandleSyncApiV1RegisterCallbackPostResponseBody = {
  message: string,
  success: boolean,
}



export type BACKENDPreHandleSyncApiV1RoDeveloperGetAllDocumentsGetResponseBody = {
  id: string,
  file_name: string,
  mime_type: string,
  document_type: Enums.DocumentType,
  size: number,
  created_at: string,
  updated_at: string,
  uploaded_by: string,
  business_id: string,
  document_direction: Enums.DocumentDirection | null,
  shared_via: Enums.SharingMethod | null,
  file_hash: null | string,
  is_duplicate: boolean,
  document_category: Enums.DocumentCategory | null,
  status: Enums.DocumentStatus,
  is_vat_ignored: boolean,
  needs_review: boolean,
  review_context: null | object,
  scanned_fields: null | {
    seller_name: string,
    total_amount_payable: BackendAPITypes.Money | null,
    other_dates: string[],
    vat_number: null | string,
    normalized_datetime: string,
    has_time: boolean,
    payment_term: null | number,
    normalized_due_date: null | string,
    is_vat_exempt: boolean | null,
    reference_identifier: null | string,
    payment_reference: null | string,
    seller_iban: null | string,
    buyer_name: null | string,
    buyer_iban: null | string,
    characteristics: null | string,
    time: null | string,
    date: null | string,
    vat_amount_overall: BackendAPITypes.Money | null,
    vat_reverse_charge_applied: boolean | null,
    is_credit_note: boolean | null,
    vat_breakdown_details: null | {
      vat_rate_percentage_applied: null | number,
      net_amount_at_this_rate: null | number,
      vat_amount_at_this_rate: null | number,
    }[],
    due_date: null | string,
  },
}[]



export type BACKENDPreHandleSyncApiV1RoDeveloperGetDocumentGetResponseBody = {
  file_name: string,
  mimetype: string,
  document_category: string,
  document_direction: string,
  is_matched: boolean,
  shared_via: null | string,
  status: string,
  is_duplicate: boolean,
  is_vat_ignored: boolean,
  scanned_fields: null | {
    seller_name: string,
    total_amount_payable: BackendAPITypes.Money | null,
    other_dates: string[],
    vat_number: null | string,
    normalized_datetime: string,
    has_time: boolean,
    payment_term: null | number,
    normalized_due_date: null | string,
    is_vat_exempt: boolean | null,
    reference_identifier: null | string,
    payment_reference: null | string,
    seller_iban: null | string,
    buyer_name: null | string,
    buyer_iban: null | string,
    characteristics: null | string,
    time: null | string,
    date: null | string,
    vat_amount_overall: BackendAPITypes.Money | null,
    vat_reverse_charge_applied: boolean | null,
    is_credit_note: boolean | null,
    vat_breakdown_details: null | {
      vat_rate_percentage_applied: null | number,
      net_amount_at_this_rate: null | number,
      vat_amount_at_this_rate: null | number,
    }[],
    due_date: null | string,
  },
  line_items: {
    id: string,
    net_amount: null | object,
    bill_id: string,
    created_at: null | string,
    updated_at: null | string,
    description: null | string,
    quantity: null | number,
    unit_price_net: null | object,
    vat_rate_percentage: null | number,
    vat_amount: null | object,
    total_amount: null | object,
    discount_percentage: null | number,
    custom_reference: null | string,
    service_start_date: null | string,
    service_end_date: null | string,
    line_item_id: null | string,
    vat_id: null | string,
    name: null | string,
    category: null | {
      id: string,
      rgs_number: string,
      rgs_level: number,
      rgs_official_label: string,
      ranking: number,
      label: string,
      label_nl: string,
      reporting_class: Enums.ReportingClass,
      reporting_financial_statement_element: Enums.ReportingFinancialStatementElement,
      normal_balance_direction: Enums.NormalBalance,
      legacy_bankcat: Enums.BankCategory,
      legacy_bankcat_nl: string,
      cashflow_subcategory: Enums.CashflowSubcategory,
      cashflow_subcategory_nl: string,
      cashflow_category: Enums.CashflowCategory | null,
      cashflow_category_nl: null | string,
      bill_line_item_classification_instruction: null | string,
      transaction_classification_instruction: null | string,
      notes_from_author: null | string,
      applicable_legal_entity_type: Enums.LegalEntityType[],
      applicable_bill_direction: Enums.DocumentDirection | null,
      expected_trigger_event: Enums.TriggerEvent | null,
      expected_document_type: Enums.DocumentCategory[],
      icon: null | string,
      section: Enums.SbsSection,
    },
    is_physical_good: boolean | null,
    is_vat_exempt: boolean | null,
    subledger_id: null | string,
    subledger: null | {
      id: string,
      name: string,
    },
    transitory_schedule: null | {
      start_month: string,
      end_month: string,
    },
    original_fx_net_amount: null | object,
    original_fx_vat_amount: null | object,
    original_fx_total_amount: null | object,
    original_fx_unit_price_net: null | object,
  }[],
  is_booked: boolean,
  relation: null | {
    id: string,
    name: string,
  },
  is_incomplete: boolean,
  needs_review: boolean,
  review_context: null | object,
}



export type BACKENDPreHandleSyncApiV1RoDeveloperGetPartnersGetResponseBody = {
  business_id: string,
  name: string,
}[]



export type BACKENDPreHandleSyncApiV1TransactionsBookAsPrivatePostResponseBody = {
  message: string,
  success: boolean,
  data: null | object,
}



}



var MD5 = function(d){var r = M(V(Y(X(d),8*d.length)));return r.toLowerCase()};function M(d){for(var _,m="0123456789ABCDEF",f="",r=0;r<d.length;r++)_=d.charCodeAt(r),f+=m.charAt(_>>>4&15)+m.charAt(15&_);return f}function X(d){for(var _=Array(d.length>>2),m=0;m<_.length;m++)_[m]=0;for(m=0;m<8*d.length;m+=8)_[m>>5]|=(255&d.charCodeAt(m/8))<<m%32;return _}function V(d){for(var _="",m=0;m<32*d.length;m+=8)_+=String.fromCharCode(d[m>>5]>>>m%32&255);return _}function Y(d,_){d[_>>5]|=128<<_%32,d[14+(_+64>>>9<<4)]=_;for(var m=1732584193,f=-271733879,r=-1732584194,i=271733878,n=0;n<d.length;n+=16){var h=m,t=f,g=r,e=i;f=md5_ii(f=md5_ii(f=md5_ii(f=md5_ii(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_hh(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_gg(f=md5_ff(f=md5_ff(f=md5_ff(f=md5_ff(f,r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+0],7,-680876936),f,r,d[n+1],12,-389564586),m,f,d[n+2],17,606105819),i,m,d[n+3],22,-1044525330),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+4],7,-176418897),f,r,d[n+5],12,1200080426),m,f,d[n+6],17,-1473231341),i,m,d[n+7],22,-45705983),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+8],7,1770035416),f,r,d[n+9],12,-1958414417),m,f,d[n+10],17,-42063),i,m,d[n+11],22,-1990404162),r=md5_ff(r,i=md5_ff(i,m=md5_ff(m,f,r,i,d[n+12],7,1804603682),f,r,d[n+13],12,-40341101),m,f,d[n+14],17,-1502002290),i,m,d[n+15],22,1236535329),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+1],5,-165796510),f,r,d[n+6],9,-1069501632),m,f,d[n+11],14,643717713),i,m,d[n+0],20,-373897302),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+5],5,-701558691),f,r,d[n+10],9,38016083),m,f,d[n+15],14,-660478335),i,m,d[n+4],20,-405537848),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+9],5,568446438),f,r,d[n+14],9,-1019803690),m,f,d[n+3],14,-187363961),i,m,d[n+8],20,1163531501),r=md5_gg(r,i=md5_gg(i,m=md5_gg(m,f,r,i,d[n+13],5,-1444681467),f,r,d[n+2],9,-51403784),m,f,d[n+7],14,1735328473),i,m,d[n+12],20,-1926607734),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+5],4,-378558),f,r,d[n+8],11,-2022574463),m,f,d[n+11],16,1839030562),i,m,d[n+14],23,-35309556),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+1],4,-1530992060),f,r,d[n+4],11,1272893353),m,f,d[n+7],16,-155497632),i,m,d[n+10],23,-1094730640),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+13],4,681279174),f,r,d[n+0],11,-358537222),m,f,d[n+3],16,-722521979),i,m,d[n+6],23,76029189),r=md5_hh(r,i=md5_hh(i,m=md5_hh(m,f,r,i,d[n+9],4,-640364487),f,r,d[n+12],11,-421815835),m,f,d[n+15],16,530742520),i,m,d[n+2],23,-995338651),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+0],6,-198630844),f,r,d[n+7],10,1126891415),m,f,d[n+14],15,-1416354905),i,m,d[n+5],21,-57434055),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+12],6,1700485571),f,r,d[n+3],10,-1894986606),m,f,d[n+10],15,-1051523),i,m,d[n+1],21,-2054922799),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+8],6,1873313359),f,r,d[n+15],10,-30611744),m,f,d[n+6],15,-1560198380),i,m,d[n+13],21,1309151649),r=md5_ii(r,i=md5_ii(i,m=md5_ii(m,f,r,i,d[n+4],6,-145523070),f,r,d[n+11],10,-1120210379),m,f,d[n+2],15,718787259),i,m,d[n+9],21,-343485551),m=safe_add(m,h),f=safe_add(f,t),r=safe_add(r,g),i=safe_add(i,e)}return Array(m,f,r,i)}function md5_cmn(d,_,m,f,r,i){return safe_add(bit_rol(safe_add(safe_add(_,d),safe_add(f,i)),r),m)}function md5_ff(d,_,m,f,r,i,n){return md5_cmn(_&m|~_&f,d,_,r,i,n)}function md5_gg(d,_,m,f,r,i,n){return md5_cmn(_&f|m&~f,d,_,r,i,n)}function md5_hh(d,_,m,f,r,i,n){return md5_cmn(_^m^f,d,_,r,i,n)}function md5_ii(d,_,m,f,r,i,n){return md5_cmn(m^(_|~f),d,_,r,i,n)}function safe_add(d,_){var m=(65535&d)+(65535&_);return(d>>16)+(_>>16)+(m>>16)<<16|65535&m}function bit_rol(d,_){return d<<_|d>>>32-_}


// Canonical, order-independent JSON serialization so the frontend and the generator
// hash the exact same bytes (matches Python json.dumps(sort_keys, separators, ensure_ascii=False)).
function canonicalStringify(value) {
    if (value === null || typeof value !== 'object') return JSON.stringify(value)
    if (Array.isArray(value)) return '[' + value.map(canonicalStringify).join(',') + ']'
    return '{' + Object.keys(value).sort().map(key => JSON.stringify(key) + ':' + canonicalStringify(value[key])).join(',') + '}'
}

function blueprintChecksum(spec) {
    return MD5(unescape(encodeURIComponent(canonicalStringify(spec))))
}

function showBlueprintOutOfSyncBanner() {
    const bannerId = 'tfic-blueprint-out-of-sync-banner'
    if (document.getElementById(bannerId)) return

    const banner = document.createElement('div')
    banner.id = bannerId
    banner.style.cssText = 'position:fixed;top:0;left:0;right:0;z-index:2147483647;display:flex;align-items:center;justify-content:center;gap:16px;background:#b45309;color:#fff;padding:10px 16px;font-family:system-ui,sans-serif;font-size:13px;text-align:center;box-shadow:0 2px 6px rgba(0,0,0,0.25)'

    const message = document.createElement('span')
    message.textContent = 'tfic-blueprint: the frontend is using an outdated blueprint. Run "make blueprint" (or start the blueprint watcher) to regenerate.'

    const dismiss = document.createElement('button')
    dismiss.textContent = 'Dismiss'
    dismiss.style.cssText = 'background:rgba(255,255,255,0.2);border:none;color:#fff;padding:2px 10px;border-radius:4px;cursor:pointer;font-size:12px'
    dismiss.onclick = () => banner.remove()

    banner.appendChild(message)
    banner.appendChild(dismiss)
    document.body.prepend(banner)
}

if ((!process.env.NODE_ENV || process.env.NODE_ENV === 'development') && typeof document !== 'undefined') {
    fetch('http://localhost:5001/openapi.json', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(res => res.text()).then(text => {
        const localChecksum = blueprintChecksum(JSON.parse(text))

        if (localChecksum !== OPENAPI_SPEC_CHECKSUM) {
            console.warn(`tfic-blueprint: outdated blueprint. Local checksum: ${localChecksum}, remote checksum: ${OPENAPI_SPEC_CHECKSUM}`)
            showBlueprintOutOfSyncBanner()
        }
    }).catch(() => {})
}

export class Non200ResponseError extends Error {
    public detail: any;
    public status: number;
    constructor(message: string, detail: any, status: number) {
        super(message);
        this.name = "Non200ResponseError";
        this.detail = detail;
        this.status = status;
        Object.setPrototypeOf(this, Non200ResponseError.prototype);
    }
}
    
export abstract class BackendAPIBlueprint {
    
    async post(path: string, data: any, signal?: AbortSignal): Promise<any> {
        throw new Error('Method not implemented! Use derived class');
    }
    
    async get(path: string, data: any, signal?: AbortSignal): Promise<any> {
        throw new Error('Method not implemented! Use derived class');
    }
    
    
    
    
    // POST access-control/user/send-email-verification-email
    async AccessControl__user__sendEmailVerificationEmail(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1AccessControlUserSendEmailVerificationEmailPostRequestBody
    ): Promise<any> {
        const response = await this.post('access-control/user/send-email-verification-email', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET access-control/users
    async AccessControl__users(
      data: any
    ): Promise<any> {
        const response = await this.get('access-control/users', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET access-control/who-am-i
    async AccessControl__whoAmI(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1AccessControlWhoAmIGetResponseBody> {
        const response = await this.get('access-control/who-am-i', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET admin/business/bank-accounts
    async Admin__business__bankAccounts(
        business_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminBusinessBankAccountsGetResponseBody> {
        const response = await this.get('admin/business/bank-accounts', {business_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET admin/business/flags
    async Admin__business__flags(
        business_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminBusinessFlagsGetResponseBody> {
        const response = await this.get('admin/business/flags', {business_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST admin/business/update-flag
    async Admin__business__updateFlag(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1AdminBusinessUpdateFlagPostRequestBody
    ): Promise<any> {
        const response = await this.post('admin/business/update-flag', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET admin/business/uploaded-documents
    async Admin__business__uploadedDocuments(
        business_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminBusinessUploadedDocumentsGetResponseBody> {
        const response = await this.get('admin/business/uploaded-documents', {business_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET admin/businesses
    async Admin__businesses(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminBusinessesGetResponseBody> {
        const response = await this.get('admin/businesses', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST admin/get-user-details
    async Admin__getUserDetails(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1AdminGetUserDetailsPostRequestBody
    ): Promise<any> {
        const response = await this.post('admin/get-user-details', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST admin/grant-business-access
    async Admin__grantBusinessAccess(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1AdminGrantBusinessAccessPostRequestBody
    ): Promise<any> {
        const response = await this.post('admin/grant-business-access', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET admin/graph/business/get-daily-balance-with-forecast
    async Admin__graph__business__getDailyBalanceWithForecast(
        business_id: string, 
        bank_account_id: string, 
        start_date?: null | string, 
        end_date?: null | string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminGraphBusinessGetDailyBalanceWithForecastGetResponseBody> {
        const response = await this.get('admin/graph/business/get-daily-balance-with-forecast', {business_id, bank_account_id, start_date, end_date})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST admin/insights/create-insight
    async Admin__insights__createInsight(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1AdminInsightsCreateInsightPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminInsightsCreateInsightPostResponseBody> {
        const response = await this.post('admin/insights/create-insight', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET admin/partner/demo
    async Admin__partner__demo(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminPartnerDemoGetResponseBody> {
        const response = await this.get('admin/partner/demo', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST admin/partner/demo/configure
    async Admin__partner__demo__configure(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1AdminPartnerDemoConfigurePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminPartnerDemoConfigurePostResponseBody> {
        const response = await this.post('admin/partner/demo/configure', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST admin/revoke-business-access
    async Admin__revokeBusinessAccess(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1AdminRevokeBusinessAccessPostRequestBody
    ): Promise<any> {
        const response = await this.post('admin/revoke-business-access', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST bank-account/add-credit-card
    async BankAccount__addCreditCard(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1BankAccountAddCreditCardPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1BankAccountAddCreditCardPostResponseBody> {
        const response = await this.post('bank-account/add-credit-card', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST bank-account/add-savings-account
    async BankAccount__addSavingsAccount(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1BankAccountAddSavingsAccountPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1BankAccountAddSavingsAccountPostResponseBody> {
        const response = await this.post('bank-account/add-savings-account', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET bank-account/my-bank-accounts
    async BankAccount__myBankAccounts(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1BankAccountMyBankAccountsGetResponseBody> {
        const response = await this.get('bank-account/my-bank-accounts', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET bank/logo
    async Bank__logo(
        bank_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1BankLogoGetResponseBody> {
        const response = await this.get('bank/logo', {bank_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET business/bank-transactions
    async Business__bankTransactions(
        business_id: string, 
        order_by?: null | string, 
        order_descending?: boolean | null, 
        page: number = 0, 
        page_size: number = 100
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessBankTransactionsGetResponseBody> {
        const response = await this.get('business/bank-transactions', {business_id, order_by, order_descending, page, page_size})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET business/cashflow-statement
    async Business__cashflowStatement(
        business_id: string, 
        bank_account_id?: null | string
    ): Promise<any> {
        const response = await this.get('business/cashflow-statement', {business_id, bank_account_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET business/connect-financial-service
    async Business__connectFinancialService(
        app_hostname?: null | string, 
        institution_id: string = "PAYMENT_MOLLIE_NL"
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessConnectFinancialServiceGetResponseBody> {
        const response = await this.get('business/connect-financial-service', {app_hostname, institution_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET business/get-monthly-summary
    async Business__getMonthlySummary(
        year: number, 
        month: number, 
        bank_account_id?: null | string
    ): Promise<any> {
        const response = await this.get('business/get-monthly-summary', {year, month, bank_account_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST business/invoice/generate-from-prompt
    async Business__invoice__generateFromPrompt(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessInvoiceGenerateFromPromptPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessInvoiceGenerateFromPromptPostResponseBody> {
        const response = await this.post('business/invoice/generate-from-prompt', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST business/mark-connection-complete
    async Business__markConnectionComplete(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessMarkConnectionCompletePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessMarkConnectionCompletePostResponseBody> {
        const response = await this.post('business/mark-connection-complete', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET business/my-business
    async Business__myBusiness(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessMyBusinessGetResponseBody> {
        const response = await this.get('business/my-business', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET business/my-connections
    async Business__myConnections(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessMyConnectionsGetResponseBody> {
        const response = await this.get('business/my-connections', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET business/my-subscriptions
    async Business__mySubscriptions(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessMySubscriptionsGetResponseBody> {
        const response = await this.get('business/my-subscriptions', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET business/relations/all-relations
    async Business__relations__allRelations(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessRelationsAllRelationsGetResponseBody> {
        const response = await this.get('business/relations/all-relations', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET business/stats/base-stats
    async Business__stats__baseStats(
      data: any
    ): Promise<any> {
        const response = await this.get('business/stats/base-stats', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET business/stats/get-monthly-transaction-category-breakdown
    async Business__stats__getMonthlyTransactionCategoryBreakdown(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessStatsGetMonthlyTransactionCategoryBreakdownGetResponseBody> {
        const response = await this.get('business/stats/get-monthly-transaction-category-breakdown', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET business/stats/iob-graph-data
    async Business__stats__iobGraphData(
        bank_account_id?: null | string, 
        start_date?: null | string, 
        end_date?: null | string
    ): Promise<any> {
        const response = await this.get('business/stats/iob-graph-data', {bank_account_id, start_date, end_date})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET business/stats/month-overview
    async Business__stats__monthOverview(
        year: number, 
        month: number, 
        bank_account_id?: null | string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessStatsMonthOverviewGetResponseBody> {
        const response = await this.get('business/stats/month-overview', {year, month, bank_account_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET business/tax/history
    async Business__tax__history(
        business_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessTaxHistoryGetResponseBody> {
        const response = await this.get('business/tax/history', {business_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST categorization-engine/exclude-transaction-from-matching
    async CategorizationEngine__excludeTransactionFromMatching(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1CategorizationEngineExcludeTransactionFromMatchingPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1CategorizationEngineExcludeTransactionFromMatchingPostResponseBody> {
        const response = await this.post('categorization-engine/exclude-transaction-from-matching', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST categorization-engine/recategorize-transaction
    async CategorizationEngine__recategorizeTransaction(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1CategorizationEngineRecategorizeTransactionPostRequestBody
    ): Promise<any> {
        const response = await this.post('categorization-engine/recategorize-transaction', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST categorization-engine/undo-book-away
    async CategorizationEngine__undoBookAway(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1CategorizationEngineUndoBookAwayPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1CategorizationEngineUndoBookAwayPostResponseBody> {
        const response = await this.post('categorization-engine/undo-book-away', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET catestial/base-transactions
    async Catestial__baseTransactions(
        bank_account_id?: null | string, 
        onlyUncategorized: boolean = false, 
        page: number = 0, 
        page_size: number = 100
    ): Promise<any> {
        const response = await this.get('catestial/base-transactions', {bank_account_id, onlyUncategorized, page, page_size})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET catestial/base-transactions/count
    async Catestial__baseTransactions__count(
        bank_account_id?: null | string, 
        relation_iban?: null | string, 
        relation_name?: null | string
    ): Promise<any> {
        const response = await this.get('catestial/base-transactions/count', {bank_account_id, relation_iban, relation_name})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET catestial/base-transactions/{transaction_id}
    async Catestial__baseTransactions__NOTSUPPORTEDtransactionIdNOTSUPPORTED(
        transaction_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1CatestialBaseTransactionsTransactionIdGetResponseBody> {
        const response = await this.get('catestial/base-transactions/{transaction_id}', {transaction_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST catestial/bulk/categorize-transactions
    async Catestial__bulk__categorizeTransactions(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1CatestialBulkCategorizeTransactionsPostRequestBody
    ): Promise<any> {
        const response = await this.post('catestial/bulk/categorize-transactions', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST catestial/categorize-transactions
    async Catestial__categorizeTransactions(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1CatestialCategorizeTransactionsPostRequestBody
    ): Promise<any> {
        const response = await this.post('catestial/categorize-transactions', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST cron/document-collection/process-documents
    async Cron__documentCollection__processDocuments(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1CronDocumentCollectionProcessDocumentsPostResponseBody> {
        const response = await this.post('cron/document-collection/process-documents', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST cron/document-collection/reprocess-documents-in-error
    async Cron__documentCollection__reprocessDocumentsInError(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1CronDocumentCollectionReprocessDocumentsInErrorPostResponseBody> {
        const response = await this.post('cron/document-collection/reprocess-documents-in-error', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST cron/document-forward/forward-pending-documents
    async Cron__documentForward__forwardPendingDocuments(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1CronDocumentForwardForwardPendingDocumentsPostResponseBody> {
        const response = await this.post('cron/document-forward/forward-pending-documents', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST cron/import-open-banking-data
    async Cron__importOpenBankingData(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1CronImportOpenBankingDataPostResponseBody> {
        const response = await this.post('cron/import-open-banking-data', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST cron/process-budgets-for-all-businesses
    async Cron__processBudgetsForAllBusinesses(
      data: any
    ): Promise<any> {
        const response = await this.post('cron/process-budgets-for-all-businesses', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST cron/process-insights
    async Cron__processInsights(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1CronProcessInsightsPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1CronProcessInsightsPostResponseBody> {
        const response = await this.post('cron/process-insights', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST cron/quinn/reap-abandoned-runs
    async Cron__quinn__reapAbandonedRuns(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1CronQuinnReapAbandonedRunsPostResponseBody> {
        const response = await this.post('cron/quinn/reap-abandoned-runs', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST cron/run-transaction-processing-pipeline
    async Cron__runTransactionProcessingPipeline(
      data: any
    ): Promise<any> {
        const response = await this.post('cron/run-transaction-processing-pipeline', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST cron/trigger-reconciliation
    async Cron__triggerReconciliation(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1CronTriggerReconciliationPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1CronTriggerReconciliationPostResponseBody> {
        const response = await this.post('cron/trigger-reconciliation', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET customer-bank-account
    async CustomerBankAccount(
      data: any
    ): Promise<any> {
        const response = await this.get('customer-bank-account', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST document-collection/reprocess-documents-without-scanning
    async DocumentCollection__reprocessDocumentsWithoutScanning(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1DocumentCollectionReprocessDocumentsWithoutScanningPostResponseBody> {
        const response = await this.post('document-collection/reprocess-documents-without-scanning', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST document-collection/share-files
    async DocumentCollection__shareFiles(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1DocumentCollectionShareFilesPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1DocumentCollectionShareFilesPostResponseBody> {
        const response = await this.post('document-collection/share-files', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST entrepreneur/approve-vat-declaration
    async Entrepreneur__approveVatDeclaration(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurApproveVatDeclarationPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurApproveVatDeclarationPostResponseBody> {
        const response = await this.post('entrepreneur/approve-vat-declaration', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST entrepreneur/cancel-draft-match
    async Entrepreneur__cancelDraftMatch(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurCancelDraftMatchPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurCancelDraftMatchPostResponseBody> {
        const response = await this.post('entrepreneur/cancel-draft-match', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST entrepreneur/create-business
    async Entrepreneur__createBusiness(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurCreateBusinessPostRequestBody
    ): Promise<any> {
        const response = await this.post('entrepreneur/create-business', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET entrepreneur/document-collection-email
    async Entrepreneur__documentCollectionEmail(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurDocumentCollectionEmailGetResponseBody> {
        const response = await this.get('entrepreneur/document-collection-email', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST entrepreneur/documents/report-incorrect
    async Entrepreneur__documents__reportIncorrect(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurDocumentsReportIncorrectPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurDocumentsReportIncorrectPostResponseBody> {
        const response = await this.post('entrepreneur/documents/report-incorrect', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET entrepreneur/get-document-content
    async Entrepreneur__getDocumentContent(
        document_id: string
    ): Promise<any> {
        const response = await this.get('entrepreneur/get-document-content', {document_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET entrepreneur/get-pending-draft-matches
    async Entrepreneur__getPendingDraftMatches(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurGetPendingDraftMatchesGetResponseBody> {
        const response = await this.get('entrepreneur/get-pending-draft-matches', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET entrepreneur/get-unmatched-transactions
    async Entrepreneur__getUnmatchedTransactions(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurGetUnmatchedTransactionsGetResponseBody> {
        const response = await this.get('entrepreneur/get-unmatched-transactions', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET entrepreneur/get-vat-declaration-approval-request
    async Entrepreneur__getVatDeclarationApprovalRequest(
        request_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurGetVatDeclarationApprovalRequestGetResponseBody> {
        const response = await this.get('entrepreneur/get-vat-declaration-approval-request', {request_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST entrepreneur/mark-transaction-as-private
    async Entrepreneur__markTransactionAsPrivate(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurMarkTransactionAsPrivatePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurMarkTransactionAsPrivatePostResponseBody> {
        const response = await this.post('entrepreneur/mark-transaction-as-private', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET entrepreneur/outstanding-bills
    async Entrepreneur__outstandingBills(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurOutstandingBillsGetResponseBody> {
        const response = await this.get('entrepreneur/outstanding-bills', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST entrepreneur/reject-vat-declaration
    async Entrepreneur__rejectVatDeclaration(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurRejectVatDeclarationPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurRejectVatDeclarationPostResponseBody> {
        const response = await this.post('entrepreneur/reject-vat-declaration', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET entrepreneur/uploaded-documents
    async Entrepreneur__uploadedDocuments(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurUploadedDocumentsGetResponseBody> {
        const response = await this.get('entrepreneur/uploaded-documents', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET export/csv/transactions
    async Export__csv__transactions(
        bank_account_id: string
    ): Promise<any> {
        const response = await this.get('export/csv/transactions', {bank_account_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET general-ledger-accounts
    async GeneralLedgerAccounts(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1GeneralLedgerAccountsGetResponseBody> {
        const response = await this.get('general-ledger-accounts', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST generate-forecast-for-demo
    async GenerateForecastForDemo(
      data: any
    ): Promise<any> {
        const response = await this.post('generate-forecast-for-demo', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET get-banks-by-country-code
    async GetBanksByCountryCode(
        country_code: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1GetBanksByCountryCodeGetResponseBody> {
        const response = await this.get('get-banks-by-country-code', {country_code})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET get-import-job-progress
    async GetImportJobProgress(
        group_id: string
    ): Promise<any> {
        const response = await this.get('get-import-job-progress', {group_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET get-import-jobs
    async GetImportJobs(
        group_id?: null | string
    ): Promise<any> {
        const response = await this.get('get-import-jobs', {group_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET graph/business/get-daily-balance
    async Graph__business__getDailyBalance(
        bank_account_id?: null | string, 
        start_date?: null | string, 
        end_date?: null | string
    ): Promise<any> {
        const response = await this.get('graph/business/get-daily-balance', {bank_account_id, start_date, end_date})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET graph/business/get-daily-balance-with-forecast
    async Graph__business__getDailyBalanceWithForecast(
        bank_account_id?: null | string, 
        start_date?: null | string, 
        end_date?: null | string
    ): Promise<any> {
        const response = await this.get('graph/business/get-daily-balance-with-forecast', {bank_account_id, start_date, end_date})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET healthcheck
    async Healthcheck(
        should_error: boolean = false
    ): Promise<any> {
        const response = await this.get('healthcheck', {should_error})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST initiate-bank-connection
    async InitiateBankConnection(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1InitiateBankConnectionPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1InitiateBankConnectionPostResponseBody> {
        const response = await this.post('initiate-bank-connection', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET insights
    async Insights(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1InsightsGetResponseBody> {
        const response = await this.get('insights', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST insights/mark-insights-read
    async Insights__markInsightsRead(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1InsightsMarkInsightsReadPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1InsightsMarkInsightsReadPostResponseBody> {
        const response = await this.post('insights/mark-insights-read', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET insights/unread-insights
    async Insights__unreadInsights(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1InsightsUnreadInsightsGetResponseBody> {
        const response = await this.get('insights/unread-insights', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST manual/reprocess-transaction
    async Manual__reprocessTransaction(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1ManualReprocessTransactionPostRequestBody
    ): Promise<any> {
        const response = await this.post('manual/reprocess-transaction', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST manual/reprocess-transaction-for-business
    async Manual__reprocessTransactionForBusiness(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1ManualReprocessTransactionForBusinessPostRequestBody
    ): Promise<any> {
        const response = await this.post('manual/reprocess-transaction-for-business', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST mark-bank-as-connected
    async MarkBankAsConnected(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MarkBankAsConnectedPostRequestBody
    ): Promise<any> {
        const response = await this.post('mark-bank-as-connected', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST mark-bank-connection-as-failed
    async MarkBankConnectionAsFailed(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MarkBankConnectionAsFailedPostRequestBody
    ): Promise<any> {
        const response = await this.post('mark-bank-connection-as-failed', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/business/archive-catalogue-item
    async Me__business__archiveCatalogueItem(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessArchiveCatalogueItemPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessArchiveCatalogueItemPostResponseBody> {
        const response = await this.post('me/business/archive-catalogue-item', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/business/archive-customer
    async Me__business__archiveCustomer(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessArchiveCustomerPostRequestBody
    ): Promise<any> {
        const response = await this.post('me/business/archive-customer', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/business/change-catalogue-item
    async Me__business__changeCatalogueItem(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeCatalogueItemPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeCatalogueItemPostResponseBody> {
        const response = await this.post('me/business/change-catalogue-item', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/business/change-customer
    async Me__business__changeCustomer(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeCustomerPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeCustomerPostResponseBody> {
        const response = await this.post('me/business/change-customer', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/business/change-recurring-sales-invoice
    async Me__business__changeRecurringSalesInvoice(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeRecurringSalesInvoicePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeRecurringSalesInvoicePostResponseBody> {
        const response = await this.post('me/business/change-recurring-sales-invoice', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/business/change-sales-invoice-draft
    async Me__business__changeSalesInvoiceDraft(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeSalesInvoiceDraftPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeSalesInvoiceDraftPostResponseBody> {
        const response = await this.post('me/business/change-sales-invoice-draft', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/business/change-sales-invoice-reminder-settings
    async Me__business__changeSalesInvoiceReminderSettings(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeSalesInvoiceReminderSettingsPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeSalesInvoiceReminderSettingsPostResponseBody> {
        const response = await this.post('me/business/change-sales-invoice-reminder-settings', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/business/create-catalogue-item
    async Me__business__createCatalogueItem(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateCatalogueItemPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateCatalogueItemPostResponseBody> {
        const response = await this.post('me/business/create-catalogue-item', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/business/create-customer
    async Me__business__createCustomer(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateCustomerPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateCustomerPostResponseBody> {
        const response = await this.post('me/business/create-customer', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/business/create-recurring-sales-invoice
    async Me__business__createRecurringSalesInvoice(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateRecurringSalesInvoicePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateRecurringSalesInvoicePostResponseBody> {
        const response = await this.post('me/business/create-recurring-sales-invoice', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/business/create-sales-invoice-draft
    async Me__business__createSalesInvoiceDraft(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateSalesInvoiceDraftPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateSalesInvoiceDraftPostResponseBody> {
        const response = await this.post('me/business/create-sales-invoice-draft', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/business/credit-sales-invoice
    async Me__business__creditSalesInvoice(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreditSalesInvoicePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreditSalesInvoicePostResponseBody> {
        const response = await this.post('me/business/credit-sales-invoice', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/business/delete-recurring-sales-invoice
    async Me__business__deleteRecurringSalesInvoice(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessDeleteRecurringSalesInvoicePostRequestBody
    ): Promise<any> {
        const response = await this.post('me/business/delete-recurring-sales-invoice', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/business/discard-sales-invoice-draft
    async Me__business__discardSalesInvoiceDraft(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessDiscardSalesInvoiceDraftPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessDiscardSalesInvoiceDraftPostResponseBody> {
        const response = await this.post('me/business/discard-sales-invoice-draft', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET me/business/download-sales-invoice-draft-pdf
    async Me__business__downloadSalesInvoiceDraftPdf(
        invoice_id: string
    ): Promise<any> {
        const response = await this.get('me/business/download-sales-invoice-draft-pdf', {invoice_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET me/business/download-sales-invoice-pdf
    async Me__business__downloadSalesInvoicePdf(
        invoice_id: string
    ): Promise<any> {
        const response = await this.get('me/business/download-sales-invoice-pdf', {invoice_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/business/edit-base-business-information
    async Me__business__editBaseBusinessInformation(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessEditBaseBusinessInformationPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessEditBaseBusinessInformationPostResponseBody> {
        const response = await this.post('me/business/edit-base-business-information', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/business/generate-sales-invoice
    async Me__business__generateSalesInvoice(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGenerateSalesInvoicePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGenerateSalesInvoicePostResponseBody> {
        const response = await this.post('me/business/generate-sales-invoice', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET me/business/get-catalogue-items
    async Me__business__getCatalogueItems(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetCatalogueItemsGetResponseBody> {
        const response = await this.get('me/business/get-catalogue-items', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET me/business/get-customers
    async Me__business__getCustomers(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetCustomersGetResponseBody> {
        const response = await this.get('me/business/get-customers', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET me/business/get-recurring-sales-invoices
    async Me__business__getRecurringSalesInvoices(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetRecurringSalesInvoicesGetResponseBody> {
        const response = await this.get('me/business/get-recurring-sales-invoices', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET me/business/get-sales-invoice
    async Me__business__getSalesInvoice(
        invoice_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoiceGetResponseBody> {
        const response = await this.get('me/business/get-sales-invoice', {invoice_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET me/business/get-sales-invoice-drafts
    async Me__business__getSalesInvoiceDrafts(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoiceDraftsGetResponseBody> {
        const response = await this.get('me/business/get-sales-invoice-drafts', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET me/business/get-sales-invoice-numbering
    async Me__business__getSalesInvoiceNumbering(
        year: number, 
        prefix?: null | string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoiceNumberingGetResponseBody> {
        const response = await this.get('me/business/get-sales-invoice-numbering', {year, prefix})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET me/business/get-sales-invoice-timeline
    async Me__business__getSalesInvoiceTimeline(
        invoice_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoiceTimelineGetResponseBody> {
        const response = await this.get('me/business/get-sales-invoice-timeline', {invoice_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET me/business/get-sales-invoices
    async Me__business__getSalesInvoices(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoicesGetResponseBody> {
        const response = await this.get('me/business/get-sales-invoices', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/business/issue-sales-invoice
    async Me__business__issueSalesInvoice(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessIssueSalesInvoicePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessIssueSalesInvoicePostResponseBody> {
        const response = await this.post('me/business/issue-sales-invoice', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET me/business/logo
    async Me__business__logo(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessLogoGetResponseBody> {
        const response = await this.get('me/business/logo', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/business/pause-recurring-sales-invoice
    async Me__business__pauseRecurringSalesInvoice(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessPauseRecurringSalesInvoicePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessPauseRecurringSalesInvoicePostResponseBody> {
        const response = await this.post('me/business/pause-recurring-sales-invoice', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/business/preview-sales-invoice
    async Me__business__previewSalesInvoice(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessPreviewSalesInvoicePostRequestBody
    ): Promise<any> {
        const response = await this.post('me/business/preview-sales-invoice', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/business/resend-sales-invoice
    async Me__business__resendSalesInvoice(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessResendSalesInvoicePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessResendSalesInvoicePostResponseBody> {
        const response = await this.post('me/business/resend-sales-invoice', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/business/resume-recurring-sales-invoice
    async Me__business__resumeRecurringSalesInvoice(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessResumeRecurringSalesInvoicePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessResumeRecurringSalesInvoicePostResponseBody> {
        const response = await this.post('me/business/resume-recurring-sales-invoice', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/business/send-sales-invoice
    async Me__business__sendSalesInvoice(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessSendSalesInvoicePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessSendSalesInvoicePostResponseBody> {
        const response = await this.post('me/business/send-sales-invoice', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/business/send-sales-invoice-reminder
    async Me__business__sendSalesInvoiceReminder(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessSendSalesInvoiceReminderPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessSendSalesInvoiceReminderPostResponseBody> {
        const response = await this.post('me/business/send-sales-invoice-reminder', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET me/business/settings
    async Me__business__settings(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessSettingsGetResponseBody> {
        const response = await this.get('me/business/settings', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/business/update-setting
    async Me__business__updateSetting(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessUpdateSettingPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessUpdateSettingPostResponseBody> {
        const response = await this.post('me/business/update-setting', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/business/upload-logo
    async Me__business__uploadLogo(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessUploadLogoPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessUploadLogoPostResponseBody> {
        const response = await this.post('me/business/upload-logo', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET me/notices
    async Me__notices(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeNoticesGetResponseBody> {
        const response = await this.get('me/notices', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET me/settings
    async Me__settings(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeSettingsGetResponseBody> {
        const response = await this.get('me/settings', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/settings/change-setting
    async Me__settings__changeSetting(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeSettingsChangeSettingPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeSettingsChangeSettingPostResponseBody> {
        const response = await this.post('me/settings/change-setting', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/update-flag
    async Me__updateFlag(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeUpdateFlagPostRequestBody
    ): Promise<any> {
        const response = await this.post('me/update-flag', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/user-device/deregister-device
    async Me__userDevice__deregisterDevice(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeUserDeviceDeregisterDevicePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeUserDeviceDeregisterDevicePostResponseBody> {
        const response = await this.post('me/user-device/deregister-device', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/user-device/register-device
    async Me__userDevice__registerDevice(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeUserDeviceRegisterDevicePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeUserDeviceRegisterDevicePostResponseBody> {
        const response = await this.post('me/user-device/register-device', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST me/user-device/send-test-message
    async Me__userDevice__sendTestMessage(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1MeUserDeviceSendTestMessagePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MeUserDeviceSendTestMessagePostResponseBody> {
        const response = await this.post('me/user-device/send-test-message', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET my-business/double-payments
    async MyBusiness__doublePayments(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1MyBusinessDoublePaymentsGetResponseBody> {
        const response = await this.get('my-business/double-payments', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST onboarding/accept-invitation
    async Onboarding__acceptInvitation(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1OnboardingAcceptInvitationPostRequestBody
    ): Promise<any> {
        const response = await this.post('onboarding/accept-invitation', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST onboarding/create-sso-user
    async Onboarding__createSsoUser(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1OnboardingCreateSsoUserPostRequestBody
    ): Promise<any> {
        const response = await this.post('onboarding/create-sso-user', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST onboarding/create-user
    async Onboarding__createUser(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1OnboardingCreateUserPostRequestBody
    ): Promise<any> {
        const response = await this.post('onboarding/create-user', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET onboarding/invitation
    async Onboarding__invitation(
        token: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1OnboardingInvitationGetResponseBody> {
        const response = await this.get('onboarding/invitation', {token})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST open-banking/handle-callback
    async OpenBanking__handleCallback(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1OpenBankingHandleCallbackPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1OpenBankingHandleCallbackPostResponseBody> {
        const response = await this.post('open-banking/handle-callback', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST open-banking/reconnect-bank-account
    async OpenBanking__reconnectBankAccount(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1OpenBankingReconnectBankAccountPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1OpenBankingReconnectBankAccountPostResponseBody> {
        const response = await this.post('open-banking/reconnect-bank-account', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/book-to-general-ledger-account
    async Partner__bookToGeneralLedgerAccount(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBookToGeneralLedgerAccountPostRequestBody
    ): Promise<any> {
        const response = await this.post('partner/book-to-general-ledger-account', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/business/booking-suggestions
    async Partner__business__bookingSuggestions(
        business_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessBookingSuggestionsGetResponseBody> {
        const response = await this.get('partner/business/booking-suggestions', {business_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/business/edit-booking-suggestions
    async Partner__business__editBookingSuggestions(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessEditBookingSuggestionsPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessEditBookingSuggestionsPostResponseBody> {
        const response = await this.post('partner/business/edit-booking-suggestions', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/business/edit-description
    async Partner__business__editDescription(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessEditDescriptionPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessEditDescriptionPostResponseBody> {
        const response = await this.post('partner/business/edit-description', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/business/settings
    async Partner__business__settings(
        business_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessSettingsGetResponseBody> {
        const response = await this.get('partner/business/settings', {business_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/business/stats/base-stats
    async Partner__business__stats__baseStats(
        business_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessStatsBaseStatsGetResponseBody> {
        const response = await this.get('partner/business/stats/base-stats', {business_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/business/update-setting
    async Partner__business__updateSetting(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessUpdateSettingPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessUpdateSettingPostResponseBody> {
        const response = await this.post('partner/business/update-setting', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/client/bill/dismiss-todo
    async Partner__client__bill__dismissTodo(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientBillDismissTodoPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientBillDismissTodoPostResponseBody> {
        const response = await this.post('partner/client/bill/dismiss-todo', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/client/bill/list-bill-todos
    async Partner__client__bill__listBillTodos(
        bill_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientBillListBillTodosGetResponseBody> {
        const response = await this.get('partner/client/bill/list-bill-todos', {bill_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/client/document/delete
    async Partner__client__document__delete(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientDocumentDeletePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientDocumentDeletePostResponseBody> {
        const response = await this.post('partner/client/document/delete', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/client/document/edit-document-fields
    async Partner__client__document__editDocumentFields(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientDocumentEditDocumentFieldsPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientDocumentEditDocumentFieldsPostResponseBody> {
        const response = await this.post('partner/client/document/edit-document-fields', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/client/document/validate-document-fields
    async Partner__client__document__validateDocumentFields(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientDocumentValidateDocumentFieldsPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientDocumentValidateDocumentFieldsPostResponseBody> {
        const response = await this.post('partner/client/document/validate-document-fields', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/client/get-bill-duplicates
    async Partner__client__getBillDuplicates(
        bill_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientGetBillDuplicatesGetResponseBody> {
        const response = await this.get('partner/client/get-bill-duplicates', {bill_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/client/get-completeness-score
    async Partner__client__getCompletenessScore(
        client_business_id: string, 
        date_from: string, 
        date_to: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientGetCompletenessScoreGetResponseBody> {
        const response = await this.get('partner/client/get-completeness-score', {client_business_id, date_from, date_to})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/client/get-document
    async Partner__client__getDocument(
        business_id: string, 
        document_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientGetDocumentGetResponseBody> {
        const response = await this.get('partner/client/get-document', {business_id, document_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/client/get-document-content
    async Partner__client__getDocumentContent(
        business_id: string, 
        document_id: string
    ): Promise<any> {
        const response = await this.get('partner/client/get-document-content', {business_id, document_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/client/matches
    async Partner__client__matches(
        from_date: string, 
        until_date: string, 
        business_id?: null | string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientMatchesGetResponseBody> {
        const response = await this.get('partner/client/matches', {from_date, until_date, business_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/client/unmatch-and-delete-bill
    async Partner__client__unmatchAndDeleteBill(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientUnmatchAndDeleteBillPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientUnmatchAndDeleteBillPostResponseBody> {
        const response = await this.post('partner/client/unmatch-and-delete-bill', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/client/uploaded-documents
    async Partner__client__uploadedDocuments(
        business_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientUploadedDocumentsGetResponseBody> {
        const response = await this.get('partner/client/uploaded-documents', {business_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/compute-vat-declaration
    async Partner__computeVatDeclaration(
        client_business_id: string, 
        date_from: string, 
        date_to: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerComputeVatDeclarationGetResponseBody> {
        const response = await this.get('partner/compute-vat-declaration', {client_business_id, date_from, date_to})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/connect-financial-service
    async Partner__connectFinancialService(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerConnectFinancialServiceGetResponseBody> {
        const response = await this.get('partner/connect-financial-service', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/create-business
    async Partner__createBusiness(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerCreateBusinessPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerCreateBusinessPostResponseBody> {
        const response = await this.post('partner/create-business', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/create-client-subledger
    async Partner__createClientSubledger(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerCreateClientSubledgerPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerCreateClientSubledgerPostResponseBody> {
        const response = await this.post('partner/create-client-subledger', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/create-fixed-asset
    async Partner__createFixedAsset(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerCreateFixedAssetPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerCreateFixedAssetPostResponseBody> {
        const response = await this.post('partner/create-fixed-asset', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/delete-automation-rule
    async Partner__deleteAutomationRule(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDeleteAutomationRulePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDeleteAutomationRulePostResponseBody> {
        const response = await this.post('partner/delete-automation-rule', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/delete-manual-booking
    async Partner__deleteManualBooking(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDeleteManualBookingPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDeleteManualBookingPostResponseBody> {
        const response = await this.post('partner/delete-manual-booking', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/document-activity-documents
    async Partner__documentActivityDocuments(
        business_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentActivityDocumentsGetResponseBody> {
        const response = await this.get('partner/document-activity-documents', {business_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/document/bill/convert-to-euro
    async Partner__document__bill__convertToEuro(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentBillConvertToEuroPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentBillConvertToEuroPostResponseBody> {
        const response = await this.post('partner/document/bill/convert-to-euro', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/document/bill/mark-as-privately-paid
    async Partner__document__bill__markAsPrivatelyPaid(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentBillMarkAsPrivatelyPaidPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentBillMarkAsPrivatelyPaidPostResponseBody> {
        const response = await this.post('partner/document/bill/mark-as-privately-paid', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/document/bill/undo-mark-as-privately-paid
    async Partner__document__bill__undoMarkAsPrivatelyPaid(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentBillUndoMarkAsPrivatelyPaidPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentBillUndoMarkAsPrivatelyPaidPostResponseBody> {
        const response = await this.post('partner/document/bill/undo-mark-as-privately-paid', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/document/toggle-document-vat-ignored
    async Partner__document__toggleDocumentVatIgnored(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentToggleDocumentVatIgnoredPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentToggleDocumentVatIgnoredPostResponseBody> {
        const response = await this.post('partner/document/toggle-document-vat-ignored', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/edit-manual-booking
    async Partner__editManualBooking(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerEditManualBookingPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerEditManualBookingPostResponseBody> {
        const response = await this.post('partner/edit-manual-booking', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/entrepreneur/document-collection-email
    async Partner__entrepreneur__documentCollectionEmail(
        business_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerEntrepreneurDocumentCollectionEmailGetResponseBody> {
        const response = await this.get('partner/entrepreneur/document-collection-email', {business_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/entrepreneur/get-bank-accounts
    async Partner__entrepreneur__getBankAccounts(
        business_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerEntrepreneurGetBankAccountsGetResponseBody> {
        const response = await this.get('partner/entrepreneur/get-bank-accounts', {business_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/export-client-balance-sheet
    async Partner__exportClientBalanceSheet(
        start_date: string, 
        end_date: string, 
        client_business_id: string, 
        export_format: Enums.BalanceSheetExportFormat, 
        currency?: Enums.CurrencyEnum, 
        comparison_period?: null | string, 
        show_predicted_accounts: boolean = true
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerExportClientBalanceSheetGetResponseBody> {
        const response = await this.get('partner/export-client-balance-sheet', {start_date, end_date, client_business_id, export_format, currency, comparison_period, show_predicted_accounts})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/export-entrepreneur-transactions-to-csv
    async Partner__exportEntrepreneurTransactionsToCsv(
        bank_account_id: string
    ): Promise<any> {
        const response = await this.get('partner/export-entrepreneur-transactions-to-csv', {bank_account_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/find-by-business-id
    async Partner__findByBusinessId(
        partner_business_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerFindByBusinessIdGetResponseBody> {
        const response = await this.get('partner/find-by-business-id', {partner_business_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/find-by-host-url
    async Partner__findByHostUrl(
        hostname: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerFindByHostUrlGetResponseBody> {
        const response = await this.get('partner/find-by-host-url', {hostname})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/get-all-vat-declaration-snapshots
    async Partner__getAllVatDeclarationSnapshots(
        client_business_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetAllVatDeclarationSnapshotsGetResponseBody> {
        const response = await this.get('partner/get-all-vat-declaration-snapshots', {client_business_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/get-automation-rules
    async Partner__getAutomationRules(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetAutomationRulesGetResponseBody> {
        const response = await this.get('partner/get-automation-rules', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/get-bank-account-balance-at-date
    async Partner__getBankAccountBalanceAtDate(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBankAccountBalanceAtDatePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBankAccountBalanceAtDatePostResponseBody> {
        const response = await this.post('partner/get-bank-account-balance-at-date', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/get-bks-entrepreneur-businesses
    async Partner__getBksEntrepreneurBusinesses(
        connection_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBksEntrepreneurBusinessesGetResponseBody> {
        const response = await this.get('partner/get-bks-entrepreneur-businesses', {connection_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/get-bks-import-jobs
    async Partner__getBksImportJobs(
        business_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBksImportJobsGetResponseBody> {
        const response = await this.get('partner/get-bks-import-jobs', {business_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/get-bks-import-status
    async Partner__getBksImportStatus(
        import_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBksImportStatusGetResponseBody> {
        const response = await this.get('partner/get-bks-import-status', {import_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/get-bks-journals
    async Partner__getBksJournals(
        external_business_id: string, 
        connection_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBksJournalsGetResponseBody> {
        const response = await this.get('partner/get-bks-journals', {external_business_id, connection_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/get-blacklist-rule-preview
    async Partner__getBlacklistRulePreview(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBlacklistRulePreviewPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBlacklistRulePreviewPostResponseBody> {
        const response = await this.post('partner/get-blacklist-rule-preview', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/get-business-access-list
    async Partner__getBusinessAccessList(
        business_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBusinessAccessListGetResponseBody> {
        const response = await this.get('partner/get-business-access-list', {business_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/get-business-reconciliation-overviews
    async Partner__getBusinessReconciliationOverviews(
        date_since: string, 
        client_business_id?: null | string, 
        date_until?: null | string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBusinessReconciliationOverviewsGetResponseBody> {
        const response = await this.get('partner/get-business-reconciliation-overviews', {date_since, client_business_id, date_until})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/get-client-activity
    async Partner__getClientActivity(
        start_date: string, 
        end_date: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientActivityGetResponseBody> {
        const response = await this.get('partner/get-client-activity', {start_date, end_date})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/get-client-balance-sheet-per-period
    async Partner__getClientBalanceSheetPerPeriod(
        start_date: string, 
        end_date: string, 
        client_business_id: string, 
        currency?: Enums.CurrencyEnum, 
        show_predicted_accounts: boolean = true, 
        include_empty_accounts: boolean = true
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientBalanceSheetPerPeriodGetResponseBody> {
        const response = await this.get('partner/get-client-balance-sheet-per-period', {start_date, end_date, client_business_id, currency, show_predicted_accounts, include_empty_accounts})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/get-client-bank-accounts
    async Partner__getClientBankAccounts(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientBankAccountsGetResponseBody> {
        const response = await this.get('partner/get-client-bank-accounts', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/get-client-insights
    async Partner__getClientInsights(
        business_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientInsightsGetResponseBody> {
        const response = await this.get('partner/get-client-insights', {business_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/get-client-manual-bookings
    async Partner__getClientManualBookings(
        client_business_id: string, 
        start_date?: null | string, 
        end_date?: null | string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientManualBookingsGetResponseBody> {
        const response = await this.get('partner/get-client-manual-bookings', {client_business_id, start_date, end_date})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/get-client-profit-and-loss-pdf
    async Partner__getClientProfitAndLossPdf(
        start_date: string, 
        end_date: string, 
        client_business_id: string, 
        currency?: Enums.CurrencyEnum | null, 
        expanded: boolean = false, 
        show_predicted_accounts: boolean = true
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientProfitAndLossPdfGetResponseBody> {
        const response = await this.get('partner/get-client-profit-and-loss-pdf', {start_date, end_date, client_business_id, currency, expanded, show_predicted_accounts})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/get-client-profit-and-loss-per-period
    async Partner__getClientProfitAndLossPerPeriod(
        start_date: string, 
        end_date: string, 
        client_business_id: string, 
        currency?: Enums.CurrencyEnum, 
        show_predicted_accounts: boolean = true, 
        include_empty_accounts: boolean = true
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientProfitAndLossPerPeriodGetResponseBody> {
        const response = await this.get('partner/get-client-profit-and-loss-per-period', {start_date, end_date, client_business_id, currency, show_predicted_accounts, include_empty_accounts})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/get-client-reports
    async Partner__getClientReports(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientReportsGetResponseBody> {
        const response = await this.get('partner/get-client-reports', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/get-client-subledgers
    async Partner__getClientSubledgers(
        business_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientSubledgersGetResponseBody> {
        const response = await this.get('partner/get-client-subledgers', {business_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/get-client-trial-balance
    async Partner__getClientTrialBalance(
        start_date: string, 
        end_date: string, 
        client_business_id: string, 
        currency?: Enums.CurrencyEnum, 
        show_predicted_accounts: boolean = true
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientTrialBalanceGetResponseBody> {
        const response = await this.get('partner/get-client-trial-balance', {start_date, end_date, client_business_id, currency, show_predicted_accounts})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/get-client-trial-balance-report
    async Partner__getClientTrialBalanceReport(
        start_date: string, 
        end_date: string, 
        client_business_id: string, 
        currency?: Enums.CurrencyEnum, 
        comparison_period?: null | string, 
        show_predicted_accounts: boolean = true, 
        include_empty_accounts: boolean = true
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientTrialBalanceReportGetResponseBody> {
        const response = await this.get('partner/get-client-trial-balance-report', {start_date, end_date, client_business_id, currency, comparison_period, show_predicted_accounts, include_empty_accounts})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/get-client-vat-declaration-statuses
    async Partner__getClientVatDeclarationStatuses(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientVatDeclarationStatusesGetResponseBody> {
        const response = await this.get('partner/get-client-vat-declaration-statuses', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/get-fixed-asset-details
    async Partner__getFixedAssetDetails(
        client_business_id: string, 
        fixed_asset_id: string, 
        as_of?: null | string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetFixedAssetDetailsGetResponseBody> {
        const response = await this.get('partner/get-fixed-asset-details', {client_business_id, fixed_asset_id, as_of})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/get-fixed-assets
    async Partner__getFixedAssets(
        client_business_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetFixedAssetsGetResponseBody> {
        const response = await this.get('partner/get-fixed-assets', {client_business_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/get-vat-declaration-snapshot
    async Partner__getVatDeclarationSnapshot(
        client_business_id: string, 
        snapshot_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetVatDeclarationSnapshotGetResponseBody> {
        const response = await this.get('partner/get-vat-declaration-snapshot', {client_business_id, snapshot_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/grant-entrepreneur-access
    async Partner__grantEntrepreneurAccess(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGrantEntrepreneurAccessPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGrantEntrepreneurAccessPostResponseBody> {
        const response = await this.post('partner/grant-entrepreneur-access', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/graph/business/get-daily-balance-with-forecast
    async Partner__graph__business__getDailyBalanceWithForecast(
        business_id: string, 
        bank_account_id: string, 
        start_date?: null | string, 
        end_date?: null | string
    ): Promise<any> {
        const response = await this.get('partner/graph/business/get-daily-balance-with-forecast', {business_id, bank_account_id, start_date, end_date})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/initiate-bks-document-import
    async Partner__initiateBksDocumentImport(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerInitiateBksDocumentImportPostRequestBody
    ): Promise<any> {
        const response = await this.post('partner/initiate-bks-document-import', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/invite-entrepreneur
    async Partner__inviteEntrepreneur(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerInviteEntrepreneurPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerInviteEntrepreneurPostResponseBody> {
        const response = await this.post('partner/invite-entrepreneur', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/invite-teammate
    async Partner__inviteTeammate(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerInviteTeammatePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerInviteTeammatePostResponseBody> {
        const response = await this.post('partner/invite-teammate', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/link-fixed-asset-to-document
    async Partner__linkFixedAssetToDocument(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerLinkFixedAssetToDocumentPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerLinkFixedAssetToDocumentPostResponseBody> {
        const response = await this.post('partner/link-fixed-asset-to-document', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/linkable-entrepreneurs
    async Partner__linkableEntrepreneurs(
        business_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerLinkableEntrepreneursGetResponseBody> {
        const response = await this.get('partner/linkable-entrepreneurs', {business_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/list-archived-documents
    async Partner__listArchivedDocuments(
        date_from?: null | string, 
        date_to?: null | string, 
        orderby?: Enums.ArchivedDocumentsOrderByEnum, 
        order?: Enums.OrderDirectionEnum, 
        business_ids?: null | string, 
        file_name: string = ""
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerListArchivedDocumentsGetResponseBody> {
        const response = await this.get('partner/list-archived-documents', {date_from, date_to, orderby, order, business_ids, file_name})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/list-client-bills
    async Partner__listClientBills(
        date_from?: null | string, 
        date_to?: null | string, 
        date_type?: Enums.DateFilterType, 
        business_ids?: null | string, 
        relations?: null | string, 
        tags?: null | string, 
        tags_mode?: Enums.FilterTags, 
        direction?: Enums.DocumentDirection | null, 
        document_categories?: null | string, 
        orderby: string = "relation_name", 
        order: string = "asc"
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerListClientBillsGetResponseBody> {
        const response = await this.get('partner/list-client-bills', {date_from, date_to, date_type, business_ids, relations, tags, tags_mode, direction, document_categories, orderby, order})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/list-credit-card-statements
    async Partner__listCreditCardStatements(
        date_from?: null | string, 
        date_to?: null | string, 
        business_ids?: null | string, 
        orderby: string = "created_at", 
        order: string = "desc"
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerListCreditCardStatementsGetResponseBody> {
        const response = await this.get('partner/list-credit-card-statements', {date_from, date_to, business_ids, orderby, order})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/list-documents-to-check
    async Partner__listDocumentsToCheck(
        date_from?: null | string, 
        date_to?: null | string, 
        date_type?: Enums.DateFilterType, 
        business_ids?: null | string, 
        reasons?: null | string, 
        todo_types?: null | string, 
        orderby?: Enums.DocumentsToCheckOrderByEnum, 
        order?: Enums.OrderDirectionEnum
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerListDocumentsToCheckGetResponseBody> {
        const response = await this.get('partner/list-documents-to-check', {date_from, date_to, date_type, business_ids, reasons, todo_types, orderby, order})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/make-manual-booking
    async Partner__makeManualBooking(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerMakeManualBookingPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerMakeManualBookingPostResponseBody> {
        const response = await this.post('partner/make-manual-booking', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/managed-businesses/bank-accounts
    async Partner__managedBusinesses__bankAccounts(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerManagedBusinessesBankAccountsGetResponseBody> {
        const response = await this.get('partner/managed-businesses/bank-accounts', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/my-clients
    async Partner__myClients(
        year?: null | number, 
        quarter?: null | number
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerMyClientsGetResponseBody> {
        const response = await this.get('partner/my-clients', {year, quarter})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/my-clients/list
    async Partner__myClients__list(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerMyClientsListGetResponseBody> {
        const response = await this.get('partner/my-clients/list', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/payroll/administration-options
    async Partner__payroll__administrationOptions(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollAdministrationOptionsGetResponseBody> {
        const response = await this.get('partner/payroll/administration-options', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/payroll/administrations/assign-mapping
    async Partner__payroll__administrations__assignMapping(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollAdministrationsAssignMappingPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollAdministrationsAssignMappingPostResponseBody> {
        const response = await this.post('partner/payroll/administrations/assign-mapping', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/payroll/administrations/mapping-coverage
    async Partner__payroll__administrations__mappingCoverage(
        administration_id: string, 
        period_start?: null | string, 
        period_end?: null | string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollAdministrationsMappingCoverageGetResponseBody> {
        const response = await this.get('partner/payroll/administrations/mapping-coverage', {administration_id, period_start, period_end})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/payroll/connect-session
    async Partner__payroll__connectSession(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollConnectSessionPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollConnectSessionPostResponseBody> {
        const response = await this.post('partner/payroll/connect-session', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/payroll/connection/complete
    async Partner__payroll__connection__complete(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollConnectionCompletePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollConnectionCompletePostResponseBody> {
        const response = await this.post('partner/payroll/connection/complete', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/payroll/connection/reconnect-complete
    async Partner__payroll__connection__reconnectComplete(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollConnectionReconnectCompletePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollConnectionReconnectCompletePostResponseBody> {
        const response = await this.post('partner/payroll/connection/reconnect-complete', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/payroll/create-payroll-gl-mapping
    async Partner__payroll__createPayrollGlMapping(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollCreatePayrollGlMappingPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollCreatePayrollGlMappingPostResponseBody> {
        const response = await this.post('partner/payroll/create-payroll-gl-mapping', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/payroll/get-payroll-administration
    async Partner__payroll__getPayrollAdministration(
        business_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGetPayrollAdministrationGetResponseBody> {
        const response = await this.get('partner/payroll/get-payroll-administration', {business_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/payroll/get-payroll-connection
    async Partner__payroll__getPayrollConnection(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGetPayrollConnectionGetResponseBody> {
        const response = await this.get('partner/payroll/get-payroll-connection', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/payroll/get-payroll-gl-mapping
    async Partner__payroll__getPayrollGlMapping(
        mapping_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGetPayrollGlMappingGetResponseBody> {
        const response = await this.get('partner/payroll/get-payroll-gl-mapping', {mapping_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/payroll/gl-mapping-rules
    async Partner__payroll__glMappingRules(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingRulesPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingRulesPostResponseBody> {
        const response = await this.post('partner/payroll/gl-mapping-rules', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/payroll/gl-mapping-rules/remove
    async Partner__payroll__glMappingRules__remove(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingRulesRemovePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingRulesRemovePostResponseBody> {
        const response = await this.post('partner/payroll/gl-mapping-rules/remove', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/payroll/gl-mappings/delete
    async Partner__payroll__glMappings__delete(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingsDeletePostRequestBody
    ): Promise<any> {
        const response = await this.post('partner/payroll/gl-mappings/delete', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/payroll/gl-mappings/list
    async Partner__payroll__glMappings__list(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingsListGetResponseBody> {
        const response = await this.get('partner/payroll/gl-mappings/list', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/payroll/gl-mappings/rename
    async Partner__payroll__glMappings__rename(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingsRenamePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingsRenamePostResponseBody> {
        const response = await this.post('partner/payroll/gl-mappings/rename', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/payroll/imports
    async Partner__payroll__imports(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollImportsPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollImportsPostResponseBody> {
        const response = await this.post('partner/payroll/imports', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/payroll/imports/history
    async Partner__payroll__imports__history(
        administration_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollImportsHistoryGetResponseBody> {
        const response = await this.get('partner/payroll/imports/history', {administration_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/payroll/imports/unmapped-gl-accounts
    async Partner__payroll__imports__unmappedGlAccounts(
        administration_id: string, 
        import_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollImportsUnmappedGlAccountsGetResponseBody> {
        const response = await this.get('partner/payroll/imports/unmapped-gl-accounts', {administration_id, import_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/payroll/link-payroll-administration
    async Partner__payroll__linkPayrollAdministration(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollLinkPayrollAdministrationPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollLinkPayrollAdministrationPostResponseBody> {
        const response = await this.post('partner/payroll/link-payroll-administration', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/payroll/list-available-providers
    async Partner__payroll__listAvailableProviders(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollListAvailableProvidersGetResponseBody> {
        const response = await this.get('partner/payroll/list-available-providers', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/payroll/reconnect-session
    async Partner__payroll__reconnectSession(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollReconnectSessionPostResponseBody> {
        const response = await this.post('partner/payroll/reconnect-session', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/payroll/test-connection
    async Partner__payroll__testConnection(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollTestConnectionPostResponseBody> {
        const response = await this.post('partner/payroll/test-connection', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/process-credit-card-settlement
    async Partner__processCreditCardSettlement(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerProcessCreditCardSettlementPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerProcessCreditCardSettlementPostResponseBody> {
        const response = await this.post('partner/process-credit-card-settlement', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/recategorize-document
    async Partner__recategorizeDocument(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRecategorizeDocumentPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRecategorizeDocumentPostResponseBody> {
        const response = await this.post('partner/recategorize-document', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/refine-vat-ignore-prompt
    async Partner__refineVatIgnorePrompt(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRefineVatIgnorePromptPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRefineVatIgnorePromptPostResponseBody> {
        const response = await this.post('partner/refine-vat-ignore-prompt', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/refresh-client-trial-balance-cache
    async Partner__refreshClientTrialBalanceCache(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRefreshClientTrialBalanceCachePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRefreshClientTrialBalanceCachePostResponseBody> {
        const response = await this.post('partner/refresh-client-trial-balance-cache', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/rename-client-subledger
    async Partner__renameClientSubledger(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRenameClientSubledgerPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRenameClientSubledgerPostResponseBody> {
        const response = await this.post('partner/rename-client-subledger', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/request-vat-declaration-approval
    async Partner__requestVatDeclarationApproval(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRequestVatDeclarationApprovalPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRequestVatDeclarationApprovalPostResponseBody> {
        const response = await this.post('partner/request-vat-declaration-approval', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/save-vat-declaration-snapshot
    async Partner__saveVatDeclarationSnapshot(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerSaveVatDeclarationSnapshotPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerSaveVatDeclarationSnapshotPostResponseBody> {
        const response = await this.post('partner/save-vat-declaration-snapshot', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/teammates
    async Partner__teammates(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerTeammatesGetResponseBody> {
        const response = await this.get('partner/teammates', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET partner/transactions
    async Partner__transactions(
        client_business_id?: null | string, 
        bank_account_id?: null | string, 
        date_from?: null | string, 
        date_to?: null | string, 
        flow?: Enums.TransactionFlow | null, 
        amount_cents?: null | number, 
        amount_comparator?: Enums.TransactionAmountComparator, 
        relation_iban?: null | string, 
        general_ledger_account_id?: null | string, 
        match_status?: Enums.TransactionMatchStatus | null, 
        search?: null | string, 
        sort?: Enums.TransactionSortField, 
        direction?: Enums.SortDirection, 
        cursor?: null | string, 
        limit: number = 100
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerTransactionsGetResponseBody> {
        const response = await this.get('partner/transactions', {client_business_id, bank_account_id, date_from, date_to, flow, amount_cents, amount_comparator, relation_iban, general_ledger_account_id, match_status, search, sort, direction, cursor, limit})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/transactions/categorization-change
    async Partner__transactions__categorizationChange(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerTransactionsCategorizationChangePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerTransactionsCategorizationChangePostResponseBody> {
        const response = await this.post('partner/transactions/categorization-change', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/unlink-fixed-asset-from-document
    async Partner__unlinkFixedAssetFromDocument(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerUnlinkFixedAssetFromDocumentPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerUnlinkFixedAssetFromDocumentPostResponseBody> {
        const response = await this.post('partner/unlink-fixed-asset-from-document', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/unmatched-transactions/create-backlist-rule
    async Partner__unmatchedTransactions__createBacklistRule(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerUnmatchedTransactionsCreateBacklistRulePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerUnmatchedTransactionsCreateBacklistRulePostResponseBody> {
        const response = await this.post('partner/unmatched-transactions/create-backlist-rule', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST partner/withdraw-vat-declaration-approval-request
    async Partner__withdrawVatDeclarationApprovalRequest(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerWithdrawVatDeclarationApprovalRequestPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerWithdrawVatDeclarationApprovalRequestPostResponseBody> {
        const response = await this.post('partner/withdraw-vat-declaration-approval-request', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST public/send-reset-password-email
    async Public__sendResetPasswordEmail(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1PublicSendResetPasswordEmailPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1PublicSendResetPasswordEmailPostResponseBody> {
        const response = await this.post('public/send-reset-password-email', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET quinn/get-chat
    async Quinn__getChat(
        chat_id?: null | string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnGetChatGetResponseBody> {
        const response = await this.get('quinn/get-chat', {chat_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET quinn/get-run-status
    async Quinn__getRunStatus(
        run_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnGetRunStatusGetResponseBody> {
        const response = await this.get('quinn/get-run-status', {run_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET quinn/list-sessions
    async Quinn__listSessions(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnListSessionsGetResponseBody> {
        const response = await this.get('quinn/list-sessions', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST quinn/rate-answer
    async Quinn__rateAnswer(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnRateAnswerPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnRateAnswerPostResponseBody> {
        const response = await this.post('quinn/rate-answer', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST quinn/send-message
    async Quinn__sendMessage(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnSendMessagePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnSendMessagePostResponseBody> {
        const response = await this.post('quinn/send-message', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST quinn/start-run
    async Quinn__startRun(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnStartRunPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnStartRunPostResponseBody> {
        const response = await this.post('quinn/start-run', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET reconciliation/get-match-details
    async Reconciliation__getMatchDetails(
        match_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationGetMatchDetailsGetResponseBody> {
        const response = await this.get('reconciliation/get-match-details', {match_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET reconciliation/get-match-details-by-document-id
    async Reconciliation__getMatchDetailsByDocumentId(
        document_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationGetMatchDetailsByDocumentIdGetResponseBody> {
        const response = await this.get('reconciliation/get-match-details-by-document-id', {document_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST reconciliation/manually-add-parts-match
    async Reconciliation__manuallyAddPartsMatch(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationManuallyAddPartsMatchPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationManuallyAddPartsMatchPostResponseBody> {
        const response = await this.post('reconciliation/manually-add-parts-match', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST reconciliation/manually-match
    async Reconciliation__manuallyMatch(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationManuallyMatchPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationManuallyMatchPostResponseBody> {
        const response = await this.post('reconciliation/manually-match', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST reconciliation/manually-unmatch
    async Reconciliation__manuallyUnmatch(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationManuallyUnmatchPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationManuallyUnmatchPostResponseBody> {
        const response = await this.post('reconciliation/manually-unmatch', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST reconciliation/mark-match-manually-completed
    async Reconciliation__markMatchManuallyCompleted(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationMarkMatchManuallyCompletedPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationMarkMatchManuallyCompletedPostResponseBody> {
        const response = await this.post('reconciliation/mark-match-manually-completed', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST register-callback
    async RegisterCallback(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1RegisterCallbackPostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1RegisterCallbackPostResponseBody> {
        const response = await this.post('register-callback', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET ro-developer/get-all-documents
    async RoDeveloper__getAllDocuments(
        document_id?: null | string, 
        direction?: null | string, 
        category?: null | string, 
        status?: null | string, 
        needs_review?: boolean | null, 
        review_context_failed_check?: null | string, 
        partner_business_id?: null | string, 
        include_duplicates: boolean = false, 
        include_deleted: boolean = false
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1RoDeveloperGetAllDocumentsGetResponseBody> {
        const response = await this.get('ro-developer/get-all-documents', {document_id, direction, category, status, needs_review, review_context_failed_check, partner_business_id, include_duplicates, include_deleted})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET ro-developer/get-document
    async RoDeveloper__getDocument(
        document_id: string
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1RoDeveloperGetDocumentGetResponseBody> {
        const response = await this.get('ro-developer/get-document', {document_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET ro-developer/get-document-content
    async RoDeveloper__getDocumentContent(
        document_id: string
    ): Promise<any> {
        const response = await this.get('ro-developer/get-document-content', {document_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET ro-developer/get-failed-checks
    async RoDeveloper__getFailedChecks(
      data: any
    ): Promise<any> {
        const response = await this.get('ro-developer/get-failed-checks', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET ro-developer/get-partners
    async RoDeveloper__getPartners(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1RoDeveloperGetPartnersGetResponseBody> {
        const response = await this.get('ro-developer/get-partners', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST start-import-job
    async StartImportJob(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1StartImportJobPostRequestBody
    ): Promise<any> {
        const response = await this.post('start-import-job', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET tql/preview
    async Tql__preview(
        expression: string, 
        page?: null | number, 
        page_size?: null | number, 
        order_by?: null | string, 
        order_descending?: boolean | null
    ): Promise<any> {
        const response = await this.get('tql/preview', {expression, page, page_size, order_by, order_descending})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET tql/query-from-suggestion
    async Tql__queryFromSuggestion(
        suggestion: string
    ): Promise<any> {
        const response = await this.get('tql/query-from-suggestion', {suggestion})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST transactions/book-as-private
    async Transactions__bookAsPrivate(
      data: BackendAPITypes.BACKENDPreHandleSyncApiV1TransactionsBookAsPrivatePostRequestBody
    ): Promise<BackendAPITypes.BACKENDPreHandleSyncApiV1TransactionsBookAsPrivatePostResponseBody> {
        const response = await this.post('transactions/book-as-private', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // GET transactions/get-transaction-history
    async Transactions__getTransactionHistory(
        transaction_id: string
    ): Promise<any> {
        const response = await this.get('transactions/get-transaction-history', {transaction_id})
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST webhook/sendgrid/events
    async Webhook__sendgrid__events(
      data: any
    ): Promise<BackendAPITypes.BACKENDPreHandleAsyncApiV1WebhookSendgridEventsPostResponseBody> {
        const response = await this.post('webhook/sendgrid/events', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }

    
    // POST webhook/sendgrid/inbound-parse
    async Webhook__sendgrid__inboundParse(
      data: BackendAPITypes.BACKENDPreHandleAsyncApiV1WebhookSendgridInboundParsePostRequestBody
    ): Promise<any> {
        const response = await this.post('webhook/sendgrid/inbound-parse', data)
        
        if (!response.ok) {
            let errorDetail = null;
            try {
                const responseBody = await response.json();
                errorDetail = responseBody.detail || responseBody;
            } catch (e) {
                // Response body is not JSON, use statusText
            }
            throw new Non200ResponseError(response.statusText, errorDetail, response.status)
        }
        
        return await response.json()
    }
}


// ============================================================================
// React Query layer (generated). One hook per endpoint. Per typed GET: a query
// hook (useX) cached under [queryKey, path, params], where queryKey is the
// caller's QueryKey group. Per POST: a mutation hook (useXMutation) whose `invalidates`
// option lists the QueryKey groups to refresh before the mutation resolves.
// GETs with an untyped response get no hook: the spec cannot tell untyped JSON
// apart from file downloads. POSTs with a multipart body get no hook: they go
// through api.postFormData.
// ============================================================================
import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import type {UseMutationOptions, UseQueryOptions} from '@tanstack/react-query'
import type {QueryKey} from '../api/queryKeys.ts'

export type ApiError = Non200ResponseError

declare module '@tanstack/react-query' {
    interface Register {
        defaultError: ApiError;
    }
}

export type ApiQueryOptions<TResult, TData = TResult> = Omit<
    UseQueryOptions<TResult, ApiError, TData>,
    'queryKey' | 'queryFn'
> & {
    queryKey: QueryKey;
};

export type ApiMutationOptions<TResult, TVariables> = Omit<
    UseMutationOptions<TResult, ApiError, TVariables>,
    'mutationFn'
> & {
    invalidates?: readonly QueryKey[];
};

export async function sendHookRequest<T>(
    transport: BackendAPIBlueprint,
    verb: 'get' | 'post',
    path: string,
    data: any,
    signal?: AbortSignal,
): Promise<T> {
    const response: Response = signal
        ? await transport[verb](path, data, signal)
        : await transport[verb](path, data)

    if (!response.ok) {
        let errorDetail = null;
        try {
            const responseBody = await response.json();
            errorDetail = responseBody.detail || responseBody;
        } catch (e) {
            // Response body is not JSON, use statusText
        }
        throw new Non200ResponseError(response.statusText, errorDetail, response.status)
    }

    if (response.status === 204) {
        return undefined as T
    }

    return await response.json()
}

// POST access-control/user/send-email-verification-email
export const useAccessControl__user__sendEmailVerificationEmailMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, BackendAPITypes.BACKENDPreHandleSyncApiV1AccessControlUserSendEmailVerificationEmailPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1AccessControlUserSendEmailVerificationEmailPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'access-control/user/send-email-verification-email', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET access-control/who-am-i
export const useAccessControl__whoAmI = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1AccessControlWhoAmIGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1AccessControlWhoAmIGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1AccessControlWhoAmIGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'access-control/who-am-i', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1AccessControlWhoAmIGetResponseBody>(api, 'get', 'access-control/who-am-i', data, signal),
    })
}

// GET admin/business/bank-accounts
export const useAdmin__business__bankAccounts = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1AdminBusinessBankAccountsGetResponseBody>(api: BackendAPIBlueprint, params: {business_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminBusinessBankAccountsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {business_id: params.business_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminBusinessBankAccountsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'admin/business/bank-accounts', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminBusinessBankAccountsGetResponseBody>(api, 'get', 'admin/business/bank-accounts', data, signal),
    })
}

// GET admin/business/flags
export const useAdmin__business__flags = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1AdminBusinessFlagsGetResponseBody>(api: BackendAPIBlueprint, params: {business_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminBusinessFlagsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {business_id: params.business_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminBusinessFlagsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'admin/business/flags', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminBusinessFlagsGetResponseBody>(api, 'get', 'admin/business/flags', data, signal),
    })
}

// POST admin/business/update-flag
export const useAdmin__business__updateFlagMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, BackendAPITypes.BACKENDPreHandleSyncApiV1AdminBusinessUpdateFlagPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1AdminBusinessUpdateFlagPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'admin/business/update-flag', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET admin/business/uploaded-documents
export const useAdmin__business__uploadedDocuments = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1AdminBusinessUploadedDocumentsGetResponseBody>(api: BackendAPIBlueprint, params: {business_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminBusinessUploadedDocumentsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {business_id: params.business_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminBusinessUploadedDocumentsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'admin/business/uploaded-documents', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminBusinessUploadedDocumentsGetResponseBody>(api, 'get', 'admin/business/uploaded-documents', data, signal),
    })
}

// GET admin/businesses
export const useAdmin__businesses = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1AdminBusinessesGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminBusinessesGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminBusinessesGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'admin/businesses', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminBusinessesGetResponseBody>(api, 'get', 'admin/businesses', data, signal),
    })
}

// POST admin/get-user-details
export const useAdmin__getUserDetailsMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, BackendAPITypes.BACKENDPreHandleSyncApiV1AdminGetUserDetailsPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1AdminGetUserDetailsPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'admin/get-user-details', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST admin/grant-business-access
export const useAdmin__grantBusinessAccessMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, BackendAPITypes.BACKENDPreHandleSyncApiV1AdminGrantBusinessAccessPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1AdminGrantBusinessAccessPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'admin/grant-business-access', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET admin/graph/business/get-daily-balance-with-forecast
export const useAdmin__graph__business__getDailyBalanceWithForecast = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1AdminGraphBusinessGetDailyBalanceWithForecastGetResponseBody>(api: BackendAPIBlueprint, params: {business_id: string, bank_account_id: string, start_date?: null | string, end_date?: null | string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminGraphBusinessGetDailyBalanceWithForecastGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {business_id: params.business_id, bank_account_id: params.bank_account_id, start_date: params.start_date, end_date: params.end_date}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminGraphBusinessGetDailyBalanceWithForecastGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'admin/graph/business/get-daily-balance-with-forecast', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminGraphBusinessGetDailyBalanceWithForecastGetResponseBody>(api, 'get', 'admin/graph/business/get-daily-balance-with-forecast', data, signal),
    })
}

// POST admin/insights/create-insight
export const useAdmin__insights__createInsightMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminInsightsCreateInsightPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1AdminInsightsCreateInsightPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminInsightsCreateInsightPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1AdminInsightsCreateInsightPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminInsightsCreateInsightPostResponseBody>(api, 'post', 'admin/insights/create-insight', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET admin/partner/demo
export const useAdmin__partner__demo = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1AdminPartnerDemoGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminPartnerDemoGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminPartnerDemoGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'admin/partner/demo', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminPartnerDemoGetResponseBody>(api, 'get', 'admin/partner/demo', data, signal),
    })
}

// POST admin/partner/demo/configure
export const useAdmin__partner__demo__configureMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminPartnerDemoConfigurePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1AdminPartnerDemoConfigurePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminPartnerDemoConfigurePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1AdminPartnerDemoConfigurePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1AdminPartnerDemoConfigurePostResponseBody>(api, 'post', 'admin/partner/demo/configure', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST admin/revoke-business-access
export const useAdmin__revokeBusinessAccessMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, BackendAPITypes.BACKENDPreHandleSyncApiV1AdminRevokeBusinessAccessPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1AdminRevokeBusinessAccessPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'admin/revoke-business-access', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST bank-account/add-credit-card
export const useBankAccount__addCreditCardMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1BankAccountAddCreditCardPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1BankAccountAddCreditCardPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1BankAccountAddCreditCardPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1BankAccountAddCreditCardPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1BankAccountAddCreditCardPostResponseBody>(api, 'post', 'bank-account/add-credit-card', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST bank-account/add-savings-account
export const useBankAccount__addSavingsAccountMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1BankAccountAddSavingsAccountPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1BankAccountAddSavingsAccountPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1BankAccountAddSavingsAccountPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1BankAccountAddSavingsAccountPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1BankAccountAddSavingsAccountPostResponseBody>(api, 'post', 'bank-account/add-savings-account', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET bank-account/my-bank-accounts
export const useBankAccount__myBankAccounts = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1BankAccountMyBankAccountsGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1BankAccountMyBankAccountsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1BankAccountMyBankAccountsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'bank-account/my-bank-accounts', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1BankAccountMyBankAccountsGetResponseBody>(api, 'get', 'bank-account/my-bank-accounts', data, signal),
    })
}

// GET bank/logo
export const useBank__logo = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1BankLogoGetResponseBody>(api: BackendAPIBlueprint, params: {bank_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1BankLogoGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {bank_id: params.bank_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1BankLogoGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'bank/logo', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1BankLogoGetResponseBody>(api, 'get', 'bank/logo', data, signal),
    })
}

// GET business/bank-transactions
export const useBusiness__bankTransactions = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessBankTransactionsGetResponseBody>(api: BackendAPIBlueprint, params: {business_id: string, order_by?: null | string, order_descending?: boolean | null, page?: number, page_size?: number}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessBankTransactionsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {business_id: params.business_id, order_by: params.order_by, order_descending: params.order_descending, page: params.page === undefined ? 0 : params.page, page_size: params.page_size === undefined ? 100 : params.page_size}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessBankTransactionsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'business/bank-transactions', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessBankTransactionsGetResponseBody>(api, 'get', 'business/bank-transactions', data, signal),
    })
}

// GET business/connect-financial-service
export const useBusiness__connectFinancialService = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessConnectFinancialServiceGetResponseBody>(api: BackendAPIBlueprint, params: {app_hostname?: null | string, institution_id?: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessConnectFinancialServiceGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {app_hostname: params.app_hostname, institution_id: params.institution_id === undefined ? "PAYMENT_MOLLIE_NL" : params.institution_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessConnectFinancialServiceGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'business/connect-financial-service', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessConnectFinancialServiceGetResponseBody>(api, 'get', 'business/connect-financial-service', data, signal),
    })
}

// POST business/invoice/generate-from-prompt
export const useBusiness__invoice__generateFromPromptMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessInvoiceGenerateFromPromptPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessInvoiceGenerateFromPromptPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessInvoiceGenerateFromPromptPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessInvoiceGenerateFromPromptPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessInvoiceGenerateFromPromptPostResponseBody>(api, 'post', 'business/invoice/generate-from-prompt', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST business/mark-connection-complete
export const useBusiness__markConnectionCompleteMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessMarkConnectionCompletePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessMarkConnectionCompletePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessMarkConnectionCompletePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessMarkConnectionCompletePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessMarkConnectionCompletePostResponseBody>(api, 'post', 'business/mark-connection-complete', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET business/my-business
export const useBusiness__myBusiness = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessMyBusinessGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessMyBusinessGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessMyBusinessGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'business/my-business', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessMyBusinessGetResponseBody>(api, 'get', 'business/my-business', data, signal),
    })
}

// GET business/my-connections
export const useBusiness__myConnections = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessMyConnectionsGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessMyConnectionsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessMyConnectionsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'business/my-connections', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessMyConnectionsGetResponseBody>(api, 'get', 'business/my-connections', data, signal),
    })
}

// GET business/my-subscriptions
export const useBusiness__mySubscriptions = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessMySubscriptionsGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessMySubscriptionsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessMySubscriptionsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'business/my-subscriptions', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessMySubscriptionsGetResponseBody>(api, 'get', 'business/my-subscriptions', data, signal),
    })
}

// GET business/relations/all-relations
export const useBusiness__relations__allRelations = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessRelationsAllRelationsGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessRelationsAllRelationsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessRelationsAllRelationsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'business/relations/all-relations', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessRelationsAllRelationsGetResponseBody>(api, 'get', 'business/relations/all-relations', data, signal),
    })
}

// GET business/stats/get-monthly-transaction-category-breakdown
export const useBusiness__stats__getMonthlyTransactionCategoryBreakdown = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessStatsGetMonthlyTransactionCategoryBreakdownGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessStatsGetMonthlyTransactionCategoryBreakdownGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessStatsGetMonthlyTransactionCategoryBreakdownGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'business/stats/get-monthly-transaction-category-breakdown', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessStatsGetMonthlyTransactionCategoryBreakdownGetResponseBody>(api, 'get', 'business/stats/get-monthly-transaction-category-breakdown', data, signal),
    })
}

// GET business/stats/month-overview
export const useBusiness__stats__monthOverview = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessStatsMonthOverviewGetResponseBody>(api: BackendAPIBlueprint, params: {year: number, month: number, bank_account_id?: null | string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessStatsMonthOverviewGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {year: params.year, month: params.month, bank_account_id: params.bank_account_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessStatsMonthOverviewGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'business/stats/month-overview', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessStatsMonthOverviewGetResponseBody>(api, 'get', 'business/stats/month-overview', data, signal),
    })
}

// GET business/tax/history
export const useBusiness__tax__history = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessTaxHistoryGetResponseBody>(api: BackendAPIBlueprint, params: {business_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessTaxHistoryGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {business_id: params.business_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessTaxHistoryGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'business/tax/history', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1BusinessTaxHistoryGetResponseBody>(api, 'get', 'business/tax/history', data, signal),
    })
}

// POST categorization-engine/exclude-transaction-from-matching
export const useCategorizationEngine__excludeTransactionFromMatchingMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1CategorizationEngineExcludeTransactionFromMatchingPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1CategorizationEngineExcludeTransactionFromMatchingPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1CategorizationEngineExcludeTransactionFromMatchingPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1CategorizationEngineExcludeTransactionFromMatchingPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1CategorizationEngineExcludeTransactionFromMatchingPostResponseBody>(api, 'post', 'categorization-engine/exclude-transaction-from-matching', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST categorization-engine/recategorize-transaction
export const useCategorizationEngine__recategorizeTransactionMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, BackendAPITypes.BACKENDPreHandleSyncApiV1CategorizationEngineRecategorizeTransactionPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1CategorizationEngineRecategorizeTransactionPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'categorization-engine/recategorize-transaction', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST categorization-engine/undo-book-away
export const useCategorizationEngine__undoBookAwayMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1CategorizationEngineUndoBookAwayPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1CategorizationEngineUndoBookAwayPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1CategorizationEngineUndoBookAwayPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1CategorizationEngineUndoBookAwayPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1CategorizationEngineUndoBookAwayPostResponseBody>(api, 'post', 'categorization-engine/undo-book-away', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST catestial/bulk/categorize-transactions
export const useCatestial__bulk__categorizeTransactionsMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, BackendAPITypes.BACKENDPreHandleSyncApiV1CatestialBulkCategorizeTransactionsPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1CatestialBulkCategorizeTransactionsPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'catestial/bulk/categorize-transactions', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST catestial/categorize-transactions
export const useCatestial__categorizeTransactionsMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, BackendAPITypes.BACKENDPreHandleSyncApiV1CatestialCategorizeTransactionsPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1CatestialCategorizeTransactionsPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'catestial/categorize-transactions', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST cron/document-collection/process-documents
export const useCron__documentCollection__processDocumentsMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1CronDocumentCollectionProcessDocumentsPostResponseBody, any>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1CronDocumentCollectionProcessDocumentsPostResponseBody, ApiError, any>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1CronDocumentCollectionProcessDocumentsPostResponseBody>(api, 'post', 'cron/document-collection/process-documents', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST cron/document-collection/reprocess-documents-in-error
export const useCron__documentCollection__reprocessDocumentsInErrorMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1CronDocumentCollectionReprocessDocumentsInErrorPostResponseBody, any>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1CronDocumentCollectionReprocessDocumentsInErrorPostResponseBody, ApiError, any>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1CronDocumentCollectionReprocessDocumentsInErrorPostResponseBody>(api, 'post', 'cron/document-collection/reprocess-documents-in-error', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST cron/document-forward/forward-pending-documents
export const useCron__documentForward__forwardPendingDocumentsMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1CronDocumentForwardForwardPendingDocumentsPostResponseBody, any>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1CronDocumentForwardForwardPendingDocumentsPostResponseBody, ApiError, any>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1CronDocumentForwardForwardPendingDocumentsPostResponseBody>(api, 'post', 'cron/document-forward/forward-pending-documents', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST cron/import-open-banking-data
export const useCron__importOpenBankingDataMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1CronImportOpenBankingDataPostResponseBody, any>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1CronImportOpenBankingDataPostResponseBody, ApiError, any>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1CronImportOpenBankingDataPostResponseBody>(api, 'post', 'cron/import-open-banking-data', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST cron/process-budgets-for-all-businesses
export const useCron__processBudgetsForAllBusinessesMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, any>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, any>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'cron/process-budgets-for-all-businesses', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST cron/process-insights
export const useCron__processInsightsMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1CronProcessInsightsPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1CronProcessInsightsPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1CronProcessInsightsPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1CronProcessInsightsPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1CronProcessInsightsPostResponseBody>(api, 'post', 'cron/process-insights', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST cron/quinn/reap-abandoned-runs
export const useCron__quinn__reapAbandonedRunsMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1CronQuinnReapAbandonedRunsPostResponseBody, any>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1CronQuinnReapAbandonedRunsPostResponseBody, ApiError, any>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1CronQuinnReapAbandonedRunsPostResponseBody>(api, 'post', 'cron/quinn/reap-abandoned-runs', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST cron/run-transaction-processing-pipeline
export const useCron__runTransactionProcessingPipelineMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, any>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, any>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'cron/run-transaction-processing-pipeline', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST cron/trigger-reconciliation
export const useCron__triggerReconciliationMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1CronTriggerReconciliationPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1CronTriggerReconciliationPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1CronTriggerReconciliationPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1CronTriggerReconciliationPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1CronTriggerReconciliationPostResponseBody>(api, 'post', 'cron/trigger-reconciliation', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST document-collection/reprocess-documents-without-scanning
export const useDocumentCollection__reprocessDocumentsWithoutScanningMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1DocumentCollectionReprocessDocumentsWithoutScanningPostResponseBody, any>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1DocumentCollectionReprocessDocumentsWithoutScanningPostResponseBody, ApiError, any>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1DocumentCollectionReprocessDocumentsWithoutScanningPostResponseBody>(api, 'post', 'document-collection/reprocess-documents-without-scanning', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST entrepreneur/approve-vat-declaration
export const useEntrepreneur__approveVatDeclarationMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurApproveVatDeclarationPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurApproveVatDeclarationPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurApproveVatDeclarationPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurApproveVatDeclarationPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurApproveVatDeclarationPostResponseBody>(api, 'post', 'entrepreneur/approve-vat-declaration', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST entrepreneur/cancel-draft-match
export const useEntrepreneur__cancelDraftMatchMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurCancelDraftMatchPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurCancelDraftMatchPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurCancelDraftMatchPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurCancelDraftMatchPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurCancelDraftMatchPostResponseBody>(api, 'post', 'entrepreneur/cancel-draft-match', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST entrepreneur/create-business
export const useEntrepreneur__createBusinessMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurCreateBusinessPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurCreateBusinessPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'entrepreneur/create-business', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET entrepreneur/document-collection-email
export const useEntrepreneur__documentCollectionEmail = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurDocumentCollectionEmailGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurDocumentCollectionEmailGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurDocumentCollectionEmailGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'entrepreneur/document-collection-email', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurDocumentCollectionEmailGetResponseBody>(api, 'get', 'entrepreneur/document-collection-email', data, signal),
    })
}

// POST entrepreneur/documents/report-incorrect
export const useEntrepreneur__documents__reportIncorrectMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurDocumentsReportIncorrectPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurDocumentsReportIncorrectPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurDocumentsReportIncorrectPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurDocumentsReportIncorrectPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurDocumentsReportIncorrectPostResponseBody>(api, 'post', 'entrepreneur/documents/report-incorrect', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET entrepreneur/get-pending-draft-matches
export const useEntrepreneur__getPendingDraftMatches = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurGetPendingDraftMatchesGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurGetPendingDraftMatchesGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurGetPendingDraftMatchesGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'entrepreneur/get-pending-draft-matches', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurGetPendingDraftMatchesGetResponseBody>(api, 'get', 'entrepreneur/get-pending-draft-matches', data, signal),
    })
}

// GET entrepreneur/get-unmatched-transactions
export const useEntrepreneur__getUnmatchedTransactions = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurGetUnmatchedTransactionsGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurGetUnmatchedTransactionsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurGetUnmatchedTransactionsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'entrepreneur/get-unmatched-transactions', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurGetUnmatchedTransactionsGetResponseBody>(api, 'get', 'entrepreneur/get-unmatched-transactions', data, signal),
    })
}

// GET entrepreneur/get-vat-declaration-approval-request
export const useEntrepreneur__getVatDeclarationApprovalRequest = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurGetVatDeclarationApprovalRequestGetResponseBody>(api: BackendAPIBlueprint, params: {request_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurGetVatDeclarationApprovalRequestGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {request_id: params.request_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurGetVatDeclarationApprovalRequestGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'entrepreneur/get-vat-declaration-approval-request', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurGetVatDeclarationApprovalRequestGetResponseBody>(api, 'get', 'entrepreneur/get-vat-declaration-approval-request', data, signal),
    })
}

// POST entrepreneur/mark-transaction-as-private
export const useEntrepreneur__markTransactionAsPrivateMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurMarkTransactionAsPrivatePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurMarkTransactionAsPrivatePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurMarkTransactionAsPrivatePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurMarkTransactionAsPrivatePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurMarkTransactionAsPrivatePostResponseBody>(api, 'post', 'entrepreneur/mark-transaction-as-private', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET entrepreneur/outstanding-bills
export const useEntrepreneur__outstandingBills = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurOutstandingBillsGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurOutstandingBillsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurOutstandingBillsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'entrepreneur/outstanding-bills', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurOutstandingBillsGetResponseBody>(api, 'get', 'entrepreneur/outstanding-bills', data, signal),
    })
}

// POST entrepreneur/reject-vat-declaration
export const useEntrepreneur__rejectVatDeclarationMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurRejectVatDeclarationPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurRejectVatDeclarationPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurRejectVatDeclarationPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurRejectVatDeclarationPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurRejectVatDeclarationPostResponseBody>(api, 'post', 'entrepreneur/reject-vat-declaration', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET entrepreneur/uploaded-documents
export const useEntrepreneur__uploadedDocuments = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurUploadedDocumentsGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurUploadedDocumentsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurUploadedDocumentsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'entrepreneur/uploaded-documents', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1EntrepreneurUploadedDocumentsGetResponseBody>(api, 'get', 'entrepreneur/uploaded-documents', data, signal),
    })
}

// GET general-ledger-accounts
export const useGeneralLedgerAccounts = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1GeneralLedgerAccountsGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1GeneralLedgerAccountsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1GeneralLedgerAccountsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'general-ledger-accounts', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1GeneralLedgerAccountsGetResponseBody>(api, 'get', 'general-ledger-accounts', data, signal),
    })
}

// POST generate-forecast-for-demo
export const useGenerateForecastForDemoMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, any>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, any>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'generate-forecast-for-demo', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET get-banks-by-country-code
export const useGetBanksByCountryCode = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1GetBanksByCountryCodeGetResponseBody>(api: BackendAPIBlueprint, params: {country_code: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1GetBanksByCountryCodeGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {country_code: params.country_code}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1GetBanksByCountryCodeGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'get-banks-by-country-code', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1GetBanksByCountryCodeGetResponseBody>(api, 'get', 'get-banks-by-country-code', data, signal),
    })
}

// POST initiate-bank-connection
export const useInitiateBankConnectionMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1InitiateBankConnectionPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1InitiateBankConnectionPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1InitiateBankConnectionPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1InitiateBankConnectionPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1InitiateBankConnectionPostResponseBody>(api, 'post', 'initiate-bank-connection', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET insights
export const useInsights = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1InsightsGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1InsightsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1InsightsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'insights', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1InsightsGetResponseBody>(api, 'get', 'insights', data, signal),
    })
}

// POST insights/mark-insights-read
export const useInsights__markInsightsReadMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1InsightsMarkInsightsReadPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1InsightsMarkInsightsReadPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1InsightsMarkInsightsReadPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1InsightsMarkInsightsReadPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1InsightsMarkInsightsReadPostResponseBody>(api, 'post', 'insights/mark-insights-read', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET insights/unread-insights
export const useInsights__unreadInsights = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1InsightsUnreadInsightsGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1InsightsUnreadInsightsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1InsightsUnreadInsightsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'insights/unread-insights', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1InsightsUnreadInsightsGetResponseBody>(api, 'get', 'insights/unread-insights', data, signal),
    })
}

// POST manual/reprocess-transaction
export const useManual__reprocessTransactionMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, BackendAPITypes.BACKENDPreHandleSyncApiV1ManualReprocessTransactionPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1ManualReprocessTransactionPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'manual/reprocess-transaction', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST manual/reprocess-transaction-for-business
export const useManual__reprocessTransactionForBusinessMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, BackendAPITypes.BACKENDPreHandleSyncApiV1ManualReprocessTransactionForBusinessPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1ManualReprocessTransactionForBusinessPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'manual/reprocess-transaction-for-business', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST mark-bank-as-connected
export const useMarkBankAsConnectedMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, BackendAPITypes.BACKENDPreHandleSyncApiV1MarkBankAsConnectedPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MarkBankAsConnectedPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'mark-bank-as-connected', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST mark-bank-connection-as-failed
export const useMarkBankConnectionAsFailedMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, BackendAPITypes.BACKENDPreHandleSyncApiV1MarkBankConnectionAsFailedPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MarkBankConnectionAsFailedPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'mark-bank-connection-as-failed', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST me/business/archive-catalogue-item
export const useMe__business__archiveCatalogueItemMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessArchiveCatalogueItemPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessArchiveCatalogueItemPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessArchiveCatalogueItemPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessArchiveCatalogueItemPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessArchiveCatalogueItemPostResponseBody>(api, 'post', 'me/business/archive-catalogue-item', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST me/business/archive-customer
export const useMe__business__archiveCustomerMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessArchiveCustomerPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessArchiveCustomerPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'me/business/archive-customer', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST me/business/change-catalogue-item
export const useMe__business__changeCatalogueItemMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeCatalogueItemPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeCatalogueItemPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeCatalogueItemPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeCatalogueItemPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeCatalogueItemPostResponseBody>(api, 'post', 'me/business/change-catalogue-item', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST me/business/change-customer
export const useMe__business__changeCustomerMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeCustomerPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeCustomerPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeCustomerPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeCustomerPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeCustomerPostResponseBody>(api, 'post', 'me/business/change-customer', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST me/business/change-recurring-sales-invoice
export const useMe__business__changeRecurringSalesInvoiceMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeRecurringSalesInvoicePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeRecurringSalesInvoicePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeRecurringSalesInvoicePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeRecurringSalesInvoicePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeRecurringSalesInvoicePostResponseBody>(api, 'post', 'me/business/change-recurring-sales-invoice', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST me/business/change-sales-invoice-draft
export const useMe__business__changeSalesInvoiceDraftMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeSalesInvoiceDraftPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeSalesInvoiceDraftPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeSalesInvoiceDraftPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeSalesInvoiceDraftPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeSalesInvoiceDraftPostResponseBody>(api, 'post', 'me/business/change-sales-invoice-draft', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST me/business/change-sales-invoice-reminder-settings
export const useMe__business__changeSalesInvoiceReminderSettingsMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeSalesInvoiceReminderSettingsPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeSalesInvoiceReminderSettingsPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeSalesInvoiceReminderSettingsPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeSalesInvoiceReminderSettingsPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessChangeSalesInvoiceReminderSettingsPostResponseBody>(api, 'post', 'me/business/change-sales-invoice-reminder-settings', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST me/business/create-catalogue-item
export const useMe__business__createCatalogueItemMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateCatalogueItemPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateCatalogueItemPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateCatalogueItemPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateCatalogueItemPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateCatalogueItemPostResponseBody>(api, 'post', 'me/business/create-catalogue-item', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST me/business/create-customer
export const useMe__business__createCustomerMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateCustomerPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateCustomerPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateCustomerPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateCustomerPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateCustomerPostResponseBody>(api, 'post', 'me/business/create-customer', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST me/business/create-recurring-sales-invoice
export const useMe__business__createRecurringSalesInvoiceMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateRecurringSalesInvoicePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateRecurringSalesInvoicePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateRecurringSalesInvoicePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateRecurringSalesInvoicePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateRecurringSalesInvoicePostResponseBody>(api, 'post', 'me/business/create-recurring-sales-invoice', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST me/business/create-sales-invoice-draft
export const useMe__business__createSalesInvoiceDraftMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateSalesInvoiceDraftPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateSalesInvoiceDraftPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateSalesInvoiceDraftPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateSalesInvoiceDraftPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreateSalesInvoiceDraftPostResponseBody>(api, 'post', 'me/business/create-sales-invoice-draft', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST me/business/credit-sales-invoice
export const useMe__business__creditSalesInvoiceMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreditSalesInvoicePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreditSalesInvoicePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreditSalesInvoicePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreditSalesInvoicePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessCreditSalesInvoicePostResponseBody>(api, 'post', 'me/business/credit-sales-invoice', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST me/business/delete-recurring-sales-invoice
export const useMe__business__deleteRecurringSalesInvoiceMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessDeleteRecurringSalesInvoicePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessDeleteRecurringSalesInvoicePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'me/business/delete-recurring-sales-invoice', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST me/business/discard-sales-invoice-draft
export const useMe__business__discardSalesInvoiceDraftMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessDiscardSalesInvoiceDraftPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessDiscardSalesInvoiceDraftPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessDiscardSalesInvoiceDraftPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessDiscardSalesInvoiceDraftPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessDiscardSalesInvoiceDraftPostResponseBody>(api, 'post', 'me/business/discard-sales-invoice-draft', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST me/business/edit-base-business-information
export const useMe__business__editBaseBusinessInformationMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessEditBaseBusinessInformationPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessEditBaseBusinessInformationPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessEditBaseBusinessInformationPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessEditBaseBusinessInformationPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessEditBaseBusinessInformationPostResponseBody>(api, 'post', 'me/business/edit-base-business-information', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST me/business/generate-sales-invoice
export const useMe__business__generateSalesInvoiceMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGenerateSalesInvoicePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGenerateSalesInvoicePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGenerateSalesInvoicePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGenerateSalesInvoicePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGenerateSalesInvoicePostResponseBody>(api, 'post', 'me/business/generate-sales-invoice', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET me/business/get-catalogue-items
export const useMe__business__getCatalogueItems = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetCatalogueItemsGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetCatalogueItemsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetCatalogueItemsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'me/business/get-catalogue-items', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetCatalogueItemsGetResponseBody>(api, 'get', 'me/business/get-catalogue-items', data, signal),
    })
}

// GET me/business/get-customers
export const useMe__business__getCustomers = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetCustomersGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetCustomersGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetCustomersGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'me/business/get-customers', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetCustomersGetResponseBody>(api, 'get', 'me/business/get-customers', data, signal),
    })
}

// GET me/business/get-recurring-sales-invoices
export const useMe__business__getRecurringSalesInvoices = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetRecurringSalesInvoicesGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetRecurringSalesInvoicesGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetRecurringSalesInvoicesGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'me/business/get-recurring-sales-invoices', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetRecurringSalesInvoicesGetResponseBody>(api, 'get', 'me/business/get-recurring-sales-invoices', data, signal),
    })
}

// GET me/business/get-sales-invoice
export const useMe__business__getSalesInvoice = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoiceGetResponseBody>(api: BackendAPIBlueprint, params: {invoice_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoiceGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {invoice_id: params.invoice_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoiceGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'me/business/get-sales-invoice', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoiceGetResponseBody>(api, 'get', 'me/business/get-sales-invoice', data, signal),
    })
}

// GET me/business/get-sales-invoice-drafts
export const useMe__business__getSalesInvoiceDrafts = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoiceDraftsGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoiceDraftsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoiceDraftsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'me/business/get-sales-invoice-drafts', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoiceDraftsGetResponseBody>(api, 'get', 'me/business/get-sales-invoice-drafts', data, signal),
    })
}

// GET me/business/get-sales-invoice-numbering
export const useMe__business__getSalesInvoiceNumbering = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoiceNumberingGetResponseBody>(api: BackendAPIBlueprint, params: {year: number, prefix?: null | string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoiceNumberingGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {year: params.year, prefix: params.prefix}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoiceNumberingGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'me/business/get-sales-invoice-numbering', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoiceNumberingGetResponseBody>(api, 'get', 'me/business/get-sales-invoice-numbering', data, signal),
    })
}

// GET me/business/get-sales-invoice-timeline
export const useMe__business__getSalesInvoiceTimeline = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoiceTimelineGetResponseBody>(api: BackendAPIBlueprint, params: {invoice_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoiceTimelineGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {invoice_id: params.invoice_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoiceTimelineGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'me/business/get-sales-invoice-timeline', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoiceTimelineGetResponseBody>(api, 'get', 'me/business/get-sales-invoice-timeline', data, signal),
    })
}

// GET me/business/get-sales-invoices
export const useMe__business__getSalesInvoices = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoicesGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoicesGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoicesGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'me/business/get-sales-invoices', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessGetSalesInvoicesGetResponseBody>(api, 'get', 'me/business/get-sales-invoices', data, signal),
    })
}

// POST me/business/issue-sales-invoice
export const useMe__business__issueSalesInvoiceMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessIssueSalesInvoicePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessIssueSalesInvoicePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessIssueSalesInvoicePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessIssueSalesInvoicePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessIssueSalesInvoicePostResponseBody>(api, 'post', 'me/business/issue-sales-invoice', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET me/business/logo
export const useMe__business__logo = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessLogoGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessLogoGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessLogoGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'me/business/logo', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessLogoGetResponseBody>(api, 'get', 'me/business/logo', data, signal),
    })
}

// POST me/business/pause-recurring-sales-invoice
export const useMe__business__pauseRecurringSalesInvoiceMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessPauseRecurringSalesInvoicePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessPauseRecurringSalesInvoicePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessPauseRecurringSalesInvoicePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessPauseRecurringSalesInvoicePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessPauseRecurringSalesInvoicePostResponseBody>(api, 'post', 'me/business/pause-recurring-sales-invoice', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST me/business/preview-sales-invoice
export const useMe__business__previewSalesInvoiceMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessPreviewSalesInvoicePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessPreviewSalesInvoicePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'me/business/preview-sales-invoice', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST me/business/resend-sales-invoice
export const useMe__business__resendSalesInvoiceMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessResendSalesInvoicePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessResendSalesInvoicePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessResendSalesInvoicePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessResendSalesInvoicePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessResendSalesInvoicePostResponseBody>(api, 'post', 'me/business/resend-sales-invoice', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST me/business/resume-recurring-sales-invoice
export const useMe__business__resumeRecurringSalesInvoiceMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessResumeRecurringSalesInvoicePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessResumeRecurringSalesInvoicePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessResumeRecurringSalesInvoicePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessResumeRecurringSalesInvoicePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessResumeRecurringSalesInvoicePostResponseBody>(api, 'post', 'me/business/resume-recurring-sales-invoice', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST me/business/send-sales-invoice
export const useMe__business__sendSalesInvoiceMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessSendSalesInvoicePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessSendSalesInvoicePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessSendSalesInvoicePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessSendSalesInvoicePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessSendSalesInvoicePostResponseBody>(api, 'post', 'me/business/send-sales-invoice', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST me/business/send-sales-invoice-reminder
export const useMe__business__sendSalesInvoiceReminderMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessSendSalesInvoiceReminderPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessSendSalesInvoiceReminderPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessSendSalesInvoiceReminderPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessSendSalesInvoiceReminderPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessSendSalesInvoiceReminderPostResponseBody>(api, 'post', 'me/business/send-sales-invoice-reminder', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET me/business/settings
export const useMe__business__settings = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessSettingsGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessSettingsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessSettingsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'me/business/settings', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessSettingsGetResponseBody>(api, 'get', 'me/business/settings', data, signal),
    })
}

// POST me/business/update-setting
export const useMe__business__updateSettingMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessUpdateSettingPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessUpdateSettingPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessUpdateSettingPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessUpdateSettingPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeBusinessUpdateSettingPostResponseBody>(api, 'post', 'me/business/update-setting', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET me/notices
export const useMe__notices = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1MeNoticesGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeNoticesGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1MeNoticesGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'me/notices', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeNoticesGetResponseBody>(api, 'get', 'me/notices', data, signal),
    })
}

// GET me/settings
export const useMe__settings = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1MeSettingsGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeSettingsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1MeSettingsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'me/settings', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeSettingsGetResponseBody>(api, 'get', 'me/settings', data, signal),
    })
}

// POST me/settings/change-setting
export const useMe__settings__changeSettingMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeSettingsChangeSettingPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1MeSettingsChangeSettingPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1MeSettingsChangeSettingPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeSettingsChangeSettingPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeSettingsChangeSettingPostResponseBody>(api, 'post', 'me/settings/change-setting', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST me/update-flag
export const useMe__updateFlagMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, BackendAPITypes.BACKENDPreHandleSyncApiV1MeUpdateFlagPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeUpdateFlagPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'me/update-flag', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST me/user-device/deregister-device
export const useMe__userDevice__deregisterDeviceMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeUserDeviceDeregisterDevicePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1MeUserDeviceDeregisterDevicePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1MeUserDeviceDeregisterDevicePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeUserDeviceDeregisterDevicePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeUserDeviceDeregisterDevicePostResponseBody>(api, 'post', 'me/user-device/deregister-device', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST me/user-device/register-device
export const useMe__userDevice__registerDeviceMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeUserDeviceRegisterDevicePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1MeUserDeviceRegisterDevicePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1MeUserDeviceRegisterDevicePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeUserDeviceRegisterDevicePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeUserDeviceRegisterDevicePostResponseBody>(api, 'post', 'me/user-device/register-device', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST me/user-device/send-test-message
export const useMe__userDevice__sendTestMessageMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MeUserDeviceSendTestMessagePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1MeUserDeviceSendTestMessagePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1MeUserDeviceSendTestMessagePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1MeUserDeviceSendTestMessagePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MeUserDeviceSendTestMessagePostResponseBody>(api, 'post', 'me/user-device/send-test-message', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET my-business/double-payments
export const useMyBusiness__doublePayments = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1MyBusinessDoublePaymentsGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1MyBusinessDoublePaymentsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1MyBusinessDoublePaymentsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'my-business/double-payments', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1MyBusinessDoublePaymentsGetResponseBody>(api, 'get', 'my-business/double-payments', data, signal),
    })
}

// POST onboarding/accept-invitation
export const useOnboarding__acceptInvitationMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, BackendAPITypes.BACKENDPreHandleSyncApiV1OnboardingAcceptInvitationPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1OnboardingAcceptInvitationPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'onboarding/accept-invitation', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST onboarding/create-sso-user
export const useOnboarding__createSsoUserMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, BackendAPITypes.BACKENDPreHandleSyncApiV1OnboardingCreateSsoUserPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1OnboardingCreateSsoUserPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'onboarding/create-sso-user', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST onboarding/create-user
export const useOnboarding__createUserMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, BackendAPITypes.BACKENDPreHandleSyncApiV1OnboardingCreateUserPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1OnboardingCreateUserPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'onboarding/create-user', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET onboarding/invitation
export const useOnboarding__invitation = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1OnboardingInvitationGetResponseBody>(api: BackendAPIBlueprint, params: {token: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1OnboardingInvitationGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {token: params.token}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1OnboardingInvitationGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'onboarding/invitation', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1OnboardingInvitationGetResponseBody>(api, 'get', 'onboarding/invitation', data, signal),
    })
}

// POST open-banking/handle-callback
export const useOpenBanking__handleCallbackMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1OpenBankingHandleCallbackPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1OpenBankingHandleCallbackPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1OpenBankingHandleCallbackPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1OpenBankingHandleCallbackPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1OpenBankingHandleCallbackPostResponseBody>(api, 'post', 'open-banking/handle-callback', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST open-banking/reconnect-bank-account
export const useOpenBanking__reconnectBankAccountMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1OpenBankingReconnectBankAccountPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1OpenBankingReconnectBankAccountPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1OpenBankingReconnectBankAccountPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1OpenBankingReconnectBankAccountPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1OpenBankingReconnectBankAccountPostResponseBody>(api, 'post', 'open-banking/reconnect-bank-account', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/book-to-general-ledger-account
export const usePartner__bookToGeneralLedgerAccountMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBookToGeneralLedgerAccountPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBookToGeneralLedgerAccountPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'partner/book-to-general-ledger-account', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET partner/business/booking-suggestions
export const usePartner__business__bookingSuggestions = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessBookingSuggestionsGetResponseBody>(api: BackendAPIBlueprint, params: {business_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessBookingSuggestionsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {business_id: params.business_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessBookingSuggestionsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/business/booking-suggestions', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessBookingSuggestionsGetResponseBody>(api, 'get', 'partner/business/booking-suggestions', data, signal),
    })
}

// POST partner/business/edit-booking-suggestions
export const usePartner__business__editBookingSuggestionsMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessEditBookingSuggestionsPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessEditBookingSuggestionsPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessEditBookingSuggestionsPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessEditBookingSuggestionsPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessEditBookingSuggestionsPostResponseBody>(api, 'post', 'partner/business/edit-booking-suggestions', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/business/edit-description
export const usePartner__business__editDescriptionMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessEditDescriptionPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessEditDescriptionPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessEditDescriptionPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessEditDescriptionPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessEditDescriptionPostResponseBody>(api, 'post', 'partner/business/edit-description', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET partner/business/settings
export const usePartner__business__settings = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessSettingsGetResponseBody>(api: BackendAPIBlueprint, params: {business_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessSettingsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {business_id: params.business_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessSettingsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/business/settings', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessSettingsGetResponseBody>(api, 'get', 'partner/business/settings', data, signal),
    })
}

// GET partner/business/stats/base-stats
export const usePartner__business__stats__baseStats = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessStatsBaseStatsGetResponseBody>(api: BackendAPIBlueprint, params: {business_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessStatsBaseStatsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {business_id: params.business_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessStatsBaseStatsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/business/stats/base-stats', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessStatsBaseStatsGetResponseBody>(api, 'get', 'partner/business/stats/base-stats', data, signal),
    })
}

// POST partner/business/update-setting
export const usePartner__business__updateSettingMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessUpdateSettingPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessUpdateSettingPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessUpdateSettingPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessUpdateSettingPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerBusinessUpdateSettingPostResponseBody>(api, 'post', 'partner/business/update-setting', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/client/bill/dismiss-todo
export const usePartner__client__bill__dismissTodoMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientBillDismissTodoPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientBillDismissTodoPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientBillDismissTodoPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientBillDismissTodoPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientBillDismissTodoPostResponseBody>(api, 'post', 'partner/client/bill/dismiss-todo', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET partner/client/bill/list-bill-todos
export const usePartner__client__bill__listBillTodos = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientBillListBillTodosGetResponseBody>(api: BackendAPIBlueprint, params: {bill_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientBillListBillTodosGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {bill_id: params.bill_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientBillListBillTodosGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/client/bill/list-bill-todos', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientBillListBillTodosGetResponseBody>(api, 'get', 'partner/client/bill/list-bill-todos', data, signal),
    })
}

// POST partner/client/document/delete
export const usePartner__client__document__deleteMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientDocumentDeletePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientDocumentDeletePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientDocumentDeletePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientDocumentDeletePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientDocumentDeletePostResponseBody>(api, 'post', 'partner/client/document/delete', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/client/document/edit-document-fields
export const usePartner__client__document__editDocumentFieldsMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientDocumentEditDocumentFieldsPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientDocumentEditDocumentFieldsPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientDocumentEditDocumentFieldsPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientDocumentEditDocumentFieldsPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientDocumentEditDocumentFieldsPostResponseBody>(api, 'post', 'partner/client/document/edit-document-fields', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/client/document/validate-document-fields
export const usePartner__client__document__validateDocumentFieldsMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientDocumentValidateDocumentFieldsPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientDocumentValidateDocumentFieldsPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientDocumentValidateDocumentFieldsPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientDocumentValidateDocumentFieldsPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientDocumentValidateDocumentFieldsPostResponseBody>(api, 'post', 'partner/client/document/validate-document-fields', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET partner/client/get-bill-duplicates
export const usePartner__client__getBillDuplicates = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientGetBillDuplicatesGetResponseBody>(api: BackendAPIBlueprint, params: {bill_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientGetBillDuplicatesGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {bill_id: params.bill_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientGetBillDuplicatesGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/client/get-bill-duplicates', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientGetBillDuplicatesGetResponseBody>(api, 'get', 'partner/client/get-bill-duplicates', data, signal),
    })
}

// GET partner/client/get-completeness-score
export const usePartner__client__getCompletenessScore = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientGetCompletenessScoreGetResponseBody>(api: BackendAPIBlueprint, params: {client_business_id: string, date_from: string, date_to: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientGetCompletenessScoreGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {client_business_id: params.client_business_id, date_from: params.date_from, date_to: params.date_to}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientGetCompletenessScoreGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/client/get-completeness-score', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientGetCompletenessScoreGetResponseBody>(api, 'get', 'partner/client/get-completeness-score', data, signal),
    })
}

// GET partner/client/get-document
export const usePartner__client__getDocument = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientGetDocumentGetResponseBody>(api: BackendAPIBlueprint, params: {business_id: string, document_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientGetDocumentGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {business_id: params.business_id, document_id: params.document_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientGetDocumentGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/client/get-document', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientGetDocumentGetResponseBody>(api, 'get', 'partner/client/get-document', data, signal),
    })
}

// GET partner/client/matches
export const usePartner__client__matches = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientMatchesGetResponseBody>(api: BackendAPIBlueprint, params: {from_date: string, until_date: string, business_id?: null | string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientMatchesGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {from_date: params.from_date, until_date: params.until_date, business_id: params.business_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientMatchesGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/client/matches', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientMatchesGetResponseBody>(api, 'get', 'partner/client/matches', data, signal),
    })
}

// POST partner/client/unmatch-and-delete-bill
export const usePartner__client__unmatchAndDeleteBillMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientUnmatchAndDeleteBillPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientUnmatchAndDeleteBillPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientUnmatchAndDeleteBillPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientUnmatchAndDeleteBillPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientUnmatchAndDeleteBillPostResponseBody>(api, 'post', 'partner/client/unmatch-and-delete-bill', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET partner/client/uploaded-documents
export const usePartner__client__uploadedDocuments = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientUploadedDocumentsGetResponseBody>(api: BackendAPIBlueprint, params: {business_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientUploadedDocumentsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {business_id: params.business_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientUploadedDocumentsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/client/uploaded-documents', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerClientUploadedDocumentsGetResponseBody>(api, 'get', 'partner/client/uploaded-documents', data, signal),
    })
}

// GET partner/compute-vat-declaration
export const usePartner__computeVatDeclaration = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerComputeVatDeclarationGetResponseBody>(api: BackendAPIBlueprint, params: {client_business_id: string, date_from: string, date_to: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerComputeVatDeclarationGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {client_business_id: params.client_business_id, date_from: params.date_from, date_to: params.date_to}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerComputeVatDeclarationGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/compute-vat-declaration', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerComputeVatDeclarationGetResponseBody>(api, 'get', 'partner/compute-vat-declaration', data, signal),
    })
}

// GET partner/connect-financial-service
export const usePartner__connectFinancialService = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerConnectFinancialServiceGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerConnectFinancialServiceGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerConnectFinancialServiceGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/connect-financial-service', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerConnectFinancialServiceGetResponseBody>(api, 'get', 'partner/connect-financial-service', data, signal),
    })
}

// POST partner/create-business
export const usePartner__createBusinessMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerCreateBusinessPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerCreateBusinessPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerCreateBusinessPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerCreateBusinessPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerCreateBusinessPostResponseBody>(api, 'post', 'partner/create-business', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/create-client-subledger
export const usePartner__createClientSubledgerMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerCreateClientSubledgerPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerCreateClientSubledgerPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerCreateClientSubledgerPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerCreateClientSubledgerPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerCreateClientSubledgerPostResponseBody>(api, 'post', 'partner/create-client-subledger', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/create-fixed-asset
export const usePartner__createFixedAssetMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerCreateFixedAssetPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerCreateFixedAssetPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerCreateFixedAssetPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerCreateFixedAssetPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerCreateFixedAssetPostResponseBody>(api, 'post', 'partner/create-fixed-asset', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/delete-automation-rule
export const usePartner__deleteAutomationRuleMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDeleteAutomationRulePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDeleteAutomationRulePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDeleteAutomationRulePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDeleteAutomationRulePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDeleteAutomationRulePostResponseBody>(api, 'post', 'partner/delete-automation-rule', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/delete-manual-booking
export const usePartner__deleteManualBookingMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDeleteManualBookingPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDeleteManualBookingPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDeleteManualBookingPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDeleteManualBookingPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDeleteManualBookingPostResponseBody>(api, 'post', 'partner/delete-manual-booking', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET partner/document-activity-documents
export const usePartner__documentActivityDocuments = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentActivityDocumentsGetResponseBody>(api: BackendAPIBlueprint, params: {business_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentActivityDocumentsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {business_id: params.business_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentActivityDocumentsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/document-activity-documents', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentActivityDocumentsGetResponseBody>(api, 'get', 'partner/document-activity-documents', data, signal),
    })
}

// POST partner/document/bill/convert-to-euro
export const usePartner__document__bill__convertToEuroMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentBillConvertToEuroPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentBillConvertToEuroPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentBillConvertToEuroPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentBillConvertToEuroPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentBillConvertToEuroPostResponseBody>(api, 'post', 'partner/document/bill/convert-to-euro', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/document/bill/mark-as-privately-paid
export const usePartner__document__bill__markAsPrivatelyPaidMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentBillMarkAsPrivatelyPaidPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentBillMarkAsPrivatelyPaidPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentBillMarkAsPrivatelyPaidPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentBillMarkAsPrivatelyPaidPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentBillMarkAsPrivatelyPaidPostResponseBody>(api, 'post', 'partner/document/bill/mark-as-privately-paid', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/document/bill/undo-mark-as-privately-paid
export const usePartner__document__bill__undoMarkAsPrivatelyPaidMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentBillUndoMarkAsPrivatelyPaidPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentBillUndoMarkAsPrivatelyPaidPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentBillUndoMarkAsPrivatelyPaidPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentBillUndoMarkAsPrivatelyPaidPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentBillUndoMarkAsPrivatelyPaidPostResponseBody>(api, 'post', 'partner/document/bill/undo-mark-as-privately-paid', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/document/toggle-document-vat-ignored
export const usePartner__document__toggleDocumentVatIgnoredMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentToggleDocumentVatIgnoredPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentToggleDocumentVatIgnoredPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentToggleDocumentVatIgnoredPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentToggleDocumentVatIgnoredPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerDocumentToggleDocumentVatIgnoredPostResponseBody>(api, 'post', 'partner/document/toggle-document-vat-ignored', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/edit-manual-booking
export const usePartner__editManualBookingMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerEditManualBookingPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerEditManualBookingPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerEditManualBookingPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerEditManualBookingPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerEditManualBookingPostResponseBody>(api, 'post', 'partner/edit-manual-booking', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET partner/entrepreneur/document-collection-email
export const usePartner__entrepreneur__documentCollectionEmail = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerEntrepreneurDocumentCollectionEmailGetResponseBody>(api: BackendAPIBlueprint, params: {business_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerEntrepreneurDocumentCollectionEmailGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {business_id: params.business_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerEntrepreneurDocumentCollectionEmailGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/entrepreneur/document-collection-email', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerEntrepreneurDocumentCollectionEmailGetResponseBody>(api, 'get', 'partner/entrepreneur/document-collection-email', data, signal),
    })
}

// GET partner/entrepreneur/get-bank-accounts
export const usePartner__entrepreneur__getBankAccounts = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerEntrepreneurGetBankAccountsGetResponseBody>(api: BackendAPIBlueprint, params: {business_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerEntrepreneurGetBankAccountsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {business_id: params.business_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerEntrepreneurGetBankAccountsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/entrepreneur/get-bank-accounts', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerEntrepreneurGetBankAccountsGetResponseBody>(api, 'get', 'partner/entrepreneur/get-bank-accounts', data, signal),
    })
}

// GET partner/export-client-balance-sheet
export const usePartner__exportClientBalanceSheet = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerExportClientBalanceSheetGetResponseBody>(api: BackendAPIBlueprint, params: {start_date: string, end_date: string, client_business_id: string, export_format: Enums.BalanceSheetExportFormat, currency?: Enums.CurrencyEnum, comparison_period?: null | string, show_predicted_accounts?: boolean}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerExportClientBalanceSheetGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {start_date: params.start_date, end_date: params.end_date, client_business_id: params.client_business_id, export_format: params.export_format, currency: params.currency, comparison_period: params.comparison_period, show_predicted_accounts: params.show_predicted_accounts === undefined ? true : params.show_predicted_accounts}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerExportClientBalanceSheetGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/export-client-balance-sheet', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerExportClientBalanceSheetGetResponseBody>(api, 'get', 'partner/export-client-balance-sheet', data, signal),
    })
}

// GET partner/find-by-business-id
export const usePartner__findByBusinessId = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerFindByBusinessIdGetResponseBody>(api: BackendAPIBlueprint, params: {partner_business_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerFindByBusinessIdGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {partner_business_id: params.partner_business_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerFindByBusinessIdGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/find-by-business-id', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerFindByBusinessIdGetResponseBody>(api, 'get', 'partner/find-by-business-id', data, signal),
    })
}

// GET partner/find-by-host-url
export const usePartner__findByHostUrl = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerFindByHostUrlGetResponseBody>(api: BackendAPIBlueprint, params: {hostname: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerFindByHostUrlGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {hostname: params.hostname}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerFindByHostUrlGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/find-by-host-url', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerFindByHostUrlGetResponseBody>(api, 'get', 'partner/find-by-host-url', data, signal),
    })
}

// GET partner/get-all-vat-declaration-snapshots
export const usePartner__getAllVatDeclarationSnapshots = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetAllVatDeclarationSnapshotsGetResponseBody>(api: BackendAPIBlueprint, params: {client_business_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetAllVatDeclarationSnapshotsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {client_business_id: params.client_business_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetAllVatDeclarationSnapshotsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/get-all-vat-declaration-snapshots', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetAllVatDeclarationSnapshotsGetResponseBody>(api, 'get', 'partner/get-all-vat-declaration-snapshots', data, signal),
    })
}

// GET partner/get-automation-rules
export const usePartner__getAutomationRules = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetAutomationRulesGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetAutomationRulesGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetAutomationRulesGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/get-automation-rules', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetAutomationRulesGetResponseBody>(api, 'get', 'partner/get-automation-rules', data, signal),
    })
}

// POST partner/get-bank-account-balance-at-date
export const usePartner__getBankAccountBalanceAtDateMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBankAccountBalanceAtDatePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBankAccountBalanceAtDatePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBankAccountBalanceAtDatePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBankAccountBalanceAtDatePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBankAccountBalanceAtDatePostResponseBody>(api, 'post', 'partner/get-bank-account-balance-at-date', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET partner/get-bks-entrepreneur-businesses
export const usePartner__getBksEntrepreneurBusinesses = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBksEntrepreneurBusinessesGetResponseBody>(api: BackendAPIBlueprint, params: {connection_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBksEntrepreneurBusinessesGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {connection_id: params.connection_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBksEntrepreneurBusinessesGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/get-bks-entrepreneur-businesses', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBksEntrepreneurBusinessesGetResponseBody>(api, 'get', 'partner/get-bks-entrepreneur-businesses', data, signal),
    })
}

// GET partner/get-bks-import-jobs
export const usePartner__getBksImportJobs = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBksImportJobsGetResponseBody>(api: BackendAPIBlueprint, params: {business_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBksImportJobsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {business_id: params.business_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBksImportJobsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/get-bks-import-jobs', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBksImportJobsGetResponseBody>(api, 'get', 'partner/get-bks-import-jobs', data, signal),
    })
}

// GET partner/get-bks-import-status
export const usePartner__getBksImportStatus = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBksImportStatusGetResponseBody>(api: BackendAPIBlueprint, params: {import_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBksImportStatusGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {import_id: params.import_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBksImportStatusGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/get-bks-import-status', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBksImportStatusGetResponseBody>(api, 'get', 'partner/get-bks-import-status', data, signal),
    })
}

// GET partner/get-bks-journals
export const usePartner__getBksJournals = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBksJournalsGetResponseBody>(api: BackendAPIBlueprint, params: {external_business_id: string, connection_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBksJournalsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {external_business_id: params.external_business_id, connection_id: params.connection_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBksJournalsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/get-bks-journals', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBksJournalsGetResponseBody>(api, 'get', 'partner/get-bks-journals', data, signal),
    })
}

// POST partner/get-blacklist-rule-preview
export const usePartner__getBlacklistRulePreviewMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBlacklistRulePreviewPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBlacklistRulePreviewPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBlacklistRulePreviewPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBlacklistRulePreviewPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBlacklistRulePreviewPostResponseBody>(api, 'post', 'partner/get-blacklist-rule-preview', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET partner/get-business-access-list
export const usePartner__getBusinessAccessList = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBusinessAccessListGetResponseBody>(api: BackendAPIBlueprint, params: {business_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBusinessAccessListGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {business_id: params.business_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBusinessAccessListGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/get-business-access-list', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBusinessAccessListGetResponseBody>(api, 'get', 'partner/get-business-access-list', data, signal),
    })
}

// GET partner/get-business-reconciliation-overviews
export const usePartner__getBusinessReconciliationOverviews = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBusinessReconciliationOverviewsGetResponseBody>(api: BackendAPIBlueprint, params: {date_since: string, client_business_id?: null | string, date_until?: null | string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBusinessReconciliationOverviewsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {date_since: params.date_since, client_business_id: params.client_business_id, date_until: params.date_until}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBusinessReconciliationOverviewsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/get-business-reconciliation-overviews', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetBusinessReconciliationOverviewsGetResponseBody>(api, 'get', 'partner/get-business-reconciliation-overviews', data, signal),
    })
}

// GET partner/get-client-activity
export const usePartner__getClientActivity = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientActivityGetResponseBody>(api: BackendAPIBlueprint, params: {start_date: string, end_date: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientActivityGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {start_date: params.start_date, end_date: params.end_date}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientActivityGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/get-client-activity', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientActivityGetResponseBody>(api, 'get', 'partner/get-client-activity', data, signal),
    })
}

// GET partner/get-client-balance-sheet-per-period
export const usePartner__getClientBalanceSheetPerPeriod = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientBalanceSheetPerPeriodGetResponseBody>(api: BackendAPIBlueprint, params: {start_date: string, end_date: string, client_business_id: string, currency?: Enums.CurrencyEnum, show_predicted_accounts?: boolean, include_empty_accounts?: boolean}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientBalanceSheetPerPeriodGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {start_date: params.start_date, end_date: params.end_date, client_business_id: params.client_business_id, currency: params.currency, show_predicted_accounts: params.show_predicted_accounts === undefined ? true : params.show_predicted_accounts, include_empty_accounts: params.include_empty_accounts === undefined ? true : params.include_empty_accounts}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientBalanceSheetPerPeriodGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/get-client-balance-sheet-per-period', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientBalanceSheetPerPeriodGetResponseBody>(api, 'get', 'partner/get-client-balance-sheet-per-period', data, signal),
    })
}

// GET partner/get-client-bank-accounts
export const usePartner__getClientBankAccounts = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientBankAccountsGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientBankAccountsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientBankAccountsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/get-client-bank-accounts', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientBankAccountsGetResponseBody>(api, 'get', 'partner/get-client-bank-accounts', data, signal),
    })
}

// GET partner/get-client-insights
export const usePartner__getClientInsights = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientInsightsGetResponseBody>(api: BackendAPIBlueprint, params: {business_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientInsightsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {business_id: params.business_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientInsightsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/get-client-insights', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientInsightsGetResponseBody>(api, 'get', 'partner/get-client-insights', data, signal),
    })
}

// GET partner/get-client-manual-bookings
export const usePartner__getClientManualBookings = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientManualBookingsGetResponseBody>(api: BackendAPIBlueprint, params: {client_business_id: string, start_date?: null | string, end_date?: null | string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientManualBookingsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {client_business_id: params.client_business_id, start_date: params.start_date, end_date: params.end_date}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientManualBookingsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/get-client-manual-bookings', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientManualBookingsGetResponseBody>(api, 'get', 'partner/get-client-manual-bookings', data, signal),
    })
}

// GET partner/get-client-profit-and-loss-pdf
export const usePartner__getClientProfitAndLossPdf = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientProfitAndLossPdfGetResponseBody>(api: BackendAPIBlueprint, params: {start_date: string, end_date: string, client_business_id: string, currency?: Enums.CurrencyEnum | null, expanded?: boolean, show_predicted_accounts?: boolean}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientProfitAndLossPdfGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {start_date: params.start_date, end_date: params.end_date, client_business_id: params.client_business_id, currency: params.currency, expanded: params.expanded === undefined ? false : params.expanded, show_predicted_accounts: params.show_predicted_accounts === undefined ? true : params.show_predicted_accounts}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientProfitAndLossPdfGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/get-client-profit-and-loss-pdf', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientProfitAndLossPdfGetResponseBody>(api, 'get', 'partner/get-client-profit-and-loss-pdf', data, signal),
    })
}

// GET partner/get-client-profit-and-loss-per-period
export const usePartner__getClientProfitAndLossPerPeriod = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientProfitAndLossPerPeriodGetResponseBody>(api: BackendAPIBlueprint, params: {start_date: string, end_date: string, client_business_id: string, currency?: Enums.CurrencyEnum, show_predicted_accounts?: boolean, include_empty_accounts?: boolean}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientProfitAndLossPerPeriodGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {start_date: params.start_date, end_date: params.end_date, client_business_id: params.client_business_id, currency: params.currency, show_predicted_accounts: params.show_predicted_accounts === undefined ? true : params.show_predicted_accounts, include_empty_accounts: params.include_empty_accounts === undefined ? true : params.include_empty_accounts}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientProfitAndLossPerPeriodGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/get-client-profit-and-loss-per-period', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientProfitAndLossPerPeriodGetResponseBody>(api, 'get', 'partner/get-client-profit-and-loss-per-period', data, signal),
    })
}

// GET partner/get-client-reports
export const usePartner__getClientReports = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientReportsGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientReportsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientReportsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/get-client-reports', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientReportsGetResponseBody>(api, 'get', 'partner/get-client-reports', data, signal),
    })
}

// GET partner/get-client-subledgers
export const usePartner__getClientSubledgers = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientSubledgersGetResponseBody>(api: BackendAPIBlueprint, params: {business_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientSubledgersGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {business_id: params.business_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientSubledgersGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/get-client-subledgers', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientSubledgersGetResponseBody>(api, 'get', 'partner/get-client-subledgers', data, signal),
    })
}

// GET partner/get-client-trial-balance
export const usePartner__getClientTrialBalance = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientTrialBalanceGetResponseBody>(api: BackendAPIBlueprint, params: {start_date: string, end_date: string, client_business_id: string, currency?: Enums.CurrencyEnum, show_predicted_accounts?: boolean}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientTrialBalanceGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {start_date: params.start_date, end_date: params.end_date, client_business_id: params.client_business_id, currency: params.currency, show_predicted_accounts: params.show_predicted_accounts === undefined ? true : params.show_predicted_accounts}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientTrialBalanceGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/get-client-trial-balance', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientTrialBalanceGetResponseBody>(api, 'get', 'partner/get-client-trial-balance', data, signal),
    })
}

// GET partner/get-client-trial-balance-report
export const usePartner__getClientTrialBalanceReport = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientTrialBalanceReportGetResponseBody>(api: BackendAPIBlueprint, params: {start_date: string, end_date: string, client_business_id: string, currency?: Enums.CurrencyEnum, comparison_period?: null | string, show_predicted_accounts?: boolean, include_empty_accounts?: boolean}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientTrialBalanceReportGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {start_date: params.start_date, end_date: params.end_date, client_business_id: params.client_business_id, currency: params.currency, comparison_period: params.comparison_period, show_predicted_accounts: params.show_predicted_accounts === undefined ? true : params.show_predicted_accounts, include_empty_accounts: params.include_empty_accounts === undefined ? true : params.include_empty_accounts}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientTrialBalanceReportGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/get-client-trial-balance-report', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientTrialBalanceReportGetResponseBody>(api, 'get', 'partner/get-client-trial-balance-report', data, signal),
    })
}

// GET partner/get-client-vat-declaration-statuses
export const usePartner__getClientVatDeclarationStatuses = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientVatDeclarationStatusesGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientVatDeclarationStatusesGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientVatDeclarationStatusesGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/get-client-vat-declaration-statuses', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetClientVatDeclarationStatusesGetResponseBody>(api, 'get', 'partner/get-client-vat-declaration-statuses', data, signal),
    })
}

// GET partner/get-fixed-asset-details
export const usePartner__getFixedAssetDetails = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetFixedAssetDetailsGetResponseBody>(api: BackendAPIBlueprint, params: {client_business_id: string, fixed_asset_id: string, as_of?: null | string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetFixedAssetDetailsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {client_business_id: params.client_business_id, fixed_asset_id: params.fixed_asset_id, as_of: params.as_of}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetFixedAssetDetailsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/get-fixed-asset-details', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetFixedAssetDetailsGetResponseBody>(api, 'get', 'partner/get-fixed-asset-details', data, signal),
    })
}

// GET partner/get-fixed-assets
export const usePartner__getFixedAssets = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetFixedAssetsGetResponseBody>(api: BackendAPIBlueprint, params: {client_business_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetFixedAssetsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {client_business_id: params.client_business_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetFixedAssetsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/get-fixed-assets', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetFixedAssetsGetResponseBody>(api, 'get', 'partner/get-fixed-assets', data, signal),
    })
}

// GET partner/get-vat-declaration-snapshot
export const usePartner__getVatDeclarationSnapshot = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetVatDeclarationSnapshotGetResponseBody>(api: BackendAPIBlueprint, params: {client_business_id: string, snapshot_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetVatDeclarationSnapshotGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {client_business_id: params.client_business_id, snapshot_id: params.snapshot_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetVatDeclarationSnapshotGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/get-vat-declaration-snapshot', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGetVatDeclarationSnapshotGetResponseBody>(api, 'get', 'partner/get-vat-declaration-snapshot', data, signal),
    })
}

// POST partner/grant-entrepreneur-access
export const usePartner__grantEntrepreneurAccessMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGrantEntrepreneurAccessPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGrantEntrepreneurAccessPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGrantEntrepreneurAccessPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGrantEntrepreneurAccessPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerGrantEntrepreneurAccessPostResponseBody>(api, 'post', 'partner/grant-entrepreneur-access', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/initiate-bks-document-import
export const usePartner__initiateBksDocumentImportMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerInitiateBksDocumentImportPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerInitiateBksDocumentImportPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'partner/initiate-bks-document-import', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/invite-entrepreneur
export const usePartner__inviteEntrepreneurMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerInviteEntrepreneurPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerInviteEntrepreneurPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerInviteEntrepreneurPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerInviteEntrepreneurPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerInviteEntrepreneurPostResponseBody>(api, 'post', 'partner/invite-entrepreneur', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/invite-teammate
export const usePartner__inviteTeammateMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerInviteTeammatePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerInviteTeammatePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerInviteTeammatePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerInviteTeammatePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerInviteTeammatePostResponseBody>(api, 'post', 'partner/invite-teammate', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/link-fixed-asset-to-document
export const usePartner__linkFixedAssetToDocumentMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerLinkFixedAssetToDocumentPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerLinkFixedAssetToDocumentPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerLinkFixedAssetToDocumentPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerLinkFixedAssetToDocumentPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerLinkFixedAssetToDocumentPostResponseBody>(api, 'post', 'partner/link-fixed-asset-to-document', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET partner/linkable-entrepreneurs
export const usePartner__linkableEntrepreneurs = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerLinkableEntrepreneursGetResponseBody>(api: BackendAPIBlueprint, params: {business_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerLinkableEntrepreneursGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {business_id: params.business_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerLinkableEntrepreneursGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/linkable-entrepreneurs', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerLinkableEntrepreneursGetResponseBody>(api, 'get', 'partner/linkable-entrepreneurs', data, signal),
    })
}

// GET partner/list-archived-documents
export const usePartner__listArchivedDocuments = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerListArchivedDocumentsGetResponseBody>(api: BackendAPIBlueprint, params: {date_from?: null | string, date_to?: null | string, orderby?: Enums.ArchivedDocumentsOrderByEnum, order?: Enums.OrderDirectionEnum, business_ids?: null | string, file_name?: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerListArchivedDocumentsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {date_from: params.date_from, date_to: params.date_to, orderby: params.orderby, order: params.order, business_ids: params.business_ids, file_name: params.file_name === undefined ? "" : params.file_name}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerListArchivedDocumentsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/list-archived-documents', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerListArchivedDocumentsGetResponseBody>(api, 'get', 'partner/list-archived-documents', data, signal),
    })
}

// GET partner/list-client-bills
export const usePartner__listClientBills = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerListClientBillsGetResponseBody>(api: BackendAPIBlueprint, params: {date_from?: null | string, date_to?: null | string, date_type?: Enums.DateFilterType, business_ids?: null | string, relations?: null | string, tags?: null | string, tags_mode?: Enums.FilterTags, direction?: Enums.DocumentDirection | null, document_categories?: null | string, orderby?: string, order?: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerListClientBillsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {date_from: params.date_from, date_to: params.date_to, date_type: params.date_type, business_ids: params.business_ids, relations: params.relations, tags: params.tags, tags_mode: params.tags_mode, direction: params.direction, document_categories: params.document_categories, orderby: params.orderby === undefined ? "relation_name" : params.orderby, order: params.order === undefined ? "asc" : params.order}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerListClientBillsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/list-client-bills', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerListClientBillsGetResponseBody>(api, 'get', 'partner/list-client-bills', data, signal),
    })
}

// GET partner/list-credit-card-statements
export const usePartner__listCreditCardStatements = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerListCreditCardStatementsGetResponseBody>(api: BackendAPIBlueprint, params: {date_from?: null | string, date_to?: null | string, business_ids?: null | string, orderby?: string, order?: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerListCreditCardStatementsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {date_from: params.date_from, date_to: params.date_to, business_ids: params.business_ids, orderby: params.orderby === undefined ? "created_at" : params.orderby, order: params.order === undefined ? "desc" : params.order}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerListCreditCardStatementsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/list-credit-card-statements', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerListCreditCardStatementsGetResponseBody>(api, 'get', 'partner/list-credit-card-statements', data, signal),
    })
}

// GET partner/list-documents-to-check
export const usePartner__listDocumentsToCheck = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerListDocumentsToCheckGetResponseBody>(api: BackendAPIBlueprint, params: {date_from?: null | string, date_to?: null | string, date_type?: Enums.DateFilterType, business_ids?: null | string, reasons?: null | string, todo_types?: null | string, orderby?: Enums.DocumentsToCheckOrderByEnum, order?: Enums.OrderDirectionEnum}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerListDocumentsToCheckGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {date_from: params.date_from, date_to: params.date_to, date_type: params.date_type, business_ids: params.business_ids, reasons: params.reasons, todo_types: params.todo_types, orderby: params.orderby, order: params.order}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerListDocumentsToCheckGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/list-documents-to-check', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerListDocumentsToCheckGetResponseBody>(api, 'get', 'partner/list-documents-to-check', data, signal),
    })
}

// POST partner/make-manual-booking
export const usePartner__makeManualBookingMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerMakeManualBookingPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerMakeManualBookingPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerMakeManualBookingPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerMakeManualBookingPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerMakeManualBookingPostResponseBody>(api, 'post', 'partner/make-manual-booking', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET partner/managed-businesses/bank-accounts
export const usePartner__managedBusinesses__bankAccounts = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerManagedBusinessesBankAccountsGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerManagedBusinessesBankAccountsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerManagedBusinessesBankAccountsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/managed-businesses/bank-accounts', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerManagedBusinessesBankAccountsGetResponseBody>(api, 'get', 'partner/managed-businesses/bank-accounts', data, signal),
    })
}

// GET partner/my-clients
export const usePartner__myClients = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerMyClientsGetResponseBody>(api: BackendAPIBlueprint, params: {year?: null | number, quarter?: null | number}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerMyClientsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {year: params.year, quarter: params.quarter}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerMyClientsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/my-clients', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerMyClientsGetResponseBody>(api, 'get', 'partner/my-clients', data, signal),
    })
}

// GET partner/my-clients/list
export const usePartner__myClients__list = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerMyClientsListGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerMyClientsListGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerMyClientsListGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/my-clients/list', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerMyClientsListGetResponseBody>(api, 'get', 'partner/my-clients/list', data, signal),
    })
}

// GET partner/payroll/administration-options
export const usePartner__payroll__administrationOptions = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollAdministrationOptionsGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollAdministrationOptionsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollAdministrationOptionsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/payroll/administration-options', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollAdministrationOptionsGetResponseBody>(api, 'get', 'partner/payroll/administration-options', data, signal),
    })
}

// POST partner/payroll/administrations/assign-mapping
export const usePartner__payroll__administrations__assignMappingMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollAdministrationsAssignMappingPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollAdministrationsAssignMappingPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollAdministrationsAssignMappingPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollAdministrationsAssignMappingPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollAdministrationsAssignMappingPostResponseBody>(api, 'post', 'partner/payroll/administrations/assign-mapping', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET partner/payroll/administrations/mapping-coverage
export const usePartner__payroll__administrations__mappingCoverage = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollAdministrationsMappingCoverageGetResponseBody>(api: BackendAPIBlueprint, params: {administration_id: string, period_start?: null | string, period_end?: null | string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollAdministrationsMappingCoverageGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {administration_id: params.administration_id, period_start: params.period_start, period_end: params.period_end}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollAdministrationsMappingCoverageGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/payroll/administrations/mapping-coverage', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollAdministrationsMappingCoverageGetResponseBody>(api, 'get', 'partner/payroll/administrations/mapping-coverage', data, signal),
    })
}

// POST partner/payroll/connect-session
export const usePartner__payroll__connectSessionMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollConnectSessionPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollConnectSessionPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollConnectSessionPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollConnectSessionPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollConnectSessionPostResponseBody>(api, 'post', 'partner/payroll/connect-session', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/payroll/connection/complete
export const usePartner__payroll__connection__completeMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollConnectionCompletePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollConnectionCompletePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollConnectionCompletePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollConnectionCompletePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollConnectionCompletePostResponseBody>(api, 'post', 'partner/payroll/connection/complete', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/payroll/connection/reconnect-complete
export const usePartner__payroll__connection__reconnectCompleteMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollConnectionReconnectCompletePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollConnectionReconnectCompletePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollConnectionReconnectCompletePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollConnectionReconnectCompletePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollConnectionReconnectCompletePostResponseBody>(api, 'post', 'partner/payroll/connection/reconnect-complete', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/payroll/create-payroll-gl-mapping
export const usePartner__payroll__createPayrollGlMappingMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollCreatePayrollGlMappingPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollCreatePayrollGlMappingPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollCreatePayrollGlMappingPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollCreatePayrollGlMappingPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollCreatePayrollGlMappingPostResponseBody>(api, 'post', 'partner/payroll/create-payroll-gl-mapping', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET partner/payroll/get-payroll-administration
export const usePartner__payroll__getPayrollAdministration = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGetPayrollAdministrationGetResponseBody>(api: BackendAPIBlueprint, params: {business_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGetPayrollAdministrationGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {business_id: params.business_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGetPayrollAdministrationGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/payroll/get-payroll-administration', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGetPayrollAdministrationGetResponseBody>(api, 'get', 'partner/payroll/get-payroll-administration', data, signal),
    })
}

// GET partner/payroll/get-payroll-connection
export const usePartner__payroll__getPayrollConnection = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGetPayrollConnectionGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGetPayrollConnectionGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGetPayrollConnectionGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/payroll/get-payroll-connection', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGetPayrollConnectionGetResponseBody>(api, 'get', 'partner/payroll/get-payroll-connection', data, signal),
    })
}

// GET partner/payroll/get-payroll-gl-mapping
export const usePartner__payroll__getPayrollGlMapping = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGetPayrollGlMappingGetResponseBody>(api: BackendAPIBlueprint, params: {mapping_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGetPayrollGlMappingGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {mapping_id: params.mapping_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGetPayrollGlMappingGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/payroll/get-payroll-gl-mapping', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGetPayrollGlMappingGetResponseBody>(api, 'get', 'partner/payroll/get-payroll-gl-mapping', data, signal),
    })
}

// POST partner/payroll/gl-mapping-rules
export const usePartner__payroll__glMappingRulesMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingRulesPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingRulesPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingRulesPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingRulesPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingRulesPostResponseBody>(api, 'post', 'partner/payroll/gl-mapping-rules', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/payroll/gl-mapping-rules/remove
export const usePartner__payroll__glMappingRules__removeMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingRulesRemovePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingRulesRemovePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingRulesRemovePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingRulesRemovePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingRulesRemovePostResponseBody>(api, 'post', 'partner/payroll/gl-mapping-rules/remove', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/payroll/gl-mappings/delete
export const usePartner__payroll__glMappings__deleteMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingsDeletePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingsDeletePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'partner/payroll/gl-mappings/delete', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET partner/payroll/gl-mappings/list
export const usePartner__payroll__glMappings__list = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingsListGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingsListGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingsListGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/payroll/gl-mappings/list', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingsListGetResponseBody>(api, 'get', 'partner/payroll/gl-mappings/list', data, signal),
    })
}

// POST partner/payroll/gl-mappings/rename
export const usePartner__payroll__glMappings__renameMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingsRenamePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingsRenamePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingsRenamePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingsRenamePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollGlMappingsRenamePostResponseBody>(api, 'post', 'partner/payroll/gl-mappings/rename', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/payroll/imports
export const usePartner__payroll__importsMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollImportsPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollImportsPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollImportsPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollImportsPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollImportsPostResponseBody>(api, 'post', 'partner/payroll/imports', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET partner/payroll/imports/history
export const usePartner__payroll__imports__history = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollImportsHistoryGetResponseBody>(api: BackendAPIBlueprint, params: {administration_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollImportsHistoryGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {administration_id: params.administration_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollImportsHistoryGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/payroll/imports/history', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollImportsHistoryGetResponseBody>(api, 'get', 'partner/payroll/imports/history', data, signal),
    })
}

// GET partner/payroll/imports/unmapped-gl-accounts
export const usePartner__payroll__imports__unmappedGlAccounts = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollImportsUnmappedGlAccountsGetResponseBody>(api: BackendAPIBlueprint, params: {administration_id: string, import_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollImportsUnmappedGlAccountsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {administration_id: params.administration_id, import_id: params.import_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollImportsUnmappedGlAccountsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/payroll/imports/unmapped-gl-accounts', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollImportsUnmappedGlAccountsGetResponseBody>(api, 'get', 'partner/payroll/imports/unmapped-gl-accounts', data, signal),
    })
}

// POST partner/payroll/link-payroll-administration
export const usePartner__payroll__linkPayrollAdministrationMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollLinkPayrollAdministrationPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollLinkPayrollAdministrationPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollLinkPayrollAdministrationPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollLinkPayrollAdministrationPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollLinkPayrollAdministrationPostResponseBody>(api, 'post', 'partner/payroll/link-payroll-administration', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET partner/payroll/list-available-providers
export const usePartner__payroll__listAvailableProviders = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollListAvailableProvidersGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollListAvailableProvidersGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollListAvailableProvidersGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/payroll/list-available-providers', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollListAvailableProvidersGetResponseBody>(api, 'get', 'partner/payroll/list-available-providers', data, signal),
    })
}

// POST partner/payroll/reconnect-session
export const usePartner__payroll__reconnectSessionMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollReconnectSessionPostResponseBody, any>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollReconnectSessionPostResponseBody, ApiError, any>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollReconnectSessionPostResponseBody>(api, 'post', 'partner/payroll/reconnect-session', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/payroll/test-connection
export const usePartner__payroll__testConnectionMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollTestConnectionPostResponseBody, any>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollTestConnectionPostResponseBody, ApiError, any>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerPayrollTestConnectionPostResponseBody>(api, 'post', 'partner/payroll/test-connection', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/process-credit-card-settlement
export const usePartner__processCreditCardSettlementMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerProcessCreditCardSettlementPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerProcessCreditCardSettlementPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerProcessCreditCardSettlementPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerProcessCreditCardSettlementPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerProcessCreditCardSettlementPostResponseBody>(api, 'post', 'partner/process-credit-card-settlement', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/recategorize-document
export const usePartner__recategorizeDocumentMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRecategorizeDocumentPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRecategorizeDocumentPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRecategorizeDocumentPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRecategorizeDocumentPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRecategorizeDocumentPostResponseBody>(api, 'post', 'partner/recategorize-document', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/refine-vat-ignore-prompt
export const usePartner__refineVatIgnorePromptMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRefineVatIgnorePromptPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRefineVatIgnorePromptPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRefineVatIgnorePromptPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRefineVatIgnorePromptPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRefineVatIgnorePromptPostResponseBody>(api, 'post', 'partner/refine-vat-ignore-prompt', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/refresh-client-trial-balance-cache
export const usePartner__refreshClientTrialBalanceCacheMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRefreshClientTrialBalanceCachePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRefreshClientTrialBalanceCachePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRefreshClientTrialBalanceCachePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRefreshClientTrialBalanceCachePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRefreshClientTrialBalanceCachePostResponseBody>(api, 'post', 'partner/refresh-client-trial-balance-cache', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/rename-client-subledger
export const usePartner__renameClientSubledgerMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRenameClientSubledgerPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRenameClientSubledgerPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRenameClientSubledgerPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRenameClientSubledgerPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRenameClientSubledgerPostResponseBody>(api, 'post', 'partner/rename-client-subledger', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/request-vat-declaration-approval
export const usePartner__requestVatDeclarationApprovalMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRequestVatDeclarationApprovalPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRequestVatDeclarationApprovalPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRequestVatDeclarationApprovalPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRequestVatDeclarationApprovalPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerRequestVatDeclarationApprovalPostResponseBody>(api, 'post', 'partner/request-vat-declaration-approval', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/save-vat-declaration-snapshot
export const usePartner__saveVatDeclarationSnapshotMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerSaveVatDeclarationSnapshotPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerSaveVatDeclarationSnapshotPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerSaveVatDeclarationSnapshotPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerSaveVatDeclarationSnapshotPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerSaveVatDeclarationSnapshotPostResponseBody>(api, 'post', 'partner/save-vat-declaration-snapshot', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET partner/teammates
export const usePartner__teammates = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerTeammatesGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerTeammatesGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerTeammatesGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/teammates', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerTeammatesGetResponseBody>(api, 'get', 'partner/teammates', data, signal),
    })
}

// GET partner/transactions
export const usePartner__transactions = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerTransactionsGetResponseBody>(api: BackendAPIBlueprint, params: {client_business_id?: null | string, bank_account_id?: null | string, date_from?: null | string, date_to?: null | string, flow?: Enums.TransactionFlow | null, amount_cents?: null | number, amount_comparator?: Enums.TransactionAmountComparator, relation_iban?: null | string, general_ledger_account_id?: null | string, match_status?: Enums.TransactionMatchStatus | null, search?: null | string, sort?: Enums.TransactionSortField, direction?: Enums.SortDirection, cursor?: null | string, limit?: number}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerTransactionsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {client_business_id: params.client_business_id, bank_account_id: params.bank_account_id, date_from: params.date_from, date_to: params.date_to, flow: params.flow, amount_cents: params.amount_cents, amount_comparator: params.amount_comparator, relation_iban: params.relation_iban, general_ledger_account_id: params.general_ledger_account_id, match_status: params.match_status, search: params.search, sort: params.sort, direction: params.direction, cursor: params.cursor, limit: params.limit === undefined ? 100 : params.limit}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerTransactionsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'partner/transactions', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerTransactionsGetResponseBody>(api, 'get', 'partner/transactions', data, signal),
    })
}

// POST partner/transactions/categorization-change
export const usePartner__transactions__categorizationChangeMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerTransactionsCategorizationChangePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerTransactionsCategorizationChangePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerTransactionsCategorizationChangePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerTransactionsCategorizationChangePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerTransactionsCategorizationChangePostResponseBody>(api, 'post', 'partner/transactions/categorization-change', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/unlink-fixed-asset-from-document
export const usePartner__unlinkFixedAssetFromDocumentMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerUnlinkFixedAssetFromDocumentPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerUnlinkFixedAssetFromDocumentPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerUnlinkFixedAssetFromDocumentPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerUnlinkFixedAssetFromDocumentPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerUnlinkFixedAssetFromDocumentPostResponseBody>(api, 'post', 'partner/unlink-fixed-asset-from-document', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/unmatched-transactions/create-backlist-rule
export const usePartner__unmatchedTransactions__createBacklistRuleMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerUnmatchedTransactionsCreateBacklistRulePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerUnmatchedTransactionsCreateBacklistRulePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerUnmatchedTransactionsCreateBacklistRulePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerUnmatchedTransactionsCreateBacklistRulePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerUnmatchedTransactionsCreateBacklistRulePostResponseBody>(api, 'post', 'partner/unmatched-transactions/create-backlist-rule', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST partner/withdraw-vat-declaration-approval-request
export const usePartner__withdrawVatDeclarationApprovalRequestMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerWithdrawVatDeclarationApprovalRequestPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerWithdrawVatDeclarationApprovalRequestPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerWithdrawVatDeclarationApprovalRequestPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerWithdrawVatDeclarationApprovalRequestPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PartnerWithdrawVatDeclarationApprovalRequestPostResponseBody>(api, 'post', 'partner/withdraw-vat-declaration-approval-request', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST public/send-reset-password-email
export const usePublic__sendResetPasswordEmailMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1PublicSendResetPasswordEmailPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1PublicSendResetPasswordEmailPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1PublicSendResetPasswordEmailPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1PublicSendResetPasswordEmailPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1PublicSendResetPasswordEmailPostResponseBody>(api, 'post', 'public/send-reset-password-email', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET quinn/get-chat
export const useQuinn__getChat = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnGetChatGetResponseBody>(api: BackendAPIBlueprint, params: {chat_id?: null | string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnGetChatGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {chat_id: params.chat_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnGetChatGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'quinn/get-chat', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnGetChatGetResponseBody>(api, 'get', 'quinn/get-chat', data, signal),
    })
}

// GET quinn/get-run-status
export const useQuinn__getRunStatus = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnGetRunStatusGetResponseBody>(api: BackendAPIBlueprint, params: {run_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnGetRunStatusGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {run_id: params.run_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnGetRunStatusGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'quinn/get-run-status', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnGetRunStatusGetResponseBody>(api, 'get', 'quinn/get-run-status', data, signal),
    })
}

// GET quinn/list-sessions
export const useQuinn__listSessions = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnListSessionsGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnListSessionsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnListSessionsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'quinn/list-sessions', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnListSessionsGetResponseBody>(api, 'get', 'quinn/list-sessions', data, signal),
    })
}

// POST quinn/rate-answer
export const useQuinn__rateAnswerMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnRateAnswerPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnRateAnswerPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnRateAnswerPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnRateAnswerPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnRateAnswerPostResponseBody>(api, 'post', 'quinn/rate-answer', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST quinn/send-message
export const useQuinn__sendMessageMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnSendMessagePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnSendMessagePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnSendMessagePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnSendMessagePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnSendMessagePostResponseBody>(api, 'post', 'quinn/send-message', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST quinn/start-run
export const useQuinn__startRunMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnStartRunPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnStartRunPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnStartRunPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnStartRunPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1QuinnStartRunPostResponseBody>(api, 'post', 'quinn/start-run', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET reconciliation/get-match-details
export const useReconciliation__getMatchDetails = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationGetMatchDetailsGetResponseBody>(api: BackendAPIBlueprint, params: {match_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationGetMatchDetailsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {match_id: params.match_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationGetMatchDetailsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'reconciliation/get-match-details', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationGetMatchDetailsGetResponseBody>(api, 'get', 'reconciliation/get-match-details', data, signal),
    })
}

// GET reconciliation/get-match-details-by-document-id
export const useReconciliation__getMatchDetailsByDocumentId = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationGetMatchDetailsByDocumentIdGetResponseBody>(api: BackendAPIBlueprint, params: {document_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationGetMatchDetailsByDocumentIdGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {document_id: params.document_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationGetMatchDetailsByDocumentIdGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'reconciliation/get-match-details-by-document-id', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationGetMatchDetailsByDocumentIdGetResponseBody>(api, 'get', 'reconciliation/get-match-details-by-document-id', data, signal),
    })
}

// POST reconciliation/manually-add-parts-match
export const useReconciliation__manuallyAddPartsMatchMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationManuallyAddPartsMatchPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationManuallyAddPartsMatchPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationManuallyAddPartsMatchPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationManuallyAddPartsMatchPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationManuallyAddPartsMatchPostResponseBody>(api, 'post', 'reconciliation/manually-add-parts-match', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST reconciliation/manually-match
export const useReconciliation__manuallyMatchMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationManuallyMatchPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationManuallyMatchPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationManuallyMatchPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationManuallyMatchPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationManuallyMatchPostResponseBody>(api, 'post', 'reconciliation/manually-match', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST reconciliation/manually-unmatch
export const useReconciliation__manuallyUnmatchMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationManuallyUnmatchPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationManuallyUnmatchPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationManuallyUnmatchPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationManuallyUnmatchPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationManuallyUnmatchPostResponseBody>(api, 'post', 'reconciliation/manually-unmatch', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST reconciliation/mark-match-manually-completed
export const useReconciliation__markMatchManuallyCompletedMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationMarkMatchManuallyCompletedPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationMarkMatchManuallyCompletedPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationMarkMatchManuallyCompletedPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationMarkMatchManuallyCompletedPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1ReconciliationMarkMatchManuallyCompletedPostResponseBody>(api, 'post', 'reconciliation/mark-match-manually-completed', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST register-callback
export const useRegisterCallbackMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1RegisterCallbackPostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1RegisterCallbackPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1RegisterCallbackPostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1RegisterCallbackPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1RegisterCallbackPostResponseBody>(api, 'post', 'register-callback', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// GET ro-developer/get-all-documents
export const useRoDeveloper__getAllDocuments = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1RoDeveloperGetAllDocumentsGetResponseBody>(api: BackendAPIBlueprint, params: {document_id?: null | string, direction?: null | string, category?: null | string, status?: null | string, needs_review?: boolean | null, review_context_failed_check?: null | string, partner_business_id?: null | string, include_duplicates?: boolean, include_deleted?: boolean}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1RoDeveloperGetAllDocumentsGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {document_id: params.document_id, direction: params.direction, category: params.category, status: params.status, needs_review: params.needs_review, review_context_failed_check: params.review_context_failed_check, partner_business_id: params.partner_business_id, include_duplicates: params.include_duplicates === undefined ? false : params.include_duplicates, include_deleted: params.include_deleted === undefined ? false : params.include_deleted}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1RoDeveloperGetAllDocumentsGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'ro-developer/get-all-documents', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1RoDeveloperGetAllDocumentsGetResponseBody>(api, 'get', 'ro-developer/get-all-documents', data, signal),
    })
}

// GET ro-developer/get-document
export const useRoDeveloper__getDocument = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1RoDeveloperGetDocumentGetResponseBody>(api: BackendAPIBlueprint, params: {document_id: string}, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1RoDeveloperGetDocumentGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {document_id: params.document_id}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1RoDeveloperGetDocumentGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'ro-developer/get-document', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1RoDeveloperGetDocumentGetResponseBody>(api, 'get', 'ro-developer/get-document', data, signal),
    })
}

// GET ro-developer/get-partners
export const useRoDeveloper__getPartners = <TData = BackendAPITypes.BACKENDPreHandleSyncApiV1RoDeveloperGetPartnersGetResponseBody>(api: BackendAPIBlueprint, options: ApiQueryOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1RoDeveloperGetPartnersGetResponseBody, TData>) => {
    const {queryKey, ...rest} = options
    const data = {}
    return useQuery<BackendAPITypes.BACKENDPreHandleSyncApiV1RoDeveloperGetPartnersGetResponseBody, ApiError, TData>({
        ...rest,
        queryKey: [queryKey, 'ro-developer/get-partners', data],
        queryFn: ({signal}) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1RoDeveloperGetPartnersGetResponseBody>(api, 'get', 'ro-developer/get-partners', data, signal),
    })
}

// POST start-import-job
export const useStartImportJobMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, BackendAPITypes.BACKENDPreHandleSyncApiV1StartImportJobPostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1StartImportJobPostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'start-import-job', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST transactions/book-as-private
export const useTransactions__bookAsPrivateMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleSyncApiV1TransactionsBookAsPrivatePostResponseBody, BackendAPITypes.BACKENDPreHandleSyncApiV1TransactionsBookAsPrivatePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleSyncApiV1TransactionsBookAsPrivatePostResponseBody, ApiError, BackendAPITypes.BACKENDPreHandleSyncApiV1TransactionsBookAsPrivatePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleSyncApiV1TransactionsBookAsPrivatePostResponseBody>(api, 'post', 'transactions/book-as-private', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST webhook/sendgrid/events
export const useWebhook__sendgrid__eventsMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<BackendAPITypes.BACKENDPreHandleAsyncApiV1WebhookSendgridEventsPostResponseBody, any>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<BackendAPITypes.BACKENDPreHandleAsyncApiV1WebhookSendgridEventsPostResponseBody, ApiError, any>({
        ...rest,
        mutationFn: (data) => sendHookRequest<BackendAPITypes.BACKENDPreHandleAsyncApiV1WebhookSendgridEventsPostResponseBody>(api, 'post', 'webhook/sendgrid/events', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}

// POST webhook/sendgrid/inbound-parse
export const useWebhook__sendgrid__inboundParseMutation = (api: BackendAPIBlueprint, options?: ApiMutationOptions<any, BackendAPITypes.BACKENDPreHandleAsyncApiV1WebhookSendgridInboundParsePostRequestBody>) => {
    const client = useQueryClient()
    const {invalidates = [], ...rest} = options ?? {}
    return useMutation<any, ApiError, BackendAPITypes.BACKENDPreHandleAsyncApiV1WebhookSendgridInboundParsePostRequestBody>({
        ...rest,
        mutationFn: (data) => sendHookRequest<any>(api, 'post', 'webhook/sendgrid/inbound-parse', data),
        onSuccess: async (data, variables, context) => {
            await Promise.all(invalidates.map((key) => client.invalidateQueries({queryKey: [key]})))
            await rest.onSuccess?.(data, variables, context)
        },
    })
}
